/* eslint-disable */
/* prettier-ignore */
// This file was automatically generated and should not be edited.
import type { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
import type { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  Date: string;
  DateTime: string;
  JSON: any;
  NegativeFloat: number;
  NegativeInt: number;
  NonNegativeFloat: number;
  NonNegativeInt: number;
  NonPositiveFloat: number;
  NonPositiveInt: number;
  PositiveFloat: number;
  PositiveInt: number;
  Upload: File;
  Void: any;
};

export type AdjustedDriverHourLocation = {
  __typename: "AdjustedDriverHourLocation";
  driverHours: Maybe<HourlyDriverHours>;
  id: Scalars["NonNegativeInt"];
  title: Maybe<Scalars["String"]>;
};

export type AdjustedDriverHoursRun = {
  __typename: "AdjustedDriverHoursRun";
  createdAt: Maybe<Scalars["DateTime"]>;
  id: Scalars["NonNegativeInt"];
  name: Maybe<Scalars["String"]>;
  odhRunsId: Maybe<Scalars["NonNegativeInt"]>;
  operationalWeekStartDate: Maybe<Scalars["String"]>;
  source: Scalars["String"];
};

export type AdjustedOvf = {
  __typename: "AdjustedOvf";
  location_id: Scalars["Int"];
  ovf: Maybe<Scalars["Int"]>;
  ovf_local_datetime: Maybe<Scalars["Date"]>;
};

export type AzureSasToken = {
  __typename: "AzureSasToken";
  message: Maybe<Scalars["String"]>;
  success: Maybe<Scalars["Boolean"]>;
  token: Maybe<Scalars["String"]>;
};

export type Country = {
  __typename: "Country";
  countryCode: Scalars["String"];
};

export type CreateLocationTargetResponse = {
  __typename: "CreateLocationTargetResponse";
  id: Scalars["Int"];
};

export type DailyAdjustment = {
  __typename: "DailyAdjustment";
  day: Scalars["String"];
  hourlyAdjustments: Array<Scalars["Float"]>;
  locationId: Scalars["Int"];
  locationTitle: Scalars["String"];
  operationalDate: Scalars["String"];
};

export type DailyMissingLocation = {
  __typename: "DailyMissingLocation";
  date: Scalars["String"];
  forecasterId: Maybe<Scalars["NonNegativeInt"]>;
  locationId: Scalars["NonNegativeInt"];
  missingInDoppler: Maybe<Scalars["Boolean"]>;
};

export type DopplerQa = {
  __typename: "DopplerQA";
  dopplerRunDateTime: Scalars["String"];
  qaRunDateTime: Scalars["String"];
  weeklyQAByCountry: Array<WeeklyQaByCountry>;
};

export type DopplerRun = {
  __typename: "DopplerRun";
  dopplerRunDateTime: Scalars["String"];
  dopplerRunId: Scalars["NonNegativeInt"];
};

export type Eib = {
  __typename: "Eib";
  end_datetime: Scalars["DateTime"];
  header_key: Scalars["Int"];
  line_key: Scalars["Int"];
  quantity: Scalars["Float"];
  schedule_tag_value_id_type1: Maybe<Scalars["String"]>;
  schedule_tag_value_id_type2: Scalars["String"];
  scheduling_organization: Scalars["String"];
  start_datetime: Scalars["DateTime"];
  subgroup_organization: Scalars["String"];
};

export type EventAdjustment = {
  __typename: "EventAdjustment";
  adjustments: Maybe<Array<Maybe<DailyAdjustment>>>;
  id: Scalars["Int"];
  locationIds: Maybe<Array<Maybe<Scalars["NonNegativeInt"]>>>;
  locationIdsInTag: Maybe<Array<Maybe<Scalars["NonNegativeInt"]>>>;
  name: Scalars["String"];
  operationalWeekStartDate: Scalars["String"];
  orderSum: Maybe<Scalars["Float"]>;
  tag: Maybe<Scalars["String"]>;
};

export type EventAdjustmentAdjustmentsArgs = {
  locationId?: InputMaybe<Scalars["NonNegativeInt"]>;
};

export type EventAdjustmentTotal = {
  __typename: "EventAdjustmentTotal";
  tag: Scalars["String"];
  total: Scalars["Float"];
};

export type ForecastDriverHour = {
  __typename: "ForecastDriverHour";
  baselineOdh: Maybe<Scalars["Float"]>;
  batch: Maybe<Scalars["String"]>;
  clampedOdh: Maybe<Scalars["Float"]>;
  createdAt: Maybe<Scalars["DateTime"]>;
  forecastLocalTime: Scalars["DateTime"];
  forecastUtcTime: Scalars["DateTime"];
  hours: Maybe<Scalars["Int"]>;
  id: Scalars["Int"];
  locationId: Maybe<Scalars["Int"]>;
  mode: Maybe<Scalars["String"]>;
  orders: Maybe<Scalars["Int"]>;
  scaledOdh: Maybe<Scalars["Float"]>;
  updatedAt: Maybe<Scalars["DateTime"]>;
};

export type ForecastHoursInput = {
  endTime: Scalars["String"];
  limit?: InputMaybe<Scalars["Int"]>;
  locationIds?: InputMaybe<Array<Scalars["Int"]>>;
  offset?: InputMaybe<Scalars["Int"]>;
  ovfSource?: InputMaybe<OvfSource>;
  runId?: InputMaybe<Scalars["Int"]>;
  startTime: Scalars["String"];
  timeFormat?: InputMaybe<TimeFormat>;
};

export type ForecastNetworkDriverHour = {
  __typename: "ForecastNetworkDriverHour";
  baselineOdh: Maybe<Scalars["Float"]>;
  clampedOdh: Maybe<Scalars["Float"]>;
  createdAt: Maybe<Scalars["DateTime"]>;
  forecastUtcTime: Scalars["DateTime"];
  hours: Maybe<Scalars["Int"]>;
  mode: Maybe<Mode>;
  orders: Maybe<Scalars["Int"]>;
  scaledOdh: Maybe<Scalars["Float"]>;
  updatedAt: Maybe<Scalars["DateTime"]>;
};

export type Forecaster = {
  __typename: "Forecaster";
  id: Scalars["Int"];
};

export type GoSkedInput = {
  clusters?: InputMaybe<Array<Scalars["Int"]>>;
  countryCode: Scalars["String"];
  debugMode?: InputMaybe<Scalars["String"]>;
  firstRouterOrderThreshold: Scalars["Int"];
  icqaTph: Scalars["Int"];
  inboundTph: Scalars["Int"];
  kitchenOvfAssumption: Scalars["String"];
  kitchenRiskPph: Scalars["Int"];
  locationsToExclude?: InputMaybe<Array<Scalars["Int"]>>;
  locationsToInclude?: InputMaybe<Array<Scalars["Int"]>>;
  metroRegions?: InputMaybe<Array<Scalars["String"]>>;
  operationalWeekStartDate: Scalars["String"];
  ophAdjustment: Scalars["Int"];
  orderForecast: Scalars["Int"];
  ovfAssumption: Scalars["String"];
  packPphDecrease: Scalars["String"];
  packRiskPph: Scalars["Int"];
  roundingAdjustment: Scalars["String"];
  secondRouterOrderThreshold: Scalars["Int"];
  stateCodes?: InputMaybe<Array<Scalars["String"]>>;
  targetOphType: Scalars["String"];
};

export type HourlyDriverHours = {
  __typename: "HourlyDriverHours";
  dates: Array<Scalars["String"]>;
  hours: Array<MultiModalHourlyData>;
};

export type HourlyMissingLocation = {
  __typename: "HourlyMissingLocation";
  datetime: Scalars["String"];
  forecasterId: Maybe<Scalars["NonNegativeInt"]>;
  locationId: Scalars["NonNegativeInt"];
  missingInDoppler: Maybe<Scalars["Boolean"]>;
};

export type HourlyOvf = {
  __typename: "HourlyOVF";
  dates: Array<Scalars["String"]>;
  ovfs: Array<MultiModalHourlyData>;
};

export type InvalidShift = {
  __typename: "InvalidShift";
  date: Scalars["String"];
  delivery_method: Scalars["String"];
  driver_slots: Scalars["NonNegativeInt"];
  end_time: Scalars["String"];
  error: Scalars["String"];
  location: Scalars["String"];
  location_id: Scalars["NonNegativeInt"];
  position: Scalars["String"];
  start_time: Scalars["String"];
  time: Scalars["String"];
  weekday: Scalars["String"];
};

export type ItemForecast = {
  __typename: "ItemForecast";
  adjustedForecast: Maybe<Scalars["Float"]>;
  dsForecastStartedAt: Scalars["DateTime"];
  finalForecast: Maybe<Scalars["Float"]>;
  forecastedDate: Scalars["Date"];
  locationId: Scalars["Int"];
  modelForecast: Maybe<Scalars["Float"]>;
  o9ExtractDate: Scalars["Date"];
  o9LoadDate: Scalars["Date"];
  productId: Scalars["Int"];
  validFrom: Scalars["Date"];
  validTo: Maybe<Scalars["Date"]>;
};

export type ItemForecastInput = {
  endTime?: InputMaybe<Scalars["String"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  locationIds?: InputMaybe<Array<Scalars["Int"]>>;
  offset?: InputMaybe<Scalars["Int"]>;
  productIds?: InputMaybe<Array<Scalars["Int"]>>;
  startTime?: InputMaybe<Scalars["String"]>;
};

export type Job = {
  __typename: "Job";
  runs: Maybe<Array<Maybe<Run>>>;
};

export type JobStatus = {
  __typename: "JobStatus";
  endDate: Maybe<Scalars["DateTime"]>;
  startDate: Maybe<Scalars["DateTime"]>;
  status: Maybe<Scalars["String"]>;
};

export enum JobType {
  JobRun = "JOB_RUN",
  SubmitRun = "SUBMIT_RUN",
  WorkflowRun = "WORKFLOW_RUN",
}

export type Location = {
  __typename: "Location";
  dailyThreeWeekTrailingAverage: Maybe<Array<Scalars["Float"]>>;
  dopplerForecast: Maybe<Scalars["NonNegativeInt"]>;
  driverHours: Maybe<HourlyDriverHours>;
  eventAdjustmentTotals: Maybe<Array<Maybe<EventAdjustmentTotal>>>;
  forecasterId: Maybe<Scalars["Int"]>;
  id: Scalars["ID"];
  ovf: Maybe<HourlyOvf>;
  seasonalityAdjustments: Maybe<SeasonalityAdjustments>;
  target: Maybe<LocationTarget>;
  threeWeekOrderHistory: Maybe<Scalars["NonNegativeInt"]>;
  threeWeekTrailingAverage: Maybe<ThreeWeekTrailingAverages>;
  title: Scalars["String"];
};

export type LocationSeasonalityAdjustmentsArgs = {
  operationalWeekStartDate?: InputMaybe<Scalars["String"]>;
};

export type LocationConnection = {
  __typename: "LocationConnection";
  edges: Maybe<Array<Maybe<LocationEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
};

export type LocationEdge = {
  __typename: "LocationEdge";
  cursor: Scalars["String"];
  node: Maybe<Location>;
};

export type LocationTarget = {
  __typename: "LocationTarget";
  absenteeAdjustBike: Maybe<Scalars["Boolean"]>;
  absenteeAdjustCar: Maybe<Scalars["Boolean"]>;
  absenteeAdjustFoot: Maybe<Scalars["Boolean"]>;
  absenteeismCap: Scalars["Float"];
  absenteeismCutPremium: Scalars["Float"];
  absenteeismLookbackWindow: Scalars["Int"];
  absenteeismPercentile: Scalars["Float"];
  constrainFlag: Maybe<Scalars["String"]>;
  driverWaitTime: Maybe<Scalars["Float"]>;
  id: Scalars["ID"];
  locationId: Scalars["Int"];
  locationTargetId: Maybe<Scalars["ID"]>;
  maxODH: Maybe<Scalars["Float"]>;
  minODH: Maybe<Scalars["Float"]>;
  mindpBike: Maybe<Scalars["Int"]>;
  mindpCar: Maybe<Scalars["Int"]>;
  mindpFoot: Maybe<Scalars["Int"]>;
  openFromOverride: Maybe<Scalars["String"]>;
  openToOverride: Maybe<Scalars["String"]>;
  shiftIncrement: Maybe<Scalars["Int"]>;
  shiftPad: Maybe<Scalars["Int"]>;
  skipMui: Maybe<Scalars["Boolean"]>;
  taperPreset: Maybe<Scalars["String"]>;
  targetDate: Maybe<Scalars["Date"]>;
  targetODH: Maybe<Scalars["Float"]>;
  title: Scalars["String"];
  unscheduledCap: Scalars["Float"];
  unscheduledCutPremium: Scalars["Float"];
  unscheduledPenalty: Scalars["Float"];
  unscheduledPercentile: Scalars["Float"];
};

export type LocationTargetConnection = {
  __typename: "LocationTargetConnection";
  edges: Maybe<Array<Maybe<LocationTargetEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
};

export type LocationTargetCreateInput = {
  locationId: Scalars["Int"];
  targetDate: Scalars["Date"];
  targetODH: Scalars["Float"];
};

export type LocationTargetEdge = {
  __typename: "LocationTargetEdge";
  cursor: Scalars["String"];
  node: Maybe<LocationTarget>;
};

export type LocationTargetUpdateInput = {
  absenteeAdjustBike?: InputMaybe<Scalars["Boolean"]>;
  absenteeAdjustCar?: InputMaybe<Scalars["Boolean"]>;
  absenteeAdjustFoot?: InputMaybe<Scalars["Boolean"]>;
  absenteeismCap?: InputMaybe<Scalars["Float"]>;
  absenteeismCutPremium?: InputMaybe<Scalars["Float"]>;
  absenteeismLookbackWindow?: InputMaybe<Scalars["Int"]>;
  absenteeismPercentile?: InputMaybe<Scalars["Float"]>;
  constrainFlag?: InputMaybe<Scalars["String"]>;
  driverWaitTime?: InputMaybe<Scalars["Float"]>;
  id: Scalars["ID"];
  locationId?: InputMaybe<Scalars["Int"]>;
  maxODH?: InputMaybe<Scalars["Float"]>;
  minODH?: InputMaybe<Scalars["Float"]>;
  mindpBike?: InputMaybe<Scalars["Int"]>;
  mindpCar?: InputMaybe<Scalars["Int"]>;
  mindpFoot?: InputMaybe<Scalars["Int"]>;
  openFromOverride?: InputMaybe<Scalars["String"]>;
  openToOverride?: InputMaybe<Scalars["String"]>;
  shiftIncrement?: InputMaybe<Scalars["Int"]>;
  shiftPad?: InputMaybe<Scalars["Int"]>;
  skipMui?: InputMaybe<Scalars["Boolean"]>;
  taperPreset?: InputMaybe<Scalars["String"]>;
  targetDate?: InputMaybe<Scalars["Date"]>;
  targetODH?: InputMaybe<Scalars["Float"]>;
  unscheduledCap?: InputMaybe<Scalars["Float"]>;
  unscheduledCutPremium?: InputMaybe<Scalars["Float"]>;
  unscheduledPenalty?: InputMaybe<Scalars["Float"]>;
  unscheduledPercentile?: InputMaybe<Scalars["Float"]>;
};

export type LocationsByMetroRegion = {
  __typename: "LocationsByMetroRegion";
  locationIds: Array<Scalars["NonNegativeInt"]>;
  name: Scalars["String"];
};

export type MidweekReforecast = {
  __typename: "MidweekReforecast";
  actuals: Array<Maybe<Scalars["NonNegativeInt"]>>;
  dailyReforecastAdjustment: Array<Maybe<Scalars["Float"]>>;
  dopplerRunActive: Array<Maybe<Scalars["NonNegativeInt"]>>;
  dopplerRunPublished: Array<Maybe<Scalars["NonNegativeInt"]>>;
  dopplerVsDoppler: Array<Maybe<Scalars["Float"]>>;
  other: Array<Maybe<Scalars["Float"]>>;
  ovfPublished: Array<Maybe<Scalars["NonNegativeInt"]>>;
  ovfPublishedVsActualsOrProjection: Array<Maybe<Scalars["Float"]>>;
  ovfReforecast: Array<Maybe<Scalars["Float"]>>;
  ovfReforecastVsProjection: Array<Maybe<Scalars["Float"]>>;
  partners: Array<Maybe<Scalars["Float"]>>;
  planning: Array<Maybe<Scalars["Float"]>>;
  projection: Array<Maybe<Scalars["Float"]>>;
  promos: Array<Maybe<Scalars["Float"]>>;
  referrals: Array<Maybe<Scalars["Float"]>>;
  seasonalAdjustments: Array<Maybe<Scalars["Float"]>>;
  totalAdjustments: Array<Maybe<Scalars["Float"]>>;
};

export enum Mode {
  All = "ALL",
  Bike = "BIKE",
  Car = "CAR",
  Foot = "FOOT",
  Moped = "MOPED",
}

export type MostRecentAdjustedHoursUpload = {
  __typename: "MostRecentAdjustedHoursUpload";
  date: Maybe<Scalars["DateTime"]>;
};

export type MostRecentLaborMappingUpload = {
  __typename: "MostRecentLaborMappingUpload";
  date: Maybe<Scalars["DateTime"]>;
};

export type MostRecentOaLaborUpload = {
  __typename: "MostRecentOaLaborUpload";
  date: Maybe<Scalars["DateTime"]>;
};

export type MostRecentOdhTransformJob = {
  __typename: "MostRecentOdhTransformJob";
  batch: Maybe<Scalars["String"]>;
  date: Maybe<Scalars["DateTime"]>;
};

export type MostRecentOdhTransformRun = {
  __typename: "MostRecentOdhTransformRun";
  endDate: Maybe<Scalars["DateTime"]>;
  startDate: Maybe<Scalars["DateTime"]>;
  status: Maybe<Scalars["String"]>;
};

export type MultiModalHourlyData = {
  __typename: "MultiModalHourlyData";
  mode: Scalars["String"];
  values: Array<Array<Maybe<Scalars["Float"]>>>;
};

export type MultiweekForecast = {
  __typename: "MultiweekForecast";
  activeDopplerWeeklyTotals: Array<Maybe<Scalars["Float"]>>;
  adjustmentsWeeklyTotals: Array<Maybe<Scalars["Float"]>>;
  adjustmentsWeeklyTotalsGrowthRates: Array<Maybe<Scalars["Float"]>>;
  lastYearActualsByWeek: Array<Maybe<Scalars["Float"]>>;
  lastYearActualsByWeekGrowthRates: Array<Maybe<Scalars["Float"]>>;
  ovfPublishedByWeek: Array<Maybe<Scalars["Float"]>>;
  ovfPublishedByWeekGrowthRates: Array<Maybe<Scalars["Float"]>>;
  thisYearActualsByWeek: Array<Maybe<Scalars["Float"]>>;
  thisYearActualsByWeekGrowthRates: Array<Maybe<Scalars["Float"]>>;
};

export type Mutation = {
  __typename: "Mutation";
  approveAndReleaseShifts: StandardMutationResponse;
  cancelAllJobRuns: StandardMutationResponse;
  createGlobalAdjustmentLayer: StandardMutationResponse;
  createLocationTargets: CreateLocationTargetResponse;
  createOrEditReforecastLayer: StandardMutationResponse;
  deleteEventAdjustment: StandardMutationResponse;
  deleteShifts: Maybe<Array<Maybe<ShiftsResponse>>>;
  generateSasToken: AzureSasToken;
  publishShifterShifts: StandardMutationResponse;
  publishShifts: Maybe<PublishShiftsResponse>;
  refreshEibView: StandardMutationResponse;
  runGoSked: StandardMutationResponse;
  runOaShifter: StandardMutationResponse;
  setAllHourlyAdjustmentsToHistoricalAverage: StandardMutationResponse;
  setSelectedDopplerRun: StandardMutationResponse;
  startOdhTransform: StandardMutationResponse;
  startShifterPipeline: StandardMutationResponse;
  submitAdjustedOvf: StandardMutationResponse;
  submitMidweekReforecastAdjustedOvf: StandardMutationResponse;
  submitShifterShifts: StandardMutationResponse;
  submitShifts: Maybe<Array<Maybe<ShiftsResponse>>>;
  triggerJobRun: Maybe<Trigger>;
  updateForecastersAndForecasterAssignments: Maybe<StandardMutationResponse>;
  updateLocationTargets: StandardMutationResponse;
  uploadDriverHoursCsv: StandardMutationResponse;
  uploadEventAdjustmentCsv: StandardMutationResponse;
  uploadIncrementalAdjustedDriverHoursCsv: StandardMutationResponse;
  uploadLocationTargets: StandardMutationResponse;
  uploadOAHours: StandardMutationResponse;
  uploadOaLaborMapping: StandardMutationResponse;
  uploadOvfCsv: StandardMutationResponse;
  uploadShiftLeaderShiftRequests: StandardMutationResponse;
  uploadShiftsReportingBundle: StandardMutationResponse;
  upsertSeasonalAdjustment: SeasonalityAdjustments;
  validateShifterShifts: StandardMutationResponse;
};

export type MutationApproveAndReleaseShiftsArgs = {
  adjustedDHRunId: Scalars["NonNegativeInt"];
  operationalWeekStartDate: Scalars["String"];
};

export type MutationCancelAllJobRunsArgs = {
  environment?: InputMaybe<Scalars["String"]>;
  jobId: Scalars["NonNegativeInt"];
};

export type MutationCreateGlobalAdjustmentLayerArgs = {
  countryCode?: InputMaybe<Scalars["String"]>;
  forecasterId?: InputMaybe<Scalars["NonNegativeInt"]>;
  layerName: Scalars["String"];
  locationIds?: InputMaybe<Array<Scalars["NonNegativeInt"]>>;
  operationalWeekStartDate: Scalars["String"];
  orderAdjustment: Scalars["Int"];
  tag?: InputMaybe<Scalars["String"]>;
};

export type MutationCreateLocationTargetsArgs = {
  locationTargetCreateInput: LocationTargetCreateInput;
};

export type MutationCreateOrEditReforecastLayerArgs = {
  countryCode?: InputMaybe<Scalars["String"]>;
  date: Scalars["String"];
  locationIds?: InputMaybe<Array<InputMaybe<Scalars["NonNegativeInt"]>>>;
  metroRegion?: InputMaybe<Scalars["String"]>;
  orderAdjustment?: InputMaybe<Scalars["Int"]>;
};

export type MutationDeleteEventAdjustmentArgs = {
  name: Scalars["String"];
  operationalWeekStartDate: Scalars["String"];
};

export type MutationDeleteShiftsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["NonNegativeInt"]>>>;
};

export type MutationGenerateSasTokenArgs = {
  connectionString: Scalars["String"];
  containerName: Scalars["String"];
  permissions: Scalars["String"];
};

export type MutationPublishShifterShiftsArgs = {
  adjustedDHRunId: Scalars["NonNegativeInt"];
  operationalWeekStartDate: Scalars["String"];
};

export type MutationPublishShiftsArgs = {
  publishInput?: InputMaybe<PublishInput>;
};

export type MutationRunGoSkedArgs = {
  goSkedInput: GoSkedInput;
};

export type MutationRunOaShifterArgs = {
  oaShifterInput: OaShifterInput;
};

export type MutationSetAllHourlyAdjustmentsToHistoricalAverageArgs = {
  isMetroRegion?: InputMaybe<Scalars["Boolean"]>;
  locationId: Scalars["NonNegativeInt"];
  operationalWeekStartDate: Scalars["String"];
  weeksInPast: Scalars["NonNegativeInt"];
};

export type MutationSetSelectedDopplerRunArgs = {
  dopplerQARunsId: Scalars["NonNegativeInt"];
};

export type MutationStartOdhTransformArgs = {
  selectedWeek: Scalars["String"];
};

export type MutationStartShifterPipelineArgs = {
  adjustedDHRunId: Scalars["NonNegativeInt"];
  operationalWeekStartDate: Scalars["String"];
};

export type MutationSubmitAdjustedOvfArgs = {
  operationalWeekStartDate: Scalars["String"];
};

export type MutationSubmitMidweekReforecastAdjustedOvfArgs = {
  operationalWeekStartDate: Scalars["String"];
};

export type MutationSubmitShifterShiftsArgs = {
  adjustedDHRunId: Scalars["NonNegativeInt"];
  operationalWeekStartDate: Scalars["String"];
};

export type MutationSubmitShiftsArgs = {
  shifts?: InputMaybe<Array<InputMaybe<ShiftInput>>>;
};

export type MutationTriggerJobRunArgs = {
  environment?: InputMaybe<Scalars["String"]>;
  jobId: Scalars["NonNegativeInt"];
  queryParams?: InputMaybe<Scalars["JSON"]>;
};

export type MutationUpdateLocationTargetsArgs = {
  locationTargetUpdateInput: LocationTargetUpdateInput;
};

export type MutationUploadDriverHoursCsvArgs = {
  name?: InputMaybe<Scalars["String"]>;
  selectedWeek: Scalars["String"];
  uploadDriverHoursCsvInput: UploadDriverHoursCsvInput;
};

export type MutationUploadEventAdjustmentCsvArgs = {
  allowDatesOutsideSelectedWeek: Scalars["Boolean"];
  layerType?: InputMaybe<Scalars["String"]>;
  operationalWeekStartDate: Scalars["String"];
  uploadEventAdjustmentCsvInput: UploadEventAdjustmentCsvInput;
};

export type MutationUploadIncrementalAdjustedDriverHoursCsvArgs = {
  name?: InputMaybe<Scalars["String"]>;
  selectedWeek: Scalars["String"];
  uploadIncrementalDriverHoursCsvInput: UploadDriverHoursCsvInput;
};

export type MutationUploadLocationTargetsArgs = {
  allowDatesOutsideSelectedWeek: Scalars["Boolean"];
  selectedWeek: Scalars["String"];
  uploadLocationTargetsInput: UploadLocationTargetsInput;
};

export type MutationUploadOaHoursArgs = {
  name?: InputMaybe<Scalars["String"]>;
  selectedWeek: Scalars["String"];
  uploadOAHoursInput: UploadOaHoursInput;
};

export type MutationUploadOaLaborMappingArgs = {
  uploadOaLaborMappingInput: UploadOaLaborMappingInput;
};

export type MutationUploadOvfCsvArgs = {
  allowDatesOutsideSelectedWeek?: InputMaybe<Scalars["Boolean"]>;
  selectedWeek: Scalars["String"];
  uploadOvfCsvInput: UploadOvfCsvInput;
};

export type MutationUploadShiftLeaderShiftRequestsArgs = {
  uploadShiftLeaderShiftRequestsCsvInput: UploadShiftLeaderShiftRequestsCsvInput;
};

export type MutationUploadShiftsReportingBundleArgs = {
  adjustedDHRunId: Scalars["NonNegativeInt"];
  operationalWeekStartDate: Scalars["String"];
};

export type MutationUpsertSeasonalAdjustmentArgs = {
  adjustmentType: Scalars["String"];
  dateString: Scalars["String"];
  forecasterId?: InputMaybe<Scalars["NonNegativeInt"]>;
  locationId: Scalars["NonNegativeInt"];
  operationalWeekStartDate: Scalars["String"];
  value?: InputMaybe<Scalars["Float"]>;
};

export type MutationValidateShifterShiftsArgs = {
  adjustedDHRunId: Scalars["NonNegativeInt"];
  operationalWeekStartDate: Scalars["String"];
};

export type NotebookParams = {
  __typename: "NotebookParams";
  run_time: Maybe<Scalars["String"]>;
};

export type OvfShift = {
  __typename: "OVFShift";
  ODH: Scalars["Float"];
  OVF: Scalars["Int"];
  date: Scalars["String"];
  driverHours: Scalars["Int"];
  locationId: Scalars["Int"];
  shiftFill: Scalars["Float"];
};

export type OaDriverHoursRun = {
  __typename: "OaDriverHoursRun";
  createdAt: Maybe<Scalars["DateTime"]>;
  id: Scalars["NonNegativeInt"];
  name: Maybe<Scalars["String"]>;
  operationalWeekStartDate: Maybe<Scalars["String"]>;
  ophRunsId: Maybe<Scalars["NonNegativeInt"]>;
  source: Scalars["String"];
};

export type OaLaborHours = {
  __typename: "OaLaborHours";
  created_at: Scalars["DateTime"];
  gosked_hours: Scalars["Float"];
  gosked_inbound_hours: Maybe<Scalars["Float"]>;
  gosked_pack_hours: Maybe<Scalars["Float"]>;
  gosked_total_hours: Maybe<Scalars["Float"]>;
  id: Scalars["Int"];
  local_time: Scalars["DateTime"];
  location_id: Scalars["Int"];
  location_name: Maybe<Scalars["String"]>;
  ops_date: Scalars["Date"];
  role: Maybe<Scalars["String"]>;
};

export type OaLocation = {
  __typename: "OaLocation";
  country_code: Scalars["String"];
  created_at: Maybe<Scalars["DateTime"]>;
  location_id: Scalars["Int"];
  location_name: Scalars["String"];
  metro_region: Maybe<Scalars["String"]>;
  state_code: Maybe<Scalars["String"]>;
  updated_at: Maybe<Scalars["DateTime"]>;
};

export type OaLocationCluster = {
  __typename: "OaLocationCluster";
  created_at: Scalars["DateTime"];
  id: Scalars["Int"];
  location_ids: Array<Scalars["Int"]>;
  name: Scalars["String"];
  updated_at: Scalars["DateTime"];
};

export type OaLocationsInput = {
  cluster_ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
  country_codes?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  exclude_location_ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
  metro_regions?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  state_codes?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type OaShift = {
  __typename: "OaShift";
  endTime: Scalars["String"];
  length: Scalars["Float"];
  locationName: Scalars["String"];
  opsDate: Scalars["String"];
  shiftLeader: Maybe<Scalars["String"]>;
  startTime: Scalars["String"];
  weekday: Scalars["String"];
};

export type OaShifterInput = {
  adjustedOaHoursRunId: Scalars["Int"];
  maxShiftLength: Scalars["Int"];
  minShiftLength: Scalars["Int"];
  operationalWeekStartDate: Scalars["String"];
  shiftIncrement: Scalars["Int"];
};

export type OdhTransform = {
  __typename: "OdhTransform";
  baseline_odh: Scalars["Float"];
  batch: Scalars["String"];
  clamped_odh: Scalars["Float"];
  created_at: Scalars["DateTime"];
  forecast_local_time: Scalars["DateTime"];
  hours: Maybe<Scalars["Int"]>;
  id: Scalars["ID"];
  location_id: Scalars["String"];
  orders: Maybe<Scalars["Int"]>;
  scaled_odh: Scalars["Float"];
  updated_at: Scalars["DateTime"];
};

export type OdhTransformPayload = {
  __typename: "OdhTransformPayload";
  odhTransform: Maybe<Array<Maybe<OdhTransform>>>;
};

export type OverridingParameters = {
  __typename: "OverridingParameters";
  notebook_params: Maybe<NotebookParams>;
};

export type OvfHour = {
  __typename: "OvfHour";
  forecastLocalTime: Scalars["DateTime"];
  forecastUtcTime: Scalars["DateTime"];
  id: Maybe<Scalars["Int"]>;
  loadTimestamp: Maybe<Scalars["DateTime"]>;
  locationId: Maybe<Scalars["Int"]>;
  locationName: Maybe<Scalars["String"]>;
  ovfSource: Maybe<OvfSource>;
  runDate: Scalars["DateTime"];
  runId: Maybe<Scalars["Int"]>;
  yhat: Maybe<Scalars["Float"]>;
};

export type OvfHourNetwork = {
  __typename: "OvfHourNetwork";
  forecastUtcTime: Scalars["DateTime"];
  loadTimestamp: Maybe<Scalars["DateTime"]>;
  ovfSource: Maybe<OvfSource>;
  runDate: Scalars["DateTime"];
  yhat: Maybe<Scalars["Float"]>;
};

export enum OvfSource {
  AdjustedOvf = "ADJUSTED_OVF",
  Doppler = "DOPPLER",
  Reforecast_24H = "REFORECAST_24H",
  Reforecast_24HAndDoppler = "REFORECAST_24H_AND_DOPPLER",
}

export type PageInfo = {
  __typename: "PageInfo";
  endCursor: Scalars["String"];
  hasNextPage: Scalars["Boolean"];
  hasPreviousPage: Scalars["Boolean"];
  startCursor: Scalars["String"];
};

export type PublishInput = {
  locationIds?: InputMaybe<Array<InputMaybe<Scalars["NonNegativeInt"]>>>;
  mustRequest?: InputMaybe<Scalars["Boolean"]>;
  sendNotifications?: InputMaybe<Scalars["Boolean"]>;
  shiftIds?: InputMaybe<Array<InputMaybe<Scalars["NonNegativeInt"]>>>;
  timezone?: InputMaybe<Scalars["String"]>;
};

export type PublishShiftsResponse = {
  __typename: "PublishShiftsResponse";
  invalidShiftIds: Maybe<Array<Maybe<Scalars["NonNegativeInt"]>>>;
  success: Maybe<Array<Maybe<PublishSuccessResponse>>>;
};

export type PublishSuccessResponse = {
  __typename: "PublishSuccessResponse";
  locationId: Scalars["NonNegativeInt"];
  message: Scalars["String"];
  publishedShiftsCount: Scalars["NonNegativeInt"];
  success: Scalars["Boolean"];
};

export type PublishedOvf = {
  __typename: "PublishedOvf";
  locationId: Scalars["NonNegativeInt"];
  ovfs: Array<Maybe<Scalars["NonNegativeInt"]>>;
};

export type Query = {
  __typename: "Query";
  adjustedDriverHourLocations: Array<AdjustedDriverHourLocation>;
  countries: Maybe<Array<Maybe<Country>>>;
  currentlyActiveDopplerRunDate: Maybe<Scalars["String"]>;
  dopplerQA: Maybe<DopplerQa>;
  dopplerRunTimestampsThisWeek: Array<DopplerRun>;
  eibXlsxUrl: Scalars["String"];
  eventAdjustmentTotalsByDay: Array<Scalars["Float"]>;
  eventAdjustments: Maybe<Array<Maybe<EventAdjustment>>>;
  forecastDriverHours: Maybe<Array<ForecastDriverHour>>;
  forecastLocationsByMetroRegions: Array<LocationsByMetroRegion>;
  forecastNetworkDriverHours: Maybe<Array<ForecastNetworkDriverHour>>;
  forecasters: Maybe<Array<Maybe<Forecaster>>>;
  getAdjustedDriverHoursRunsForWeek: Array<AdjustedDriverHoursRun>;
  getAdjustedOaHours: Array<OaLaborHours>;
  getAdjustedOaHoursRunsForWeek: Array<OaDriverHoursRun>;
  getLatestJobStatus: Maybe<JobStatus>;
  getMostRecentLaborMappingUploadTimestamp: Maybe<MostRecentLaborMappingUpload>;
  getMostRecentOaLaborUploadTimestamp: Maybe<MostRecentOaLaborUpload>;
  getRun: Maybe<Run>;
  getRunsList: Maybe<Job>;
  getSasUrlForFileInDSBlobStorage: Maybe<Scalars["String"]>;
  getShiftLeaderShiftRequests: Array<Maybe<ShiftLeaderShiftRequest>>;
  getShifts: Maybe<Array<Maybe<Shift>>>;
  itemForecast: Maybe<Array<ItemForecast>>;
  locationTargets: Maybe<LocationTargetConnection>;
  locations: Maybe<Array<Maybe<Location>>>;
  metroRegions: Maybe<Array<Maybe<Scalars["String"]>>>;
  midweekReforecast: Maybe<MidweekReforecast>;
  mostRecentAdjustedHoursUploadDate: Maybe<MostRecentAdjustedHoursUpload>;
  mostRecentOdhTransformJobDate: Maybe<MostRecentOdhTransformJob>;
  mostRecentOdhTransformRun: Maybe<MostRecentOdhTransformRun>;
  mostRecentOvfSubmit: Maybe<Scalars["DateTime"]>;
  mostRecentShiftsApprovalTimestamp: Maybe<Scalars["DateTime"]>;
  mostRecentShiftsPublishTimestamp: Maybe<Scalars["DateTime"]>;
  mostRecentShiftsReportingBundleUploadTimestamp: Maybe<Scalars["DateTime"]>;
  multiweekForecast: Maybe<MultiweekForecast>;
  oaLocationClusters: Array<Maybe<OaLocationCluster>>;
  oaLocations: Array<Maybe<OaLocation>>;
  oaShifts: Array<OaShift>;
  odhLocations: Maybe<Array<Maybe<Location>>>;
  ovfHours: Maybe<Array<OvfHour>>;
  ovfHoursNetwork: Maybe<Array<OvfHourNetwork>>;
  ovfQaLocations: Maybe<Array<Maybe<Location>>>;
  ovfShifts: Maybe<Array<Maybe<OvfShift>>>;
  publishedOvf: Array<PublishedOvf>;
  secret: Maybe<Scalars["String"]>;
  shifterPipelineRunsId: Maybe<Scalars["Int"]>;
  shifterState: Maybe<Scalars["String"]>;
  shifterStatus: Maybe<ShifterStatus>;
  shifts: Maybe<Array<Maybe<ShiftModelOutput>>>;
  shiftsDailyQA: Array<ShiftsDailyQa>;
  shiftsDailyQATotal: Array<ShiftsDailyQaTotal>;
  shiftsHourlyQaCsvUrl: Scalars["String"];
  shiftsHours: Maybe<Array<Maybe<ShiftHours>>>;
  shiftsQALocationsByMetroRegions: Array<LocationsByMetroRegion>;
  shiftsWeeklyQA: Array<ShiftsWeeklyQa>;
  shiftsWeeklyQATotal: ShiftsWeeklyQaTotal;
  weeklyAdjustLocations: Maybe<Array<Maybe<Location>>>;
};

export type QueryAdjustedDriverHourLocationsArgs = {
  runId: Scalars["NonNegativeInt"];
};

export type QueryDopplerQaArgs = {
  runId: Scalars["Int"];
};

export type QueryEibXlsxUrlArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  operationalWeekStartDate: Scalars["String"];
  runId?: InputMaybe<Scalars["NonNegativeInt"]>;
};

export type QueryEventAdjustmentTotalsByDayArgs = {
  country: Scalars["String"];
  operationalWeekStartDate: Scalars["String"];
};

export type QueryEventAdjustmentsArgs = {
  layerName?: InputMaybe<Scalars["String"]>;
  operationalWeekStartDate: Scalars["String"];
  tag?: InputMaybe<Scalars["String"]>;
};

export type QueryForecastDriverHoursArgs = {
  forecastHoursInput: ForecastHoursInput;
};

export type QueryForecastLocationsByMetroRegionsArgs = {
  countryCode: Scalars["String"];
  operationalWeekStartDate: Scalars["String"];
  weeksToInclude?: InputMaybe<Scalars["NonNegativeInt"]>;
};

export type QueryForecastNetworkDriverHoursArgs = {
  forecastHoursInput: ForecastHoursInput;
  mode?: InputMaybe<Mode>;
};

export type QueryForecastersArgs = {
  operationalWeekStartDate?: InputMaybe<Scalars["String"]>;
};

export type QueryGetAdjustedDriverHoursRunsForWeekArgs = {
  operationalWeekStartDate: Scalars["String"];
};

export type QueryGetAdjustedOaHoursArgs = {
  runId: Scalars["NonNegativeInt"];
};

export type QueryGetAdjustedOaHoursRunsForWeekArgs = {
  operationalWeekStartDate: Scalars["String"];
};

export type QueryGetLatestJobStatusArgs = {
  environment?: InputMaybe<Scalars["String"]>;
  jobID: Scalars["NonNegativeInt"];
};

export type QueryGetMostRecentOaLaborUploadTimestampArgs = {
  operationalWeekStartDate?: InputMaybe<Scalars["String"]>;
};

export type QueryGetRunArgs = {
  environment?: InputMaybe<Scalars["String"]>;
  runID: Scalars["NonNegativeInt"];
};

export type QueryGetRunsListArgs = {
  environment?: InputMaybe<Scalars["String"]>;
  runsListParams: RunsListParams;
};

export type QueryGetSasUrlForFileInDsBlobStorageArgs = {
  filename: Scalars["String"];
};

export type QueryGetShiftsArgs = {
  endTime: Scalars["String"];
  locationId: Scalars["NonNegativeInt"];
  startTime: Scalars["String"];
};

export type QueryItemForecastArgs = {
  itemForecastInput: ItemForecastInput;
};

export type QueryLocationTargetsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["NonNegativeInt"]>;
  last?: InputMaybe<Scalars["NonNegativeInt"]>;
  targetWeek: Scalars["String"];
};

export type QueryLocationsArgs = {
  country?: InputMaybe<Scalars["String"]>;
  forecasterId?: InputMaybe<Scalars["String"]>;
  ids?: InputMaybe<Array<Scalars["NonNegativeInt"]>>;
  operationalWeekStartDate?: InputMaybe<Scalars["String"]>;
};

export type QueryMetroRegionsArgs = {
  countryCode?: InputMaybe<Scalars["String"]>;
};

export type QueryMidweekReforecastArgs = {
  countryCode?: InputMaybe<Scalars["String"]>;
  locationId?: InputMaybe<Scalars["NonNegativeInt"]>;
  metroRegion?: InputMaybe<Scalars["String"]>;
  operationalWeekStartDate: Scalars["String"];
};

export type QueryMostRecentAdjustedHoursUploadDateArgs = {
  operationalWeekStartDate?: InputMaybe<Scalars["String"]>;
};

export type QueryMostRecentOvfSubmitArgs = {
  selectedWeek: Scalars["String"];
};

export type QueryMostRecentShiftsApprovalTimestampArgs = {
  adjustedDHRunId: Scalars["NonNegativeInt"];
  operationalWeekStartDate: Scalars["String"];
};

export type QueryMostRecentShiftsPublishTimestampArgs = {
  adjustedDHRunId: Scalars["NonNegativeInt"];
  operationalWeekStartDate: Scalars["String"];
};

export type QueryMostRecentShiftsReportingBundleUploadTimestampArgs = {
  adjustedDHRunId: Scalars["NonNegativeInt"];
  operationalWeekStartDate: Scalars["String"];
};

export type QueryMultiweekForecastArgs = {
  locationIds: Array<Scalars["NonNegativeInt"]>;
  operationalWeekStartDate: Scalars["String"];
  weeks: Scalars["NonNegativeInt"];
};

export type QueryOaLocationClustersArgs = {
  id?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  location_ids?: InputMaybe<Array<Scalars["Int"]>>;
  name?: InputMaybe<Scalars["String"]>;
  offset?: InputMaybe<Scalars["Int"]>;
};

export type QueryOaLocationsArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
  oaLocationsInput?: InputMaybe<OaLocationsInput>;
  offset?: InputMaybe<Scalars["Int"]>;
};

export type QueryOaShiftsArgs = {
  adjustedOaHoursRunId: Scalars["NonNegativeInt"];
  operationalWeekStartDate: Scalars["String"];
};

export type QueryOdhLocationsArgs = {
  batchId?: InputMaybe<Scalars["String"]>;
  operationalWeekStartDate: Scalars["String"];
};

export type QueryOvfHoursArgs = {
  forecastHoursInput: ForecastHoursInput;
  runDate?: InputMaybe<Scalars["String"]>;
};

export type QueryOvfHoursNetworkArgs = {
  forecastHoursInput: ForecastHoursInput;
  runDate?: InputMaybe<Scalars["String"]>;
};

export type QueryOvfQaLocationsArgs = {
  country: Scalars["String"];
  operationalWeekStartDate: Scalars["String"];
};

export type QueryOvfShiftsArgs = {
  operationalWeekStartDate: Scalars["String"];
};

export type QueryPublishedOvfArgs = {
  locationIds?: InputMaybe<Array<Scalars["NonNegativeInt"]>>;
  operationalWeekStartDate: Scalars["String"];
};

export type QuerySecretArgs = {
  key: Scalars["String"];
};

export type QueryShifterPipelineRunsIdArgs = {
  adjustedDHRunId: Scalars["NonNegativeInt"];
  operationalWeekStartDate: Scalars["String"];
};

export type QueryShifterStateArgs = {
  adjustedDHRunId: Scalars["NonNegativeInt"];
};

export type QueryShifterStatusArgs = {
  adjustedDHRunId: Scalars["NonNegativeInt"];
};

export type QueryShiftsArgs = {
  adjustedDHRunId: Scalars["NonNegativeInt"];
  locationIds?: InputMaybe<Array<Scalars["NonNegativeInt"]>>;
  operationalWeekStartDate: Scalars["String"];
  submitStatuses?: InputMaybe<Array<Scalars["String"]>>;
};

export type QueryShiftsDailyQaArgs = {
  adjustedDHRunId: Scalars["NonNegativeInt"];
  flaggedOnly?: InputMaybe<Scalars["Boolean"]>;
  locationIds: Array<Scalars["NonNegativeInt"]>;
  operationalWeekStartDate: Scalars["String"];
};

export type QueryShiftsDailyQaTotalArgs = {
  adjustedDHRunId: Scalars["NonNegativeInt"];
  countryCode: Scalars["String"];
  operationalWeekStartDate: Scalars["String"];
};

export type QueryShiftsHourlyQaCsvUrlArgs = {
  adjustedDHRunId: Scalars["NonNegativeInt"];
  operationalWeekStartDate: Scalars["String"];
};

export type QueryShiftsHoursArgs = {
  adjustedDHRunId: Scalars["NonNegativeInt"];
};

export type QueryShiftsQaLocationsByMetroRegionsArgs = {
  adjustedDHRunId: Scalars["NonNegativeInt"];
  countryCode: Scalars["String"];
  operationalWeekStartDate: Scalars["String"];
};

export type QueryShiftsWeeklyQaArgs = {
  adjustedDHRunId: Scalars["NonNegativeInt"];
  flaggedOnly?: InputMaybe<Scalars["Boolean"]>;
  locationIds: Array<Scalars["NonNegativeInt"]>;
  operationalWeekStartDate: Scalars["String"];
};

export type QueryShiftsWeeklyQaTotalArgs = {
  adjustedDHRunId: Scalars["NonNegativeInt"];
  countryCode: Scalars["String"];
  operationalWeekStartDate: Scalars["String"];
};

export type QueryWeeklyAdjustLocationsArgs = {
  forecasterId: Scalars["String"];
  operationalWeekStartDate: Scalars["String"];
};

export type Run = {
  __typename: "Run";
  cleanup_duration: Maybe<Scalars["BigInt"]>;
  creator_user_name: Maybe<Scalars["String"]>;
  end_time: Maybe<Scalars["BigInt"]>;
  execution_duration: Maybe<Scalars["BigInt"]>;
  format: Maybe<Scalars["String"]>;
  job_id: Scalars["NonNegativeInt"];
  number_in_job: Maybe<Scalars["NonNegativeInt"]>;
  original_attempt_run_id: Maybe<Scalars["NonNegativeInt"]>;
  overriding_parameters: Maybe<OverridingParameters>;
  run_id: Scalars["NonNegativeInt"];
  run_name: Maybe<Scalars["String"]>;
  run_page_url: Maybe<Scalars["String"]>;
  run_type: Maybe<Scalars["String"]>;
  setup_duration: Maybe<Scalars["BigInt"]>;
  start_time: Maybe<Scalars["BigInt"]>;
  state: Maybe<State>;
  trigger: Maybe<Scalars["String"]>;
};

export type RunsListParams = {
  active_only?: InputMaybe<Scalars["Boolean"]>;
  completed_only?: InputMaybe<Scalars["Boolean"]>;
  expand_tasks?: InputMaybe<Scalars["Boolean"]>;
  job_id: Scalars["NonNegativeInt"];
  limit?: InputMaybe<Scalars["NonNegativeInt"]>;
  offset?: InputMaybe<Scalars["NonNegativeInt"]>;
  run_type?: InputMaybe<JobType>;
  start_time_from?: InputMaybe<Scalars["DateTime"]>;
  start_time_to?: InputMaybe<Scalars["DateTime"]>;
};

export type SeasonalityAdjustments = {
  __typename: "SeasonalityAdjustments";
  dailyLayer: Array<Array<Maybe<Scalars["Float"]>>>;
  dailyOverrides: Array<Maybe<Scalars["Float"]>>;
  dailySeasonalityAdjustedForecastDistribution: Array<Scalars["Float"]>;
  dates: Array<Scalars["String"]>;
  dopplerForecast: Array<Array<Maybe<Scalars["Int"]>>>;
  hourlyLayer: Array<Array<Maybe<Scalars["Float"]>>>;
  hourlyOverrides: Array<Array<Maybe<Scalars["Float"]>>>;
  success: Scalars["Boolean"];
  totalSeasonalityAdjustedForecastDistribution: Array<
    Array<Maybe<Scalars["Float"]>>
  >;
  weeklyLayer: Array<Array<Maybe<Scalars["Float"]>>>;
  weeklyOverride: Scalars["Float"];
};

export type Shift = {
  __typename: "Shift";
  assignedPersonId: Maybe<Scalars["NonNegativeInt"]>;
  classificationId: Maybe<Scalars["NonNegativeInt"]>;
  createdTime: Maybe<Scalars["String"]>;
  deliveryMethodId: Maybe<Scalars["NonNegativeInt"]>;
  endTime: Maybe<Scalars["String"]>;
  id: Maybe<Scalars["NonNegativeInt"]>;
  isDeleted: Maybe<Scalars["Boolean"]>;
  isPublished: Maybe<Scalars["Boolean"]>;
  locationId: Maybe<Scalars["NonNegativeInt"]>;
  mustRequest: Maybe<Scalars["Boolean"]>;
  publishedTime: Maybe<Scalars["String"]>;
  roleId: Maybe<Scalars["NonNegativeInt"]>;
  startTime: Maybe<Scalars["String"]>;
  tags: Maybe<Scalars["JSON"]>;
  updatedTime: Maybe<Scalars["String"]>;
};

export type ShiftHours = {
  __typename: "ShiftHours";
  isAssigned: Scalars["Boolean"];
  length: Scalars["Float"];
  localTime: Scalars["DateTime"];
  locationId: Scalars["NonNegativeInt"];
  mode: Scalars["String"];
};

export type ShiftInput = {
  assignedPersonId?: InputMaybe<Scalars["String"]>;
  deliveryMethodId?: InputMaybe<Scalars["NonNegativeInt"]>;
  endTime: Scalars["String"];
  isPublished?: InputMaybe<Scalars["Boolean"]>;
  locationId: Scalars["NonNegativeInt"];
  mustRequest?: InputMaybe<Scalars["Boolean"]>;
  shiftRoleId?: InputMaybe<Scalars["NonNegativeInt"]>;
  startTime: Scalars["String"];
  tags?: InputMaybe<Scalars["String"]>;
};

export type ShiftLeaderShiftRequest = {
  __typename: "ShiftLeaderShiftRequest";
  created_at: Scalars["DateTime"];
  day_of_week: Scalars["String"];
  id: Scalars["Int"];
  length: Scalars["Float"];
  location_id: Scalars["Int"];
  location_name: Maybe<Scalars["String"]>;
  shift_leader: Scalars["String"];
  start_time: Scalars["String"];
};

export type ShiftModelOutput = {
  __typename: "ShiftModelOutput";
  createdTime: Scalars["String"];
  date: Scalars["String"];
  deliveryMode: Scalars["String"];
  driverSlots: Scalars["NonNegativeInt"];
  endTime: Scalars["String"];
  length: Scalars["String"];
  locationId: Scalars["Int"];
  locationName: Scalars["String"];
  mustRequest: Maybe<Scalars["Boolean"]>;
  position: Scalars["String"];
  startTime: Scalars["String"];
  submitStatus: Maybe<Scalars["String"]>;
  updatedTime: Scalars["String"];
  weekday: Scalars["String"];
};

export type ShifterStatus = {
  __typename: "ShifterStatus";
  databricksRunId: Maybe<Scalars["NonNegativeInt"]>;
  details: Maybe<Scalars["String"]>;
  state: Scalars["String"];
};

export type ShiftsDailyQa = {
  __typename: "ShiftsDailyQA";
  appliedAbsenteeismAdjustmentHours: Maybe<Scalars["Float"]>;
  appliedAbsenteeismAdjustmentPercentage: Maybe<Scalars["Float"]>;
  appliedUnscheduledHours: Maybe<Scalars["Float"]>;
  appliedUnscheduledPercentage: Maybe<Scalars["Float"]>;
  date: Scalars["String"];
  dhAdjusted: Maybe<Scalars["Float"]>;
  dhAssignedDelta: Maybe<Scalars["Float"]>;
  dhAssignedInitial: Maybe<Scalars["Float"]>;
  dhFailedUpload: Maybe<Scalars["Float"]>;
  dhModeled: Maybe<Scalars["Float"]>;
  dhNetOfAbsenteeismAdjustments: Maybe<Scalars["Float"]>;
  dhNetOfAssigned: Maybe<Scalars["Float"]>;
  dhPlanned: Maybe<Scalars["Float"]>;
  dhPlannedTapered: Maybe<Scalars["Float"]>;
  dhPlannedTaperedPercentage: Maybe<Scalars["Float"]>;
  dhScheduled: Maybe<Scalars["Float"]>;
  dhScheduledMustRequest: Maybe<Scalars["Float"]>;
  dhTotalDelta: Maybe<Scalars["Float"]>;
  dhTotalExpected: Maybe<Scalars["Float"]>;
  dhTotalUpdated: Maybe<Scalars["Float"]>;
  dhUnassignedInitial: Maybe<Scalars["Float"]>;
  dhVarFlag: Maybe<Scalars["Boolean"]>;
  locationId: Scalars["NonNegativeInt"];
  maxHooEnd: Maybe<Scalars["String"]>;
  maxShiftEnd: Maybe<Scalars["String"]>;
  metroRegion: Maybe<Scalars["String"]>;
  minHooStart: Maybe<Scalars["String"]>;
  minShiftStart: Maybe<Scalars["String"]>;
  minimumDpAdjustment: Maybe<Scalars["Float"]>;
  mode: Maybe<Scalars["String"]>;
  netAbsenteeismAdjustmentHours: Maybe<Scalars["Float"]>;
  odhFlag: Maybe<Scalars["Boolean"]>;
  odhPlan: Maybe<Scalars["Float"]>;
  odhPlanVar: Maybe<Scalars["Float"]>;
  odhSched: Maybe<Scalars["Float"]>;
  odhSchedVar: Maybe<Scalars["Float"]>;
  odhTarget: Maybe<Scalars["Float"]>;
  odhTargetMax: Maybe<Scalars["Float"]>;
  odhTargetMin: Maybe<Scalars["Float"]>;
  ovf: Maybe<Scalars["Float"]>;
  startEndFlag: Maybe<Scalars["Boolean"]>;
  taperAdjustmentHours: Maybe<Scalars["Float"]>;
  weekday: Scalars["String"];
};

export type ShiftsDailyQaTotal = {
  __typename: "ShiftsDailyQATotal";
  appliedAbsenteeismAdjustmentHours: Maybe<Scalars["Float"]>;
  appliedAbsenteeismAdjustmentPercentage: Maybe<Scalars["Float"]>;
  appliedUnscheduledHours: Maybe<Scalars["Float"]>;
  appliedUnscheduledPercentage: Maybe<Scalars["Float"]>;
  date: Scalars["String"];
  dhAdjusted: Maybe<Scalars["Float"]>;
  dhAssignedDelta: Maybe<Scalars["Float"]>;
  dhAssignedInitial: Maybe<Scalars["Float"]>;
  dhFailedUpload: Maybe<Scalars["Float"]>;
  dhModeled: Scalars["Float"];
  dhNetOfAbsenteeismAdjustments: Maybe<Scalars["Float"]>;
  dhNetOfAssigned: Maybe<Scalars["Float"]>;
  dhNetOfHoursOfOperationAdjustments: Maybe<Scalars["Float"]>;
  dhPlanned: Maybe<Scalars["Float"]>;
  dhPlannedTapered: Maybe<Scalars["Float"]>;
  dhScheduled: Maybe<Scalars["Float"]>;
  dhScheduledMustRequest: Maybe<Scalars["Float"]>;
  dhTotalDelta: Maybe<Scalars["Float"]>;
  dhTotalExpected: Maybe<Scalars["Float"]>;
  dhTotalUpdated: Maybe<Scalars["Float"]>;
  dhUnassignedInitial: Maybe<Scalars["Float"]>;
  minimumDpAdjustment: Maybe<Scalars["Float"]>;
  netAbsenteeismAdjustmentHours: Maybe<Scalars["Float"]>;
  ovf: Maybe<Scalars["Float"]>;
  predictedAbsenteeismAdjustmentHours: Maybe<Scalars["Float"]>;
  predictedUnscheduledHours: Maybe<Scalars["Float"]>;
  taperAdjustmentHours: Maybe<Scalars["Float"]>;
  weekday: Scalars["String"];
};

export type ShiftsResponse = {
  __typename: "ShiftsResponse";
  message: Maybe<Scalars["String"]>;
  shift: Maybe<Shift>;
  success: Maybe<Scalars["Boolean"]>;
};

export type ShiftsWeeklyQa = {
  __typename: "ShiftsWeeklyQA";
  appliedAbsenteeismAdjustmentHours: Maybe<Scalars["Float"]>;
  appliedAbsenteeismAdjustmentPercentage: Maybe<Scalars["Float"]>;
  appliedUnscheduledHours: Maybe<Scalars["Float"]>;
  appliedUnscheduledPercentage: Maybe<Scalars["Float"]>;
  dhAdjusted: Maybe<Scalars["Float"]>;
  dhAssignedDelta: Maybe<Scalars["Float"]>;
  dhAssignedInitial: Maybe<Scalars["Float"]>;
  dhFailedUpload: Maybe<Scalars["Float"]>;
  dhModeled: Maybe<Scalars["Float"]>;
  dhNetOfAbsenteeismAdjustments: Maybe<Scalars["Float"]>;
  dhNetOfAssigned: Maybe<Scalars["Float"]>;
  dhPlanned: Maybe<Scalars["Float"]>;
  dhPlannedTapered: Maybe<Scalars["Float"]>;
  dhScheduled: Maybe<Scalars["Float"]>;
  dhScheduledMustRequest: Maybe<Scalars["Float"]>;
  dhTotalDelta: Maybe<Scalars["Float"]>;
  dhTotalExpected: Maybe<Scalars["Float"]>;
  dhTotalUpdated: Maybe<Scalars["Float"]>;
  dhUnassignedInitial: Maybe<Scalars["Float"]>;
  flagged: Maybe<Scalars["Boolean"]>;
  locationId: Scalars["NonNegativeInt"];
  metroRegion: Maybe<Scalars["String"]>;
  minimumDpAdjustment: Maybe<Scalars["Float"]>;
  netAbsenteeismAdjustmentHours: Maybe<Scalars["Float"]>;
  odhPlan: Maybe<Scalars["Float"]>;
  odhPlanVar: Maybe<Scalars["Float"]>;
  odhSched: Maybe<Scalars["Float"]>;
  odhSchedVar: Maybe<Scalars["Float"]>;
  odhTarget: Maybe<Scalars["Float"]>;
  odhTargetMax: Maybe<Scalars["Float"]>;
  odhTargetMin: Maybe<Scalars["Float"]>;
  ovf: Maybe<Scalars["Float"]>;
  taperAdjustmentHours: Maybe<Scalars["Float"]>;
};

export type ShiftsWeeklyQaTotal = {
  __typename: "ShiftsWeeklyQATotal";
  appliedAbsenteeismAdjustmentHours: Maybe<Scalars["Float"]>;
  appliedAbsenteeismAdjustmentPercentage: Maybe<Scalars["Float"]>;
  appliedUnscheduledHours: Maybe<Scalars["Float"]>;
  appliedUnscheduledPercentage: Maybe<Scalars["Float"]>;
  dhAdjusted: Maybe<Scalars["Float"]>;
  dhAssignedDelta: Maybe<Scalars["Float"]>;
  dhAssignedInitial: Maybe<Scalars["Float"]>;
  dhFailedUpload: Maybe<Scalars["Float"]>;
  dhModeled: Maybe<Scalars["Float"]>;
  dhNetOfAbsenteeismAdjustments: Maybe<Scalars["Float"]>;
  dhNetOfAssigned: Maybe<Scalars["Float"]>;
  dhNetOfHoursOfOperationAdjustments: Maybe<Scalars["Float"]>;
  dhPlanned: Maybe<Scalars["Float"]>;
  dhPlannedTapered: Maybe<Scalars["Float"]>;
  dhScheduled: Maybe<Scalars["Float"]>;
  dhScheduledMustRequest: Maybe<Scalars["Float"]>;
  dhTotalDelta: Maybe<Scalars["Float"]>;
  dhTotalExpected: Maybe<Scalars["Float"]>;
  dhTotalUpdated: Maybe<Scalars["Float"]>;
  dhUnassignedInitial: Maybe<Scalars["Float"]>;
  minimumDpAdjustment: Maybe<Scalars["Float"]>;
  netAbsenteeismAdjustmentHours: Maybe<Scalars["Float"]>;
  ovf: Maybe<Scalars["Float"]>;
  predictedAbsenteeismAdjustmentHours: Maybe<Scalars["Float"]>;
  predictedUnscheduledHours: Maybe<Scalars["Float"]>;
  taperAdjustmentHours: Maybe<Scalars["Float"]>;
};

export type StandardMutationResponse = {
  __typename: "StandardMutationResponse";
  message: Scalars["String"];
  success: Scalars["Boolean"];
};

export type State = {
  __typename: "State";
  life_cycle_state: Maybe<Scalars["String"]>;
  result_state: Maybe<Scalars["String"]>;
  state_message: Maybe<Scalars["String"]>;
  user_cancelled_or_timedout: Maybe<Scalars["Boolean"]>;
};

export type ThreeWeekTrailingAverages = {
  __typename: "ThreeWeekTrailingAverages";
  dailyPercentages: Array<Maybe<Scalars["Float"]>>;
  dates: Maybe<Array<Scalars["String"]>>;
  hourlyPercentages: Array<Array<Maybe<Scalars["Float"]>>>;
};

export enum TimeFormat {
  Local = "LOCAL",
  Utc = "UTC",
}

export type Trigger = {
  __typename: "Trigger";
  number_in_job: Maybe<Scalars["NonNegativeInt"]>;
  run_id: Scalars["NonNegativeInt"];
};

export type UploadDriverHoursCsvInput = {
  file: Scalars["Upload"];
};

export type UploadEventAdjustmentCsvInput = {
  file: Scalars["Upload"];
};

export type UploadLocationTargetsInput = {
  file: Scalars["Upload"];
};

export type UploadOaHoursInput = {
  file: Scalars["Upload"];
};

export type UploadOaLaborMappingInput = {
  file: Scalars["Upload"];
};

export type UploadOvfCsvInput = {
  file: Scalars["Upload"];
};

export type UploadShiftLeaderShiftRequestsCsvInput = {
  file: Scalars["Upload"];
};

export type UploadShiftsResponseLegacy = {
  __typename: "UploadShiftsResponseLegacy";
  invalidShifts: Array<Maybe<InvalidShift>>;
  invalidShiftsUrl: Scalars["String"];
  shiftsAdded: Scalars["NonNegativeInt"];
  success: Scalars["Boolean"];
};

export type WeeklyMissingLocation = {
  __typename: "WeeklyMissingLocation";
  forecasterId: Maybe<Scalars["NonNegativeInt"]>;
  launchDate: Scalars["String"];
  locationId: Scalars["NonNegativeInt"];
  missingInDoppler: Maybe<Scalars["Boolean"]>;
};

export type WeeklyQa = {
  __typename: "WeeklyQA";
  dailyMissingLocations: Array<Maybe<DailyMissingLocation>>;
  hourlyMissingLocations: Array<Maybe<HourlyMissingLocation>>;
  locationsInBackOffice: Scalars["NonNegativeInt"];
  locationsInDoppler: Scalars["NonNegativeInt"];
  operationalWeekStartDate: Scalars["String"];
  orders: Scalars["NonNegativeInt"];
  weeklyMissingLocations: Array<Maybe<WeeklyMissingLocation>>;
};

export type WeeklyQaByCountry = {
  __typename: "WeeklyQAByCountry";
  countryCode: Scalars["String"];
  weeklyQA: Array<WeeklyQa>;
};

export type AdjustedDriverHourLocationKeySpecifier = (
  | "driverHours"
  | "id"
  | "title"
  | AdjustedDriverHourLocationKeySpecifier
)[];
export type AdjustedDriverHourLocationFieldPolicy = {
  driverHours?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AdjustedDriverHoursRunKeySpecifier = (
  | "createdAt"
  | "id"
  | "name"
  | "odhRunsId"
  | "operationalWeekStartDate"
  | "source"
  | AdjustedDriverHoursRunKeySpecifier
)[];
export type AdjustedDriverHoursRunFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  odhRunsId?: FieldPolicy<any> | FieldReadFunction<any>;
  operationalWeekStartDate?: FieldPolicy<any> | FieldReadFunction<any>;
  source?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AdjustedOvfKeySpecifier = (
  | "location_id"
  | "ovf"
  | "ovf_local_datetime"
  | AdjustedOvfKeySpecifier
)[];
export type AdjustedOvfFieldPolicy = {
  location_id?: FieldPolicy<any> | FieldReadFunction<any>;
  ovf?: FieldPolicy<any> | FieldReadFunction<any>;
  ovf_local_datetime?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AzureSasTokenKeySpecifier = (
  | "message"
  | "success"
  | "token"
  | AzureSasTokenKeySpecifier
)[];
export type AzureSasTokenFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  success?: FieldPolicy<any> | FieldReadFunction<any>;
  token?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CountryKeySpecifier = ("countryCode" | CountryKeySpecifier)[];
export type CountryFieldPolicy = {
  countryCode?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateLocationTargetResponseKeySpecifier = (
  | "id"
  | CreateLocationTargetResponseKeySpecifier
)[];
export type CreateLocationTargetResponseFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DailyAdjustmentKeySpecifier = (
  | "day"
  | "hourlyAdjustments"
  | "locationId"
  | "locationTitle"
  | "operationalDate"
  | DailyAdjustmentKeySpecifier
)[];
export type DailyAdjustmentFieldPolicy = {
  day?: FieldPolicy<any> | FieldReadFunction<any>;
  hourlyAdjustments?: FieldPolicy<any> | FieldReadFunction<any>;
  locationId?: FieldPolicy<any> | FieldReadFunction<any>;
  locationTitle?: FieldPolicy<any> | FieldReadFunction<any>;
  operationalDate?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DailyMissingLocationKeySpecifier = (
  | "date"
  | "forecasterId"
  | "locationId"
  | "missingInDoppler"
  | DailyMissingLocationKeySpecifier
)[];
export type DailyMissingLocationFieldPolicy = {
  date?: FieldPolicy<any> | FieldReadFunction<any>;
  forecasterId?: FieldPolicy<any> | FieldReadFunction<any>;
  locationId?: FieldPolicy<any> | FieldReadFunction<any>;
  missingInDoppler?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DopplerQAKeySpecifier = (
  | "dopplerRunDateTime"
  | "qaRunDateTime"
  | "weeklyQAByCountry"
  | DopplerQAKeySpecifier
)[];
export type DopplerQAFieldPolicy = {
  dopplerRunDateTime?: FieldPolicy<any> | FieldReadFunction<any>;
  qaRunDateTime?: FieldPolicy<any> | FieldReadFunction<any>;
  weeklyQAByCountry?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DopplerRunKeySpecifier = (
  | "dopplerRunDateTime"
  | "dopplerRunId"
  | DopplerRunKeySpecifier
)[];
export type DopplerRunFieldPolicy = {
  dopplerRunDateTime?: FieldPolicy<any> | FieldReadFunction<any>;
  dopplerRunId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EibKeySpecifier = (
  | "end_datetime"
  | "header_key"
  | "line_key"
  | "quantity"
  | "schedule_tag_value_id_type1"
  | "schedule_tag_value_id_type2"
  | "scheduling_organization"
  | "start_datetime"
  | "subgroup_organization"
  | EibKeySpecifier
)[];
export type EibFieldPolicy = {
  end_datetime?: FieldPolicy<any> | FieldReadFunction<any>;
  header_key?: FieldPolicy<any> | FieldReadFunction<any>;
  line_key?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity?: FieldPolicy<any> | FieldReadFunction<any>;
  schedule_tag_value_id_type1?: FieldPolicy<any> | FieldReadFunction<any>;
  schedule_tag_value_id_type2?: FieldPolicy<any> | FieldReadFunction<any>;
  scheduling_organization?: FieldPolicy<any> | FieldReadFunction<any>;
  start_datetime?: FieldPolicy<any> | FieldReadFunction<any>;
  subgroup_organization?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EventAdjustmentKeySpecifier = (
  | "adjustments"
  | "id"
  | "locationIds"
  | "locationIdsInTag"
  | "name"
  | "operationalWeekStartDate"
  | "orderSum"
  | "tag"
  | EventAdjustmentKeySpecifier
)[];
export type EventAdjustmentFieldPolicy = {
  adjustments?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  locationIds?: FieldPolicy<any> | FieldReadFunction<any>;
  locationIdsInTag?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  operationalWeekStartDate?: FieldPolicy<any> | FieldReadFunction<any>;
  orderSum?: FieldPolicy<any> | FieldReadFunction<any>;
  tag?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EventAdjustmentTotalKeySpecifier = (
  | "tag"
  | "total"
  | EventAdjustmentTotalKeySpecifier
)[];
export type EventAdjustmentTotalFieldPolicy = {
  tag?: FieldPolicy<any> | FieldReadFunction<any>;
  total?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ForecastDriverHourKeySpecifier = (
  | "baselineOdh"
  | "batch"
  | "clampedOdh"
  | "createdAt"
  | "forecastLocalTime"
  | "forecastUtcTime"
  | "hours"
  | "id"
  | "locationId"
  | "mode"
  | "orders"
  | "scaledOdh"
  | "updatedAt"
  | ForecastDriverHourKeySpecifier
)[];
export type ForecastDriverHourFieldPolicy = {
  baselineOdh?: FieldPolicy<any> | FieldReadFunction<any>;
  batch?: FieldPolicy<any> | FieldReadFunction<any>;
  clampedOdh?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  forecastLocalTime?: FieldPolicy<any> | FieldReadFunction<any>;
  forecastUtcTime?: FieldPolicy<any> | FieldReadFunction<any>;
  hours?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  locationId?: FieldPolicy<any> | FieldReadFunction<any>;
  mode?: FieldPolicy<any> | FieldReadFunction<any>;
  orders?: FieldPolicy<any> | FieldReadFunction<any>;
  scaledOdh?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ForecastNetworkDriverHourKeySpecifier = (
  | "baselineOdh"
  | "clampedOdh"
  | "createdAt"
  | "forecastUtcTime"
  | "hours"
  | "mode"
  | "orders"
  | "scaledOdh"
  | "updatedAt"
  | ForecastNetworkDriverHourKeySpecifier
)[];
export type ForecastNetworkDriverHourFieldPolicy = {
  baselineOdh?: FieldPolicy<any> | FieldReadFunction<any>;
  clampedOdh?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  forecastUtcTime?: FieldPolicy<any> | FieldReadFunction<any>;
  hours?: FieldPolicy<any> | FieldReadFunction<any>;
  mode?: FieldPolicy<any> | FieldReadFunction<any>;
  orders?: FieldPolicy<any> | FieldReadFunction<any>;
  scaledOdh?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ForecasterKeySpecifier = ("id" | ForecasterKeySpecifier)[];
export type ForecasterFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HourlyDriverHoursKeySpecifier = (
  | "dates"
  | "hours"
  | HourlyDriverHoursKeySpecifier
)[];
export type HourlyDriverHoursFieldPolicy = {
  dates?: FieldPolicy<any> | FieldReadFunction<any>;
  hours?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HourlyMissingLocationKeySpecifier = (
  | "datetime"
  | "forecasterId"
  | "locationId"
  | "missingInDoppler"
  | HourlyMissingLocationKeySpecifier
)[];
export type HourlyMissingLocationFieldPolicy = {
  datetime?: FieldPolicy<any> | FieldReadFunction<any>;
  forecasterId?: FieldPolicy<any> | FieldReadFunction<any>;
  locationId?: FieldPolicy<any> | FieldReadFunction<any>;
  missingInDoppler?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HourlyOVFKeySpecifier = (
  | "dates"
  | "ovfs"
  | HourlyOVFKeySpecifier
)[];
export type HourlyOVFFieldPolicy = {
  dates?: FieldPolicy<any> | FieldReadFunction<any>;
  ovfs?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InvalidShiftKeySpecifier = (
  | "date"
  | "delivery_method"
  | "driver_slots"
  | "end_time"
  | "error"
  | "location"
  | "location_id"
  | "position"
  | "start_time"
  | "time"
  | "weekday"
  | InvalidShiftKeySpecifier
)[];
export type InvalidShiftFieldPolicy = {
  date?: FieldPolicy<any> | FieldReadFunction<any>;
  delivery_method?: FieldPolicy<any> | FieldReadFunction<any>;
  driver_slots?: FieldPolicy<any> | FieldReadFunction<any>;
  end_time?: FieldPolicy<any> | FieldReadFunction<any>;
  error?: FieldPolicy<any> | FieldReadFunction<any>;
  location?: FieldPolicy<any> | FieldReadFunction<any>;
  location_id?: FieldPolicy<any> | FieldReadFunction<any>;
  position?: FieldPolicy<any> | FieldReadFunction<any>;
  start_time?: FieldPolicy<any> | FieldReadFunction<any>;
  time?: FieldPolicy<any> | FieldReadFunction<any>;
  weekday?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ItemForecastKeySpecifier = (
  | "adjustedForecast"
  | "dsForecastStartedAt"
  | "finalForecast"
  | "forecastedDate"
  | "locationId"
  | "modelForecast"
  | "o9ExtractDate"
  | "o9LoadDate"
  | "productId"
  | "validFrom"
  | "validTo"
  | ItemForecastKeySpecifier
)[];
export type ItemForecastFieldPolicy = {
  adjustedForecast?: FieldPolicy<any> | FieldReadFunction<any>;
  dsForecastStartedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  finalForecast?: FieldPolicy<any> | FieldReadFunction<any>;
  forecastedDate?: FieldPolicy<any> | FieldReadFunction<any>;
  locationId?: FieldPolicy<any> | FieldReadFunction<any>;
  modelForecast?: FieldPolicy<any> | FieldReadFunction<any>;
  o9ExtractDate?: FieldPolicy<any> | FieldReadFunction<any>;
  o9LoadDate?: FieldPolicy<any> | FieldReadFunction<any>;
  productId?: FieldPolicy<any> | FieldReadFunction<any>;
  validFrom?: FieldPolicy<any> | FieldReadFunction<any>;
  validTo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JobKeySpecifier = ("runs" | JobKeySpecifier)[];
export type JobFieldPolicy = {
  runs?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JobStatusKeySpecifier = (
  | "endDate"
  | "startDate"
  | "status"
  | JobStatusKeySpecifier
)[];
export type JobStatusFieldPolicy = {
  endDate?: FieldPolicy<any> | FieldReadFunction<any>;
  startDate?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LocationKeySpecifier = (
  | "dailyThreeWeekTrailingAverage"
  | "dopplerForecast"
  | "driverHours"
  | "eventAdjustmentTotals"
  | "forecasterId"
  | "id"
  | "ovf"
  | "seasonalityAdjustments"
  | "target"
  | "threeWeekOrderHistory"
  | "threeWeekTrailingAverage"
  | "title"
  | LocationKeySpecifier
)[];
export type LocationFieldPolicy = {
  dailyThreeWeekTrailingAverage?: FieldPolicy<any> | FieldReadFunction<any>;
  dopplerForecast?: FieldPolicy<any> | FieldReadFunction<any>;
  driverHours?: FieldPolicy<any> | FieldReadFunction<any>;
  eventAdjustmentTotals?: FieldPolicy<any> | FieldReadFunction<any>;
  forecasterId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  ovf?: FieldPolicy<any> | FieldReadFunction<any>;
  seasonalityAdjustments?: FieldPolicy<any> | FieldReadFunction<any>;
  target?: FieldPolicy<any> | FieldReadFunction<any>;
  threeWeekOrderHistory?: FieldPolicy<any> | FieldReadFunction<any>;
  threeWeekTrailingAverage?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LocationConnectionKeySpecifier = (
  | "edges"
  | "pageInfo"
  | "totalCount"
  | LocationConnectionKeySpecifier
)[];
export type LocationConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  totalCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LocationEdgeKeySpecifier = (
  | "cursor"
  | "node"
  | LocationEdgeKeySpecifier
)[];
export type LocationEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LocationTargetKeySpecifier = (
  | "absenteeAdjustBike"
  | "absenteeAdjustCar"
  | "absenteeAdjustFoot"
  | "absenteeismCap"
  | "absenteeismCutPremium"
  | "absenteeismLookbackWindow"
  | "absenteeismPercentile"
  | "constrainFlag"
  | "driverWaitTime"
  | "id"
  | "locationId"
  | "locationTargetId"
  | "maxODH"
  | "minODH"
  | "mindpBike"
  | "mindpCar"
  | "mindpFoot"
  | "openFromOverride"
  | "openToOverride"
  | "shiftIncrement"
  | "shiftPad"
  | "skipMui"
  | "taperPreset"
  | "targetDate"
  | "targetODH"
  | "title"
  | "unscheduledCap"
  | "unscheduledCutPremium"
  | "unscheduledPenalty"
  | "unscheduledPercentile"
  | LocationTargetKeySpecifier
)[];
export type LocationTargetFieldPolicy = {
  absenteeAdjustBike?: FieldPolicy<any> | FieldReadFunction<any>;
  absenteeAdjustCar?: FieldPolicy<any> | FieldReadFunction<any>;
  absenteeAdjustFoot?: FieldPolicy<any> | FieldReadFunction<any>;
  absenteeismCap?: FieldPolicy<any> | FieldReadFunction<any>;
  absenteeismCutPremium?: FieldPolicy<any> | FieldReadFunction<any>;
  absenteeismLookbackWindow?: FieldPolicy<any> | FieldReadFunction<any>;
  absenteeismPercentile?: FieldPolicy<any> | FieldReadFunction<any>;
  constrainFlag?: FieldPolicy<any> | FieldReadFunction<any>;
  driverWaitTime?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  locationId?: FieldPolicy<any> | FieldReadFunction<any>;
  locationTargetId?: FieldPolicy<any> | FieldReadFunction<any>;
  maxODH?: FieldPolicy<any> | FieldReadFunction<any>;
  minODH?: FieldPolicy<any> | FieldReadFunction<any>;
  mindpBike?: FieldPolicy<any> | FieldReadFunction<any>;
  mindpCar?: FieldPolicy<any> | FieldReadFunction<any>;
  mindpFoot?: FieldPolicy<any> | FieldReadFunction<any>;
  openFromOverride?: FieldPolicy<any> | FieldReadFunction<any>;
  openToOverride?: FieldPolicy<any> | FieldReadFunction<any>;
  shiftIncrement?: FieldPolicy<any> | FieldReadFunction<any>;
  shiftPad?: FieldPolicy<any> | FieldReadFunction<any>;
  skipMui?: FieldPolicy<any> | FieldReadFunction<any>;
  taperPreset?: FieldPolicy<any> | FieldReadFunction<any>;
  targetDate?: FieldPolicy<any> | FieldReadFunction<any>;
  targetODH?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  unscheduledCap?: FieldPolicy<any> | FieldReadFunction<any>;
  unscheduledCutPremium?: FieldPolicy<any> | FieldReadFunction<any>;
  unscheduledPenalty?: FieldPolicy<any> | FieldReadFunction<any>;
  unscheduledPercentile?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LocationTargetConnectionKeySpecifier = (
  | "edges"
  | "pageInfo"
  | "totalCount"
  | LocationTargetConnectionKeySpecifier
)[];
export type LocationTargetConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  totalCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LocationTargetEdgeKeySpecifier = (
  | "cursor"
  | "node"
  | LocationTargetEdgeKeySpecifier
)[];
export type LocationTargetEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LocationsByMetroRegionKeySpecifier = (
  | "locationIds"
  | "name"
  | LocationsByMetroRegionKeySpecifier
)[];
export type LocationsByMetroRegionFieldPolicy = {
  locationIds?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MidweekReforecastKeySpecifier = (
  | "actuals"
  | "dailyReforecastAdjustment"
  | "dopplerRunActive"
  | "dopplerRunPublished"
  | "dopplerVsDoppler"
  | "other"
  | "ovfPublished"
  | "ovfPublishedVsActualsOrProjection"
  | "ovfReforecast"
  | "ovfReforecastVsProjection"
  | "partners"
  | "planning"
  | "projection"
  | "promos"
  | "referrals"
  | "seasonalAdjustments"
  | "totalAdjustments"
  | MidweekReforecastKeySpecifier
)[];
export type MidweekReforecastFieldPolicy = {
  actuals?: FieldPolicy<any> | FieldReadFunction<any>;
  dailyReforecastAdjustment?: FieldPolicy<any> | FieldReadFunction<any>;
  dopplerRunActive?: FieldPolicy<any> | FieldReadFunction<any>;
  dopplerRunPublished?: FieldPolicy<any> | FieldReadFunction<any>;
  dopplerVsDoppler?: FieldPolicy<any> | FieldReadFunction<any>;
  other?: FieldPolicy<any> | FieldReadFunction<any>;
  ovfPublished?: FieldPolicy<any> | FieldReadFunction<any>;
  ovfPublishedVsActualsOrProjection?: FieldPolicy<any> | FieldReadFunction<any>;
  ovfReforecast?: FieldPolicy<any> | FieldReadFunction<any>;
  ovfReforecastVsProjection?: FieldPolicy<any> | FieldReadFunction<any>;
  partners?: FieldPolicy<any> | FieldReadFunction<any>;
  planning?: FieldPolicy<any> | FieldReadFunction<any>;
  projection?: FieldPolicy<any> | FieldReadFunction<any>;
  promos?: FieldPolicy<any> | FieldReadFunction<any>;
  referrals?: FieldPolicy<any> | FieldReadFunction<any>;
  seasonalAdjustments?: FieldPolicy<any> | FieldReadFunction<any>;
  totalAdjustments?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MostRecentAdjustedHoursUploadKeySpecifier = (
  | "date"
  | MostRecentAdjustedHoursUploadKeySpecifier
)[];
export type MostRecentAdjustedHoursUploadFieldPolicy = {
  date?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MostRecentLaborMappingUploadKeySpecifier = (
  | "date"
  | MostRecentLaborMappingUploadKeySpecifier
)[];
export type MostRecentLaborMappingUploadFieldPolicy = {
  date?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MostRecentOaLaborUploadKeySpecifier = (
  | "date"
  | MostRecentOaLaborUploadKeySpecifier
)[];
export type MostRecentOaLaborUploadFieldPolicy = {
  date?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MostRecentOdhTransformJobKeySpecifier = (
  | "batch"
  | "date"
  | MostRecentOdhTransformJobKeySpecifier
)[];
export type MostRecentOdhTransformJobFieldPolicy = {
  batch?: FieldPolicy<any> | FieldReadFunction<any>;
  date?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MostRecentOdhTransformRunKeySpecifier = (
  | "endDate"
  | "startDate"
  | "status"
  | MostRecentOdhTransformRunKeySpecifier
)[];
export type MostRecentOdhTransformRunFieldPolicy = {
  endDate?: FieldPolicy<any> | FieldReadFunction<any>;
  startDate?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MultiModalHourlyDataKeySpecifier = (
  | "mode"
  | "values"
  | MultiModalHourlyDataKeySpecifier
)[];
export type MultiModalHourlyDataFieldPolicy = {
  mode?: FieldPolicy<any> | FieldReadFunction<any>;
  values?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MultiweekForecastKeySpecifier = (
  | "activeDopplerWeeklyTotals"
  | "adjustmentsWeeklyTotals"
  | "adjustmentsWeeklyTotalsGrowthRates"
  | "lastYearActualsByWeek"
  | "lastYearActualsByWeekGrowthRates"
  | "ovfPublishedByWeek"
  | "ovfPublishedByWeekGrowthRates"
  | "thisYearActualsByWeek"
  | "thisYearActualsByWeekGrowthRates"
  | MultiweekForecastKeySpecifier
)[];
export type MultiweekForecastFieldPolicy = {
  activeDopplerWeeklyTotals?: FieldPolicy<any> | FieldReadFunction<any>;
  adjustmentsWeeklyTotals?: FieldPolicy<any> | FieldReadFunction<any>;
  adjustmentsWeeklyTotalsGrowthRates?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  lastYearActualsByWeek?: FieldPolicy<any> | FieldReadFunction<any>;
  lastYearActualsByWeekGrowthRates?: FieldPolicy<any> | FieldReadFunction<any>;
  ovfPublishedByWeek?: FieldPolicy<any> | FieldReadFunction<any>;
  ovfPublishedByWeekGrowthRates?: FieldPolicy<any> | FieldReadFunction<any>;
  thisYearActualsByWeek?: FieldPolicy<any> | FieldReadFunction<any>;
  thisYearActualsByWeekGrowthRates?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MutationKeySpecifier = (
  | "approveAndReleaseShifts"
  | "cancelAllJobRuns"
  | "createGlobalAdjustmentLayer"
  | "createLocationTargets"
  | "createOrEditReforecastLayer"
  | "deleteEventAdjustment"
  | "deleteShifts"
  | "generateSasToken"
  | "publishShifterShifts"
  | "publishShifts"
  | "refreshEibView"
  | "runGoSked"
  | "runOaShifter"
  | "setAllHourlyAdjustmentsToHistoricalAverage"
  | "setSelectedDopplerRun"
  | "startOdhTransform"
  | "startShifterPipeline"
  | "submitAdjustedOvf"
  | "submitMidweekReforecastAdjustedOvf"
  | "submitShifterShifts"
  | "submitShifts"
  | "triggerJobRun"
  | "updateForecastersAndForecasterAssignments"
  | "updateLocationTargets"
  | "uploadDriverHoursCsv"
  | "uploadEventAdjustmentCsv"
  | "uploadIncrementalAdjustedDriverHoursCsv"
  | "uploadLocationTargets"
  | "uploadOAHours"
  | "uploadOaLaborMapping"
  | "uploadOvfCsv"
  | "uploadShiftLeaderShiftRequests"
  | "uploadShiftsReportingBundle"
  | "upsertSeasonalAdjustment"
  | "validateShifterShifts"
  | MutationKeySpecifier
)[];
export type MutationFieldPolicy = {
  approveAndReleaseShifts?: FieldPolicy<any> | FieldReadFunction<any>;
  cancelAllJobRuns?: FieldPolicy<any> | FieldReadFunction<any>;
  createGlobalAdjustmentLayer?: FieldPolicy<any> | FieldReadFunction<any>;
  createLocationTargets?: FieldPolicy<any> | FieldReadFunction<any>;
  createOrEditReforecastLayer?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteEventAdjustment?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteShifts?: FieldPolicy<any> | FieldReadFunction<any>;
  generateSasToken?: FieldPolicy<any> | FieldReadFunction<any>;
  publishShifterShifts?: FieldPolicy<any> | FieldReadFunction<any>;
  publishShifts?: FieldPolicy<any> | FieldReadFunction<any>;
  refreshEibView?: FieldPolicy<any> | FieldReadFunction<any>;
  runGoSked?: FieldPolicy<any> | FieldReadFunction<any>;
  runOaShifter?: FieldPolicy<any> | FieldReadFunction<any>;
  setAllHourlyAdjustmentsToHistoricalAverage?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  setSelectedDopplerRun?: FieldPolicy<any> | FieldReadFunction<any>;
  startOdhTransform?: FieldPolicy<any> | FieldReadFunction<any>;
  startShifterPipeline?: FieldPolicy<any> | FieldReadFunction<any>;
  submitAdjustedOvf?: FieldPolicy<any> | FieldReadFunction<any>;
  submitMidweekReforecastAdjustedOvf?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  submitShifterShifts?: FieldPolicy<any> | FieldReadFunction<any>;
  submitShifts?: FieldPolicy<any> | FieldReadFunction<any>;
  triggerJobRun?: FieldPolicy<any> | FieldReadFunction<any>;
  updateForecastersAndForecasterAssignments?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  updateLocationTargets?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadDriverHoursCsv?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadEventAdjustmentCsv?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadIncrementalAdjustedDriverHoursCsv?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  uploadLocationTargets?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadOAHours?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadOaLaborMapping?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadOvfCsv?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadShiftLeaderShiftRequests?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadShiftsReportingBundle?: FieldPolicy<any> | FieldReadFunction<any>;
  upsertSeasonalAdjustment?: FieldPolicy<any> | FieldReadFunction<any>;
  validateShifterShifts?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NotebookParamsKeySpecifier = (
  | "run_time"
  | NotebookParamsKeySpecifier
)[];
export type NotebookParamsFieldPolicy = {
  run_time?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OVFShiftKeySpecifier = (
  | "ODH"
  | "OVF"
  | "date"
  | "driverHours"
  | "locationId"
  | "shiftFill"
  | OVFShiftKeySpecifier
)[];
export type OVFShiftFieldPolicy = {
  ODH?: FieldPolicy<any> | FieldReadFunction<any>;
  OVF?: FieldPolicy<any> | FieldReadFunction<any>;
  date?: FieldPolicy<any> | FieldReadFunction<any>;
  driverHours?: FieldPolicy<any> | FieldReadFunction<any>;
  locationId?: FieldPolicy<any> | FieldReadFunction<any>;
  shiftFill?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OaDriverHoursRunKeySpecifier = (
  | "createdAt"
  | "id"
  | "name"
  | "operationalWeekStartDate"
  | "ophRunsId"
  | "source"
  | OaDriverHoursRunKeySpecifier
)[];
export type OaDriverHoursRunFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  operationalWeekStartDate?: FieldPolicy<any> | FieldReadFunction<any>;
  ophRunsId?: FieldPolicy<any> | FieldReadFunction<any>;
  source?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OaLaborHoursKeySpecifier = (
  | "created_at"
  | "gosked_hours"
  | "gosked_inbound_hours"
  | "gosked_pack_hours"
  | "gosked_total_hours"
  | "id"
  | "local_time"
  | "location_id"
  | "location_name"
  | "ops_date"
  | "role"
  | OaLaborHoursKeySpecifier
)[];
export type OaLaborHoursFieldPolicy = {
  created_at?: FieldPolicy<any> | FieldReadFunction<any>;
  gosked_hours?: FieldPolicy<any> | FieldReadFunction<any>;
  gosked_inbound_hours?: FieldPolicy<any> | FieldReadFunction<any>;
  gosked_pack_hours?: FieldPolicy<any> | FieldReadFunction<any>;
  gosked_total_hours?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  local_time?: FieldPolicy<any> | FieldReadFunction<any>;
  location_id?: FieldPolicy<any> | FieldReadFunction<any>;
  location_name?: FieldPolicy<any> | FieldReadFunction<any>;
  ops_date?: FieldPolicy<any> | FieldReadFunction<any>;
  role?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OaLocationKeySpecifier = (
  | "country_code"
  | "created_at"
  | "location_id"
  | "location_name"
  | "metro_region"
  | "state_code"
  | "updated_at"
  | OaLocationKeySpecifier
)[];
export type OaLocationFieldPolicy = {
  country_code?: FieldPolicy<any> | FieldReadFunction<any>;
  created_at?: FieldPolicy<any> | FieldReadFunction<any>;
  location_id?: FieldPolicy<any> | FieldReadFunction<any>;
  location_name?: FieldPolicy<any> | FieldReadFunction<any>;
  metro_region?: FieldPolicy<any> | FieldReadFunction<any>;
  state_code?: FieldPolicy<any> | FieldReadFunction<any>;
  updated_at?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OaLocationClusterKeySpecifier = (
  | "created_at"
  | "id"
  | "location_ids"
  | "name"
  | "updated_at"
  | OaLocationClusterKeySpecifier
)[];
export type OaLocationClusterFieldPolicy = {
  created_at?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  location_ids?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  updated_at?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OaShiftKeySpecifier = (
  | "endTime"
  | "length"
  | "locationName"
  | "opsDate"
  | "shiftLeader"
  | "startTime"
  | "weekday"
  | OaShiftKeySpecifier
)[];
export type OaShiftFieldPolicy = {
  endTime?: FieldPolicy<any> | FieldReadFunction<any>;
  length?: FieldPolicy<any> | FieldReadFunction<any>;
  locationName?: FieldPolicy<any> | FieldReadFunction<any>;
  opsDate?: FieldPolicy<any> | FieldReadFunction<any>;
  shiftLeader?: FieldPolicy<any> | FieldReadFunction<any>;
  startTime?: FieldPolicy<any> | FieldReadFunction<any>;
  weekday?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OdhTransformKeySpecifier = (
  | "baseline_odh"
  | "batch"
  | "clamped_odh"
  | "created_at"
  | "forecast_local_time"
  | "hours"
  | "id"
  | "location_id"
  | "orders"
  | "scaled_odh"
  | "updated_at"
  | OdhTransformKeySpecifier
)[];
export type OdhTransformFieldPolicy = {
  baseline_odh?: FieldPolicy<any> | FieldReadFunction<any>;
  batch?: FieldPolicy<any> | FieldReadFunction<any>;
  clamped_odh?: FieldPolicy<any> | FieldReadFunction<any>;
  created_at?: FieldPolicy<any> | FieldReadFunction<any>;
  forecast_local_time?: FieldPolicy<any> | FieldReadFunction<any>;
  hours?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  location_id?: FieldPolicy<any> | FieldReadFunction<any>;
  orders?: FieldPolicy<any> | FieldReadFunction<any>;
  scaled_odh?: FieldPolicy<any> | FieldReadFunction<any>;
  updated_at?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OdhTransformPayloadKeySpecifier = (
  | "odhTransform"
  | OdhTransformPayloadKeySpecifier
)[];
export type OdhTransformPayloadFieldPolicy = {
  odhTransform?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OverridingParametersKeySpecifier = (
  | "notebook_params"
  | OverridingParametersKeySpecifier
)[];
export type OverridingParametersFieldPolicy = {
  notebook_params?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OvfHourKeySpecifier = (
  | "forecastLocalTime"
  | "forecastUtcTime"
  | "id"
  | "loadTimestamp"
  | "locationId"
  | "locationName"
  | "ovfSource"
  | "runDate"
  | "runId"
  | "yhat"
  | OvfHourKeySpecifier
)[];
export type OvfHourFieldPolicy = {
  forecastLocalTime?: FieldPolicy<any> | FieldReadFunction<any>;
  forecastUtcTime?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  loadTimestamp?: FieldPolicy<any> | FieldReadFunction<any>;
  locationId?: FieldPolicy<any> | FieldReadFunction<any>;
  locationName?: FieldPolicy<any> | FieldReadFunction<any>;
  ovfSource?: FieldPolicy<any> | FieldReadFunction<any>;
  runDate?: FieldPolicy<any> | FieldReadFunction<any>;
  runId?: FieldPolicy<any> | FieldReadFunction<any>;
  yhat?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OvfHourNetworkKeySpecifier = (
  | "forecastUtcTime"
  | "loadTimestamp"
  | "ovfSource"
  | "runDate"
  | "yhat"
  | OvfHourNetworkKeySpecifier
)[];
export type OvfHourNetworkFieldPolicy = {
  forecastUtcTime?: FieldPolicy<any> | FieldReadFunction<any>;
  loadTimestamp?: FieldPolicy<any> | FieldReadFunction<any>;
  ovfSource?: FieldPolicy<any> | FieldReadFunction<any>;
  runDate?: FieldPolicy<any> | FieldReadFunction<any>;
  yhat?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PageInfoKeySpecifier = (
  | "endCursor"
  | "hasNextPage"
  | "hasPreviousPage"
  | "startCursor"
  | PageInfoKeySpecifier
)[];
export type PageInfoFieldPolicy = {
  endCursor?: FieldPolicy<any> | FieldReadFunction<any>;
  hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>;
  hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>;
  startCursor?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PublishShiftsResponseKeySpecifier = (
  | "invalidShiftIds"
  | "success"
  | PublishShiftsResponseKeySpecifier
)[];
export type PublishShiftsResponseFieldPolicy = {
  invalidShiftIds?: FieldPolicy<any> | FieldReadFunction<any>;
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PublishSuccessResponseKeySpecifier = (
  | "locationId"
  | "message"
  | "publishedShiftsCount"
  | "success"
  | PublishSuccessResponseKeySpecifier
)[];
export type PublishSuccessResponseFieldPolicy = {
  locationId?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  publishedShiftsCount?: FieldPolicy<any> | FieldReadFunction<any>;
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PublishedOvfKeySpecifier = (
  | "locationId"
  | "ovfs"
  | PublishedOvfKeySpecifier
)[];
export type PublishedOvfFieldPolicy = {
  locationId?: FieldPolicy<any> | FieldReadFunction<any>;
  ovfs?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QueryKeySpecifier = (
  | "adjustedDriverHourLocations"
  | "countries"
  | "currentlyActiveDopplerRunDate"
  | "dopplerQA"
  | "dopplerRunTimestampsThisWeek"
  | "eibXlsxUrl"
  | "eventAdjustmentTotalsByDay"
  | "eventAdjustments"
  | "forecastDriverHours"
  | "forecastLocationsByMetroRegions"
  | "forecastNetworkDriverHours"
  | "forecasters"
  | "getAdjustedDriverHoursRunsForWeek"
  | "getAdjustedOaHours"
  | "getAdjustedOaHoursRunsForWeek"
  | "getLatestJobStatus"
  | "getMostRecentLaborMappingUploadTimestamp"
  | "getMostRecentOaLaborUploadTimestamp"
  | "getRun"
  | "getRunsList"
  | "getSasUrlForFileInDSBlobStorage"
  | "getShiftLeaderShiftRequests"
  | "getShifts"
  | "itemForecast"
  | "locationTargets"
  | "locations"
  | "metroRegions"
  | "midweekReforecast"
  | "mostRecentAdjustedHoursUploadDate"
  | "mostRecentOdhTransformJobDate"
  | "mostRecentOdhTransformRun"
  | "mostRecentOvfSubmit"
  | "mostRecentShiftsApprovalTimestamp"
  | "mostRecentShiftsPublishTimestamp"
  | "mostRecentShiftsReportingBundleUploadTimestamp"
  | "multiweekForecast"
  | "oaLocationClusters"
  | "oaLocations"
  | "oaShifts"
  | "odhLocations"
  | "ovfHours"
  | "ovfHoursNetwork"
  | "ovfQaLocations"
  | "ovfShifts"
  | "publishedOvf"
  | "secret"
  | "shifterPipelineRunsId"
  | "shifterState"
  | "shifterStatus"
  | "shifts"
  | "shiftsDailyQA"
  | "shiftsDailyQATotal"
  | "shiftsHourlyQaCsvUrl"
  | "shiftsHours"
  | "shiftsQALocationsByMetroRegions"
  | "shiftsWeeklyQA"
  | "shiftsWeeklyQATotal"
  | "weeklyAdjustLocations"
  | QueryKeySpecifier
)[];
export type QueryFieldPolicy = {
  adjustedDriverHourLocations?: FieldPolicy<any> | FieldReadFunction<any>;
  countries?: FieldPolicy<any> | FieldReadFunction<any>;
  currentlyActiveDopplerRunDate?: FieldPolicy<any> | FieldReadFunction<any>;
  dopplerQA?: FieldPolicy<any> | FieldReadFunction<any>;
  dopplerRunTimestampsThisWeek?: FieldPolicy<any> | FieldReadFunction<any>;
  eibXlsxUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  eventAdjustmentTotalsByDay?: FieldPolicy<any> | FieldReadFunction<any>;
  eventAdjustments?: FieldPolicy<any> | FieldReadFunction<any>;
  forecastDriverHours?: FieldPolicy<any> | FieldReadFunction<any>;
  forecastLocationsByMetroRegions?: FieldPolicy<any> | FieldReadFunction<any>;
  forecastNetworkDriverHours?: FieldPolicy<any> | FieldReadFunction<any>;
  forecasters?: FieldPolicy<any> | FieldReadFunction<any>;
  getAdjustedDriverHoursRunsForWeek?: FieldPolicy<any> | FieldReadFunction<any>;
  getAdjustedOaHours?: FieldPolicy<any> | FieldReadFunction<any>;
  getAdjustedOaHoursRunsForWeek?: FieldPolicy<any> | FieldReadFunction<any>;
  getLatestJobStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  getMostRecentLaborMappingUploadTimestamp?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  getMostRecentOaLaborUploadTimestamp?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  getRun?: FieldPolicy<any> | FieldReadFunction<any>;
  getRunsList?: FieldPolicy<any> | FieldReadFunction<any>;
  getSasUrlForFileInDSBlobStorage?: FieldPolicy<any> | FieldReadFunction<any>;
  getShiftLeaderShiftRequests?: FieldPolicy<any> | FieldReadFunction<any>;
  getShifts?: FieldPolicy<any> | FieldReadFunction<any>;
  itemForecast?: FieldPolicy<any> | FieldReadFunction<any>;
  locationTargets?: FieldPolicy<any> | FieldReadFunction<any>;
  locations?: FieldPolicy<any> | FieldReadFunction<any>;
  metroRegions?: FieldPolicy<any> | FieldReadFunction<any>;
  midweekReforecast?: FieldPolicy<any> | FieldReadFunction<any>;
  mostRecentAdjustedHoursUploadDate?: FieldPolicy<any> | FieldReadFunction<any>;
  mostRecentOdhTransformJobDate?: FieldPolicy<any> | FieldReadFunction<any>;
  mostRecentOdhTransformRun?: FieldPolicy<any> | FieldReadFunction<any>;
  mostRecentOvfSubmit?: FieldPolicy<any> | FieldReadFunction<any>;
  mostRecentShiftsApprovalTimestamp?: FieldPolicy<any> | FieldReadFunction<any>;
  mostRecentShiftsPublishTimestamp?: FieldPolicy<any> | FieldReadFunction<any>;
  mostRecentShiftsReportingBundleUploadTimestamp?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  multiweekForecast?: FieldPolicy<any> | FieldReadFunction<any>;
  oaLocationClusters?: FieldPolicy<any> | FieldReadFunction<any>;
  oaLocations?: FieldPolicy<any> | FieldReadFunction<any>;
  oaShifts?: FieldPolicy<any> | FieldReadFunction<any>;
  odhLocations?: FieldPolicy<any> | FieldReadFunction<any>;
  ovfHours?: FieldPolicy<any> | FieldReadFunction<any>;
  ovfHoursNetwork?: FieldPolicy<any> | FieldReadFunction<any>;
  ovfQaLocations?: FieldPolicy<any> | FieldReadFunction<any>;
  ovfShifts?: FieldPolicy<any> | FieldReadFunction<any>;
  publishedOvf?: FieldPolicy<any> | FieldReadFunction<any>;
  secret?: FieldPolicy<any> | FieldReadFunction<any>;
  shifterPipelineRunsId?: FieldPolicy<any> | FieldReadFunction<any>;
  shifterState?: FieldPolicy<any> | FieldReadFunction<any>;
  shifterStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  shifts?: FieldPolicy<any> | FieldReadFunction<any>;
  shiftsDailyQA?: FieldPolicy<any> | FieldReadFunction<any>;
  shiftsDailyQATotal?: FieldPolicy<any> | FieldReadFunction<any>;
  shiftsHourlyQaCsvUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  shiftsHours?: FieldPolicy<any> | FieldReadFunction<any>;
  shiftsQALocationsByMetroRegions?: FieldPolicy<any> | FieldReadFunction<any>;
  shiftsWeeklyQA?: FieldPolicy<any> | FieldReadFunction<any>;
  shiftsWeeklyQATotal?: FieldPolicy<any> | FieldReadFunction<any>;
  weeklyAdjustLocations?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RunKeySpecifier = (
  | "cleanup_duration"
  | "creator_user_name"
  | "end_time"
  | "execution_duration"
  | "format"
  | "job_id"
  | "number_in_job"
  | "original_attempt_run_id"
  | "overriding_parameters"
  | "run_id"
  | "run_name"
  | "run_page_url"
  | "run_type"
  | "setup_duration"
  | "start_time"
  | "state"
  | "trigger"
  | RunKeySpecifier
)[];
export type RunFieldPolicy = {
  cleanup_duration?: FieldPolicy<any> | FieldReadFunction<any>;
  creator_user_name?: FieldPolicy<any> | FieldReadFunction<any>;
  end_time?: FieldPolicy<any> | FieldReadFunction<any>;
  execution_duration?: FieldPolicy<any> | FieldReadFunction<any>;
  format?: FieldPolicy<any> | FieldReadFunction<any>;
  job_id?: FieldPolicy<any> | FieldReadFunction<any>;
  number_in_job?: FieldPolicy<any> | FieldReadFunction<any>;
  original_attempt_run_id?: FieldPolicy<any> | FieldReadFunction<any>;
  overriding_parameters?: FieldPolicy<any> | FieldReadFunction<any>;
  run_id?: FieldPolicy<any> | FieldReadFunction<any>;
  run_name?: FieldPolicy<any> | FieldReadFunction<any>;
  run_page_url?: FieldPolicy<any> | FieldReadFunction<any>;
  run_type?: FieldPolicy<any> | FieldReadFunction<any>;
  setup_duration?: FieldPolicy<any> | FieldReadFunction<any>;
  start_time?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
  trigger?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SeasonalityAdjustmentsKeySpecifier = (
  | "dailyLayer"
  | "dailyOverrides"
  | "dailySeasonalityAdjustedForecastDistribution"
  | "dates"
  | "dopplerForecast"
  | "hourlyLayer"
  | "hourlyOverrides"
  | "success"
  | "totalSeasonalityAdjustedForecastDistribution"
  | "weeklyLayer"
  | "weeklyOverride"
  | SeasonalityAdjustmentsKeySpecifier
)[];
export type SeasonalityAdjustmentsFieldPolicy = {
  dailyLayer?: FieldPolicy<any> | FieldReadFunction<any>;
  dailyOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  dailySeasonalityAdjustedForecastDistribution?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  dates?: FieldPolicy<any> | FieldReadFunction<any>;
  dopplerForecast?: FieldPolicy<any> | FieldReadFunction<any>;
  hourlyLayer?: FieldPolicy<any> | FieldReadFunction<any>;
  hourlyOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  success?: FieldPolicy<any> | FieldReadFunction<any>;
  totalSeasonalityAdjustedForecastDistribution?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  weeklyLayer?: FieldPolicy<any> | FieldReadFunction<any>;
  weeklyOverride?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShiftKeySpecifier = (
  | "assignedPersonId"
  | "classificationId"
  | "createdTime"
  | "deliveryMethodId"
  | "endTime"
  | "id"
  | "isDeleted"
  | "isPublished"
  | "locationId"
  | "mustRequest"
  | "publishedTime"
  | "roleId"
  | "startTime"
  | "tags"
  | "updatedTime"
  | ShiftKeySpecifier
)[];
export type ShiftFieldPolicy = {
  assignedPersonId?: FieldPolicy<any> | FieldReadFunction<any>;
  classificationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdTime?: FieldPolicy<any> | FieldReadFunction<any>;
  deliveryMethodId?: FieldPolicy<any> | FieldReadFunction<any>;
  endTime?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isDeleted?: FieldPolicy<any> | FieldReadFunction<any>;
  isPublished?: FieldPolicy<any> | FieldReadFunction<any>;
  locationId?: FieldPolicy<any> | FieldReadFunction<any>;
  mustRequest?: FieldPolicy<any> | FieldReadFunction<any>;
  publishedTime?: FieldPolicy<any> | FieldReadFunction<any>;
  roleId?: FieldPolicy<any> | FieldReadFunction<any>;
  startTime?: FieldPolicy<any> | FieldReadFunction<any>;
  tags?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedTime?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShiftHoursKeySpecifier = (
  | "isAssigned"
  | "length"
  | "localTime"
  | "locationId"
  | "mode"
  | ShiftHoursKeySpecifier
)[];
export type ShiftHoursFieldPolicy = {
  isAssigned?: FieldPolicy<any> | FieldReadFunction<any>;
  length?: FieldPolicy<any> | FieldReadFunction<any>;
  localTime?: FieldPolicy<any> | FieldReadFunction<any>;
  locationId?: FieldPolicy<any> | FieldReadFunction<any>;
  mode?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShiftLeaderShiftRequestKeySpecifier = (
  | "created_at"
  | "day_of_week"
  | "id"
  | "length"
  | "location_id"
  | "location_name"
  | "shift_leader"
  | "start_time"
  | ShiftLeaderShiftRequestKeySpecifier
)[];
export type ShiftLeaderShiftRequestFieldPolicy = {
  created_at?: FieldPolicy<any> | FieldReadFunction<any>;
  day_of_week?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  length?: FieldPolicy<any> | FieldReadFunction<any>;
  location_id?: FieldPolicy<any> | FieldReadFunction<any>;
  location_name?: FieldPolicy<any> | FieldReadFunction<any>;
  shift_leader?: FieldPolicy<any> | FieldReadFunction<any>;
  start_time?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShiftModelOutputKeySpecifier = (
  | "createdTime"
  | "date"
  | "deliveryMode"
  | "driverSlots"
  | "endTime"
  | "length"
  | "locationId"
  | "locationName"
  | "mustRequest"
  | "position"
  | "startTime"
  | "submitStatus"
  | "updatedTime"
  | "weekday"
  | ShiftModelOutputKeySpecifier
)[];
export type ShiftModelOutputFieldPolicy = {
  createdTime?: FieldPolicy<any> | FieldReadFunction<any>;
  date?: FieldPolicy<any> | FieldReadFunction<any>;
  deliveryMode?: FieldPolicy<any> | FieldReadFunction<any>;
  driverSlots?: FieldPolicy<any> | FieldReadFunction<any>;
  endTime?: FieldPolicy<any> | FieldReadFunction<any>;
  length?: FieldPolicy<any> | FieldReadFunction<any>;
  locationId?: FieldPolicy<any> | FieldReadFunction<any>;
  locationName?: FieldPolicy<any> | FieldReadFunction<any>;
  mustRequest?: FieldPolicy<any> | FieldReadFunction<any>;
  position?: FieldPolicy<any> | FieldReadFunction<any>;
  startTime?: FieldPolicy<any> | FieldReadFunction<any>;
  submitStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedTime?: FieldPolicy<any> | FieldReadFunction<any>;
  weekday?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShifterStatusKeySpecifier = (
  | "databricksRunId"
  | "details"
  | "state"
  | ShifterStatusKeySpecifier
)[];
export type ShifterStatusFieldPolicy = {
  databricksRunId?: FieldPolicy<any> | FieldReadFunction<any>;
  details?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShiftsDailyQAKeySpecifier = (
  | "appliedAbsenteeismAdjustmentHours"
  | "appliedAbsenteeismAdjustmentPercentage"
  | "appliedUnscheduledHours"
  | "appliedUnscheduledPercentage"
  | "date"
  | "dhAdjusted"
  | "dhAssignedDelta"
  | "dhAssignedInitial"
  | "dhFailedUpload"
  | "dhModeled"
  | "dhNetOfAbsenteeismAdjustments"
  | "dhNetOfAssigned"
  | "dhPlanned"
  | "dhPlannedTapered"
  | "dhPlannedTaperedPercentage"
  | "dhScheduled"
  | "dhScheduledMustRequest"
  | "dhTotalDelta"
  | "dhTotalExpected"
  | "dhTotalUpdated"
  | "dhUnassignedInitial"
  | "dhVarFlag"
  | "locationId"
  | "maxHooEnd"
  | "maxShiftEnd"
  | "metroRegion"
  | "minHooStart"
  | "minShiftStart"
  | "minimumDpAdjustment"
  | "mode"
  | "netAbsenteeismAdjustmentHours"
  | "odhFlag"
  | "odhPlan"
  | "odhPlanVar"
  | "odhSched"
  | "odhSchedVar"
  | "odhTarget"
  | "odhTargetMax"
  | "odhTargetMin"
  | "ovf"
  | "startEndFlag"
  | "taperAdjustmentHours"
  | "weekday"
  | ShiftsDailyQAKeySpecifier
)[];
export type ShiftsDailyQAFieldPolicy = {
  appliedAbsenteeismAdjustmentHours?: FieldPolicy<any> | FieldReadFunction<any>;
  appliedAbsenteeismAdjustmentPercentage?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  appliedUnscheduledHours?: FieldPolicy<any> | FieldReadFunction<any>;
  appliedUnscheduledPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  date?: FieldPolicy<any> | FieldReadFunction<any>;
  dhAdjusted?: FieldPolicy<any> | FieldReadFunction<any>;
  dhAssignedDelta?: FieldPolicy<any> | FieldReadFunction<any>;
  dhAssignedInitial?: FieldPolicy<any> | FieldReadFunction<any>;
  dhFailedUpload?: FieldPolicy<any> | FieldReadFunction<any>;
  dhModeled?: FieldPolicy<any> | FieldReadFunction<any>;
  dhNetOfAbsenteeismAdjustments?: FieldPolicy<any> | FieldReadFunction<any>;
  dhNetOfAssigned?: FieldPolicy<any> | FieldReadFunction<any>;
  dhPlanned?: FieldPolicy<any> | FieldReadFunction<any>;
  dhPlannedTapered?: FieldPolicy<any> | FieldReadFunction<any>;
  dhPlannedTaperedPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  dhScheduled?: FieldPolicy<any> | FieldReadFunction<any>;
  dhScheduledMustRequest?: FieldPolicy<any> | FieldReadFunction<any>;
  dhTotalDelta?: FieldPolicy<any> | FieldReadFunction<any>;
  dhTotalExpected?: FieldPolicy<any> | FieldReadFunction<any>;
  dhTotalUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  dhUnassignedInitial?: FieldPolicy<any> | FieldReadFunction<any>;
  dhVarFlag?: FieldPolicy<any> | FieldReadFunction<any>;
  locationId?: FieldPolicy<any> | FieldReadFunction<any>;
  maxHooEnd?: FieldPolicy<any> | FieldReadFunction<any>;
  maxShiftEnd?: FieldPolicy<any> | FieldReadFunction<any>;
  metroRegion?: FieldPolicy<any> | FieldReadFunction<any>;
  minHooStart?: FieldPolicy<any> | FieldReadFunction<any>;
  minShiftStart?: FieldPolicy<any> | FieldReadFunction<any>;
  minimumDpAdjustment?: FieldPolicy<any> | FieldReadFunction<any>;
  mode?: FieldPolicy<any> | FieldReadFunction<any>;
  netAbsenteeismAdjustmentHours?: FieldPolicy<any> | FieldReadFunction<any>;
  odhFlag?: FieldPolicy<any> | FieldReadFunction<any>;
  odhPlan?: FieldPolicy<any> | FieldReadFunction<any>;
  odhPlanVar?: FieldPolicy<any> | FieldReadFunction<any>;
  odhSched?: FieldPolicy<any> | FieldReadFunction<any>;
  odhSchedVar?: FieldPolicy<any> | FieldReadFunction<any>;
  odhTarget?: FieldPolicy<any> | FieldReadFunction<any>;
  odhTargetMax?: FieldPolicy<any> | FieldReadFunction<any>;
  odhTargetMin?: FieldPolicy<any> | FieldReadFunction<any>;
  ovf?: FieldPolicy<any> | FieldReadFunction<any>;
  startEndFlag?: FieldPolicy<any> | FieldReadFunction<any>;
  taperAdjustmentHours?: FieldPolicy<any> | FieldReadFunction<any>;
  weekday?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShiftsDailyQATotalKeySpecifier = (
  | "appliedAbsenteeismAdjustmentHours"
  | "appliedAbsenteeismAdjustmentPercentage"
  | "appliedUnscheduledHours"
  | "appliedUnscheduledPercentage"
  | "date"
  | "dhAdjusted"
  | "dhAssignedDelta"
  | "dhAssignedInitial"
  | "dhFailedUpload"
  | "dhModeled"
  | "dhNetOfAbsenteeismAdjustments"
  | "dhNetOfAssigned"
  | "dhNetOfHoursOfOperationAdjustments"
  | "dhPlanned"
  | "dhPlannedTapered"
  | "dhScheduled"
  | "dhScheduledMustRequest"
  | "dhTotalDelta"
  | "dhTotalExpected"
  | "dhTotalUpdated"
  | "dhUnassignedInitial"
  | "minimumDpAdjustment"
  | "netAbsenteeismAdjustmentHours"
  | "ovf"
  | "predictedAbsenteeismAdjustmentHours"
  | "predictedUnscheduledHours"
  | "taperAdjustmentHours"
  | "weekday"
  | ShiftsDailyQATotalKeySpecifier
)[];
export type ShiftsDailyQATotalFieldPolicy = {
  appliedAbsenteeismAdjustmentHours?: FieldPolicy<any> | FieldReadFunction<any>;
  appliedAbsenteeismAdjustmentPercentage?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  appliedUnscheduledHours?: FieldPolicy<any> | FieldReadFunction<any>;
  appliedUnscheduledPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  date?: FieldPolicy<any> | FieldReadFunction<any>;
  dhAdjusted?: FieldPolicy<any> | FieldReadFunction<any>;
  dhAssignedDelta?: FieldPolicy<any> | FieldReadFunction<any>;
  dhAssignedInitial?: FieldPolicy<any> | FieldReadFunction<any>;
  dhFailedUpload?: FieldPolicy<any> | FieldReadFunction<any>;
  dhModeled?: FieldPolicy<any> | FieldReadFunction<any>;
  dhNetOfAbsenteeismAdjustments?: FieldPolicy<any> | FieldReadFunction<any>;
  dhNetOfAssigned?: FieldPolicy<any> | FieldReadFunction<any>;
  dhNetOfHoursOfOperationAdjustments?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  dhPlanned?: FieldPolicy<any> | FieldReadFunction<any>;
  dhPlannedTapered?: FieldPolicy<any> | FieldReadFunction<any>;
  dhScheduled?: FieldPolicy<any> | FieldReadFunction<any>;
  dhScheduledMustRequest?: FieldPolicy<any> | FieldReadFunction<any>;
  dhTotalDelta?: FieldPolicy<any> | FieldReadFunction<any>;
  dhTotalExpected?: FieldPolicy<any> | FieldReadFunction<any>;
  dhTotalUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  dhUnassignedInitial?: FieldPolicy<any> | FieldReadFunction<any>;
  minimumDpAdjustment?: FieldPolicy<any> | FieldReadFunction<any>;
  netAbsenteeismAdjustmentHours?: FieldPolicy<any> | FieldReadFunction<any>;
  ovf?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedAbsenteeismAdjustmentHours?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  predictedUnscheduledHours?: FieldPolicy<any> | FieldReadFunction<any>;
  taperAdjustmentHours?: FieldPolicy<any> | FieldReadFunction<any>;
  weekday?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShiftsResponseKeySpecifier = (
  | "message"
  | "shift"
  | "success"
  | ShiftsResponseKeySpecifier
)[];
export type ShiftsResponseFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  shift?: FieldPolicy<any> | FieldReadFunction<any>;
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShiftsWeeklyQAKeySpecifier = (
  | "appliedAbsenteeismAdjustmentHours"
  | "appliedAbsenteeismAdjustmentPercentage"
  | "appliedUnscheduledHours"
  | "appliedUnscheduledPercentage"
  | "dhAdjusted"
  | "dhAssignedDelta"
  | "dhAssignedInitial"
  | "dhFailedUpload"
  | "dhModeled"
  | "dhNetOfAbsenteeismAdjustments"
  | "dhNetOfAssigned"
  | "dhPlanned"
  | "dhPlannedTapered"
  | "dhScheduled"
  | "dhScheduledMustRequest"
  | "dhTotalDelta"
  | "dhTotalExpected"
  | "dhTotalUpdated"
  | "dhUnassignedInitial"
  | "flagged"
  | "locationId"
  | "metroRegion"
  | "minimumDpAdjustment"
  | "netAbsenteeismAdjustmentHours"
  | "odhPlan"
  | "odhPlanVar"
  | "odhSched"
  | "odhSchedVar"
  | "odhTarget"
  | "odhTargetMax"
  | "odhTargetMin"
  | "ovf"
  | "taperAdjustmentHours"
  | ShiftsWeeklyQAKeySpecifier
)[];
export type ShiftsWeeklyQAFieldPolicy = {
  appliedAbsenteeismAdjustmentHours?: FieldPolicy<any> | FieldReadFunction<any>;
  appliedAbsenteeismAdjustmentPercentage?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  appliedUnscheduledHours?: FieldPolicy<any> | FieldReadFunction<any>;
  appliedUnscheduledPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  dhAdjusted?: FieldPolicy<any> | FieldReadFunction<any>;
  dhAssignedDelta?: FieldPolicy<any> | FieldReadFunction<any>;
  dhAssignedInitial?: FieldPolicy<any> | FieldReadFunction<any>;
  dhFailedUpload?: FieldPolicy<any> | FieldReadFunction<any>;
  dhModeled?: FieldPolicy<any> | FieldReadFunction<any>;
  dhNetOfAbsenteeismAdjustments?: FieldPolicy<any> | FieldReadFunction<any>;
  dhNetOfAssigned?: FieldPolicy<any> | FieldReadFunction<any>;
  dhPlanned?: FieldPolicy<any> | FieldReadFunction<any>;
  dhPlannedTapered?: FieldPolicy<any> | FieldReadFunction<any>;
  dhScheduled?: FieldPolicy<any> | FieldReadFunction<any>;
  dhScheduledMustRequest?: FieldPolicy<any> | FieldReadFunction<any>;
  dhTotalDelta?: FieldPolicy<any> | FieldReadFunction<any>;
  dhTotalExpected?: FieldPolicy<any> | FieldReadFunction<any>;
  dhTotalUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  dhUnassignedInitial?: FieldPolicy<any> | FieldReadFunction<any>;
  flagged?: FieldPolicy<any> | FieldReadFunction<any>;
  locationId?: FieldPolicy<any> | FieldReadFunction<any>;
  metroRegion?: FieldPolicy<any> | FieldReadFunction<any>;
  minimumDpAdjustment?: FieldPolicy<any> | FieldReadFunction<any>;
  netAbsenteeismAdjustmentHours?: FieldPolicy<any> | FieldReadFunction<any>;
  odhPlan?: FieldPolicy<any> | FieldReadFunction<any>;
  odhPlanVar?: FieldPolicy<any> | FieldReadFunction<any>;
  odhSched?: FieldPolicy<any> | FieldReadFunction<any>;
  odhSchedVar?: FieldPolicy<any> | FieldReadFunction<any>;
  odhTarget?: FieldPolicy<any> | FieldReadFunction<any>;
  odhTargetMax?: FieldPolicy<any> | FieldReadFunction<any>;
  odhTargetMin?: FieldPolicy<any> | FieldReadFunction<any>;
  ovf?: FieldPolicy<any> | FieldReadFunction<any>;
  taperAdjustmentHours?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShiftsWeeklyQATotalKeySpecifier = (
  | "appliedAbsenteeismAdjustmentHours"
  | "appliedAbsenteeismAdjustmentPercentage"
  | "appliedUnscheduledHours"
  | "appliedUnscheduledPercentage"
  | "dhAdjusted"
  | "dhAssignedDelta"
  | "dhAssignedInitial"
  | "dhFailedUpload"
  | "dhModeled"
  | "dhNetOfAbsenteeismAdjustments"
  | "dhNetOfAssigned"
  | "dhNetOfHoursOfOperationAdjustments"
  | "dhPlanned"
  | "dhPlannedTapered"
  | "dhScheduled"
  | "dhScheduledMustRequest"
  | "dhTotalDelta"
  | "dhTotalExpected"
  | "dhTotalUpdated"
  | "dhUnassignedInitial"
  | "minimumDpAdjustment"
  | "netAbsenteeismAdjustmentHours"
  | "ovf"
  | "predictedAbsenteeismAdjustmentHours"
  | "predictedUnscheduledHours"
  | "taperAdjustmentHours"
  | ShiftsWeeklyQATotalKeySpecifier
)[];
export type ShiftsWeeklyQATotalFieldPolicy = {
  appliedAbsenteeismAdjustmentHours?: FieldPolicy<any> | FieldReadFunction<any>;
  appliedAbsenteeismAdjustmentPercentage?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  appliedUnscheduledHours?: FieldPolicy<any> | FieldReadFunction<any>;
  appliedUnscheduledPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  dhAdjusted?: FieldPolicy<any> | FieldReadFunction<any>;
  dhAssignedDelta?: FieldPolicy<any> | FieldReadFunction<any>;
  dhAssignedInitial?: FieldPolicy<any> | FieldReadFunction<any>;
  dhFailedUpload?: FieldPolicy<any> | FieldReadFunction<any>;
  dhModeled?: FieldPolicy<any> | FieldReadFunction<any>;
  dhNetOfAbsenteeismAdjustments?: FieldPolicy<any> | FieldReadFunction<any>;
  dhNetOfAssigned?: FieldPolicy<any> | FieldReadFunction<any>;
  dhNetOfHoursOfOperationAdjustments?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  dhPlanned?: FieldPolicy<any> | FieldReadFunction<any>;
  dhPlannedTapered?: FieldPolicy<any> | FieldReadFunction<any>;
  dhScheduled?: FieldPolicy<any> | FieldReadFunction<any>;
  dhScheduledMustRequest?: FieldPolicy<any> | FieldReadFunction<any>;
  dhTotalDelta?: FieldPolicy<any> | FieldReadFunction<any>;
  dhTotalExpected?: FieldPolicy<any> | FieldReadFunction<any>;
  dhTotalUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  dhUnassignedInitial?: FieldPolicy<any> | FieldReadFunction<any>;
  minimumDpAdjustment?: FieldPolicy<any> | FieldReadFunction<any>;
  netAbsenteeismAdjustmentHours?: FieldPolicy<any> | FieldReadFunction<any>;
  ovf?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedAbsenteeismAdjustmentHours?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  predictedUnscheduledHours?: FieldPolicy<any> | FieldReadFunction<any>;
  taperAdjustmentHours?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StandardMutationResponseKeySpecifier = (
  | "message"
  | "success"
  | StandardMutationResponseKeySpecifier
)[];
export type StandardMutationResponseFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StateKeySpecifier = (
  | "life_cycle_state"
  | "result_state"
  | "state_message"
  | "user_cancelled_or_timedout"
  | StateKeySpecifier
)[];
export type StateFieldPolicy = {
  life_cycle_state?: FieldPolicy<any> | FieldReadFunction<any>;
  result_state?: FieldPolicy<any> | FieldReadFunction<any>;
  state_message?: FieldPolicy<any> | FieldReadFunction<any>;
  user_cancelled_or_timedout?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ThreeWeekTrailingAveragesKeySpecifier = (
  | "dailyPercentages"
  | "dates"
  | "hourlyPercentages"
  | ThreeWeekTrailingAveragesKeySpecifier
)[];
export type ThreeWeekTrailingAveragesFieldPolicy = {
  dailyPercentages?: FieldPolicy<any> | FieldReadFunction<any>;
  dates?: FieldPolicy<any> | FieldReadFunction<any>;
  hourlyPercentages?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TriggerKeySpecifier = (
  | "number_in_job"
  | "run_id"
  | TriggerKeySpecifier
)[];
export type TriggerFieldPolicy = {
  number_in_job?: FieldPolicy<any> | FieldReadFunction<any>;
  run_id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UploadShiftsResponseLegacyKeySpecifier = (
  | "invalidShifts"
  | "invalidShiftsUrl"
  | "shiftsAdded"
  | "success"
  | UploadShiftsResponseLegacyKeySpecifier
)[];
export type UploadShiftsResponseLegacyFieldPolicy = {
  invalidShifts?: FieldPolicy<any> | FieldReadFunction<any>;
  invalidShiftsUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  shiftsAdded?: FieldPolicy<any> | FieldReadFunction<any>;
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WeeklyMissingLocationKeySpecifier = (
  | "forecasterId"
  | "launchDate"
  | "locationId"
  | "missingInDoppler"
  | WeeklyMissingLocationKeySpecifier
)[];
export type WeeklyMissingLocationFieldPolicy = {
  forecasterId?: FieldPolicy<any> | FieldReadFunction<any>;
  launchDate?: FieldPolicy<any> | FieldReadFunction<any>;
  locationId?: FieldPolicy<any> | FieldReadFunction<any>;
  missingInDoppler?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WeeklyQAKeySpecifier = (
  | "dailyMissingLocations"
  | "hourlyMissingLocations"
  | "locationsInBackOffice"
  | "locationsInDoppler"
  | "operationalWeekStartDate"
  | "orders"
  | "weeklyMissingLocations"
  | WeeklyQAKeySpecifier
)[];
export type WeeklyQAFieldPolicy = {
  dailyMissingLocations?: FieldPolicy<any> | FieldReadFunction<any>;
  hourlyMissingLocations?: FieldPolicy<any> | FieldReadFunction<any>;
  locationsInBackOffice?: FieldPolicy<any> | FieldReadFunction<any>;
  locationsInDoppler?: FieldPolicy<any> | FieldReadFunction<any>;
  operationalWeekStartDate?: FieldPolicy<any> | FieldReadFunction<any>;
  orders?: FieldPolicy<any> | FieldReadFunction<any>;
  weeklyMissingLocations?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WeeklyQAByCountryKeySpecifier = (
  | "countryCode"
  | "weeklyQA"
  | WeeklyQAByCountryKeySpecifier
)[];
export type WeeklyQAByCountryFieldPolicy = {
  countryCode?: FieldPolicy<any> | FieldReadFunction<any>;
  weeklyQA?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StrictTypedTypePolicies = {
  AdjustedDriverHourLocation?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | AdjustedDriverHourLocationKeySpecifier
      | (() => undefined | AdjustedDriverHourLocationKeySpecifier);
    fields?: AdjustedDriverHourLocationFieldPolicy;
  };
  AdjustedDriverHoursRun?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | AdjustedDriverHoursRunKeySpecifier
      | (() => undefined | AdjustedDriverHoursRunKeySpecifier);
    fields?: AdjustedDriverHoursRunFieldPolicy;
  };
  AdjustedOvf?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | AdjustedOvfKeySpecifier
      | (() => undefined | AdjustedOvfKeySpecifier);
    fields?: AdjustedOvfFieldPolicy;
  };
  AzureSasToken?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | AzureSasTokenKeySpecifier
      | (() => undefined | AzureSasTokenKeySpecifier);
    fields?: AzureSasTokenFieldPolicy;
  };
  Country?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | CountryKeySpecifier
      | (() => undefined | CountryKeySpecifier);
    fields?: CountryFieldPolicy;
  };
  CreateLocationTargetResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | CreateLocationTargetResponseKeySpecifier
      | (() => undefined | CreateLocationTargetResponseKeySpecifier);
    fields?: CreateLocationTargetResponseFieldPolicy;
  };
  DailyAdjustment?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | DailyAdjustmentKeySpecifier
      | (() => undefined | DailyAdjustmentKeySpecifier);
    fields?: DailyAdjustmentFieldPolicy;
  };
  DailyMissingLocation?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | DailyMissingLocationKeySpecifier
      | (() => undefined | DailyMissingLocationKeySpecifier);
    fields?: DailyMissingLocationFieldPolicy;
  };
  DopplerQA?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | DopplerQAKeySpecifier
      | (() => undefined | DopplerQAKeySpecifier);
    fields?: DopplerQAFieldPolicy;
  };
  DopplerRun?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | DopplerRunKeySpecifier
      | (() => undefined | DopplerRunKeySpecifier);
    fields?: DopplerRunFieldPolicy;
  };
  Eib?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?: false | EibKeySpecifier | (() => undefined | EibKeySpecifier);
    fields?: EibFieldPolicy;
  };
  EventAdjustment?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | EventAdjustmentKeySpecifier
      | (() => undefined | EventAdjustmentKeySpecifier);
    fields?: EventAdjustmentFieldPolicy;
  };
  EventAdjustmentTotal?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | EventAdjustmentTotalKeySpecifier
      | (() => undefined | EventAdjustmentTotalKeySpecifier);
    fields?: EventAdjustmentTotalFieldPolicy;
  };
  ForecastDriverHour?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ForecastDriverHourKeySpecifier
      | (() => undefined | ForecastDriverHourKeySpecifier);
    fields?: ForecastDriverHourFieldPolicy;
  };
  ForecastNetworkDriverHour?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ForecastNetworkDriverHourKeySpecifier
      | (() => undefined | ForecastNetworkDriverHourKeySpecifier);
    fields?: ForecastNetworkDriverHourFieldPolicy;
  };
  Forecaster?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ForecasterKeySpecifier
      | (() => undefined | ForecasterKeySpecifier);
    fields?: ForecasterFieldPolicy;
  };
  HourlyDriverHours?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | HourlyDriverHoursKeySpecifier
      | (() => undefined | HourlyDriverHoursKeySpecifier);
    fields?: HourlyDriverHoursFieldPolicy;
  };
  HourlyMissingLocation?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | HourlyMissingLocationKeySpecifier
      | (() => undefined | HourlyMissingLocationKeySpecifier);
    fields?: HourlyMissingLocationFieldPolicy;
  };
  HourlyOVF?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | HourlyOVFKeySpecifier
      | (() => undefined | HourlyOVFKeySpecifier);
    fields?: HourlyOVFFieldPolicy;
  };
  InvalidShift?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | InvalidShiftKeySpecifier
      | (() => undefined | InvalidShiftKeySpecifier);
    fields?: InvalidShiftFieldPolicy;
  };
  ItemForecast?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ItemForecastKeySpecifier
      | (() => undefined | ItemForecastKeySpecifier);
    fields?: ItemForecastFieldPolicy;
  };
  Job?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?: false | JobKeySpecifier | (() => undefined | JobKeySpecifier);
    fields?: JobFieldPolicy;
  };
  JobStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | JobStatusKeySpecifier
      | (() => undefined | JobStatusKeySpecifier);
    fields?: JobStatusFieldPolicy;
  };
  Location?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | LocationKeySpecifier
      | (() => undefined | LocationKeySpecifier);
    fields?: LocationFieldPolicy;
  };
  LocationConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | LocationConnectionKeySpecifier
      | (() => undefined | LocationConnectionKeySpecifier);
    fields?: LocationConnectionFieldPolicy;
  };
  LocationEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | LocationEdgeKeySpecifier
      | (() => undefined | LocationEdgeKeySpecifier);
    fields?: LocationEdgeFieldPolicy;
  };
  LocationTarget?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | LocationTargetKeySpecifier
      | (() => undefined | LocationTargetKeySpecifier);
    fields?: LocationTargetFieldPolicy;
  };
  LocationTargetConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | LocationTargetConnectionKeySpecifier
      | (() => undefined | LocationTargetConnectionKeySpecifier);
    fields?: LocationTargetConnectionFieldPolicy;
  };
  LocationTargetEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | LocationTargetEdgeKeySpecifier
      | (() => undefined | LocationTargetEdgeKeySpecifier);
    fields?: LocationTargetEdgeFieldPolicy;
  };
  LocationsByMetroRegion?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | LocationsByMetroRegionKeySpecifier
      | (() => undefined | LocationsByMetroRegionKeySpecifier);
    fields?: LocationsByMetroRegionFieldPolicy;
  };
  MidweekReforecast?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | MidweekReforecastKeySpecifier
      | (() => undefined | MidweekReforecastKeySpecifier);
    fields?: MidweekReforecastFieldPolicy;
  };
  MostRecentAdjustedHoursUpload?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | MostRecentAdjustedHoursUploadKeySpecifier
      | (() => undefined | MostRecentAdjustedHoursUploadKeySpecifier);
    fields?: MostRecentAdjustedHoursUploadFieldPolicy;
  };
  MostRecentLaborMappingUpload?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | MostRecentLaborMappingUploadKeySpecifier
      | (() => undefined | MostRecentLaborMappingUploadKeySpecifier);
    fields?: MostRecentLaborMappingUploadFieldPolicy;
  };
  MostRecentOaLaborUpload?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | MostRecentOaLaborUploadKeySpecifier
      | (() => undefined | MostRecentOaLaborUploadKeySpecifier);
    fields?: MostRecentOaLaborUploadFieldPolicy;
  };
  MostRecentOdhTransformJob?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | MostRecentOdhTransformJobKeySpecifier
      | (() => undefined | MostRecentOdhTransformJobKeySpecifier);
    fields?: MostRecentOdhTransformJobFieldPolicy;
  };
  MostRecentOdhTransformRun?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | MostRecentOdhTransformRunKeySpecifier
      | (() => undefined | MostRecentOdhTransformRunKeySpecifier);
    fields?: MostRecentOdhTransformRunFieldPolicy;
  };
  MultiModalHourlyData?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | MultiModalHourlyDataKeySpecifier
      | (() => undefined | MultiModalHourlyDataKeySpecifier);
    fields?: MultiModalHourlyDataFieldPolicy;
  };
  MultiweekForecast?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | MultiweekForecastKeySpecifier
      | (() => undefined | MultiweekForecastKeySpecifier);
    fields?: MultiweekForecastFieldPolicy;
  };
  Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | MutationKeySpecifier
      | (() => undefined | MutationKeySpecifier);
    fields?: MutationFieldPolicy;
  };
  NotebookParams?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | NotebookParamsKeySpecifier
      | (() => undefined | NotebookParamsKeySpecifier);
    fields?: NotebookParamsFieldPolicy;
  };
  OVFShift?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | OVFShiftKeySpecifier
      | (() => undefined | OVFShiftKeySpecifier);
    fields?: OVFShiftFieldPolicy;
  };
  OaDriverHoursRun?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | OaDriverHoursRunKeySpecifier
      | (() => undefined | OaDriverHoursRunKeySpecifier);
    fields?: OaDriverHoursRunFieldPolicy;
  };
  OaLaborHours?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | OaLaborHoursKeySpecifier
      | (() => undefined | OaLaborHoursKeySpecifier);
    fields?: OaLaborHoursFieldPolicy;
  };
  OaLocation?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | OaLocationKeySpecifier
      | (() => undefined | OaLocationKeySpecifier);
    fields?: OaLocationFieldPolicy;
  };
  OaLocationCluster?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | OaLocationClusterKeySpecifier
      | (() => undefined | OaLocationClusterKeySpecifier);
    fields?: OaLocationClusterFieldPolicy;
  };
  OaShift?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | OaShiftKeySpecifier
      | (() => undefined | OaShiftKeySpecifier);
    fields?: OaShiftFieldPolicy;
  };
  OdhTransform?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | OdhTransformKeySpecifier
      | (() => undefined | OdhTransformKeySpecifier);
    fields?: OdhTransformFieldPolicy;
  };
  OdhTransformPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | OdhTransformPayloadKeySpecifier
      | (() => undefined | OdhTransformPayloadKeySpecifier);
    fields?: OdhTransformPayloadFieldPolicy;
  };
  OverridingParameters?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | OverridingParametersKeySpecifier
      | (() => undefined | OverridingParametersKeySpecifier);
    fields?: OverridingParametersFieldPolicy;
  };
  OvfHour?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | OvfHourKeySpecifier
      | (() => undefined | OvfHourKeySpecifier);
    fields?: OvfHourFieldPolicy;
  };
  OvfHourNetwork?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | OvfHourNetworkKeySpecifier
      | (() => undefined | OvfHourNetworkKeySpecifier);
    fields?: OvfHourNetworkFieldPolicy;
  };
  PageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | PageInfoKeySpecifier
      | (() => undefined | PageInfoKeySpecifier);
    fields?: PageInfoFieldPolicy;
  };
  PublishShiftsResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | PublishShiftsResponseKeySpecifier
      | (() => undefined | PublishShiftsResponseKeySpecifier);
    fields?: PublishShiftsResponseFieldPolicy;
  };
  PublishSuccessResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | PublishSuccessResponseKeySpecifier
      | (() => undefined | PublishSuccessResponseKeySpecifier);
    fields?: PublishSuccessResponseFieldPolicy;
  };
  PublishedOvf?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | PublishedOvfKeySpecifier
      | (() => undefined | PublishedOvfKeySpecifier);
    fields?: PublishedOvfFieldPolicy;
  };
  Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | QueryKeySpecifier
      | (() => undefined | QueryKeySpecifier);
    fields?: QueryFieldPolicy;
  };
  Run?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?: false | RunKeySpecifier | (() => undefined | RunKeySpecifier);
    fields?: RunFieldPolicy;
  };
  SeasonalityAdjustments?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | SeasonalityAdjustmentsKeySpecifier
      | (() => undefined | SeasonalityAdjustmentsKeySpecifier);
    fields?: SeasonalityAdjustmentsFieldPolicy;
  };
  Shift?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ShiftKeySpecifier
      | (() => undefined | ShiftKeySpecifier);
    fields?: ShiftFieldPolicy;
  };
  ShiftHours?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ShiftHoursKeySpecifier
      | (() => undefined | ShiftHoursKeySpecifier);
    fields?: ShiftHoursFieldPolicy;
  };
  ShiftLeaderShiftRequest?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ShiftLeaderShiftRequestKeySpecifier
      | (() => undefined | ShiftLeaderShiftRequestKeySpecifier);
    fields?: ShiftLeaderShiftRequestFieldPolicy;
  };
  ShiftModelOutput?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ShiftModelOutputKeySpecifier
      | (() => undefined | ShiftModelOutputKeySpecifier);
    fields?: ShiftModelOutputFieldPolicy;
  };
  ShifterStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ShifterStatusKeySpecifier
      | (() => undefined | ShifterStatusKeySpecifier);
    fields?: ShifterStatusFieldPolicy;
  };
  ShiftsDailyQA?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ShiftsDailyQAKeySpecifier
      | (() => undefined | ShiftsDailyQAKeySpecifier);
    fields?: ShiftsDailyQAFieldPolicy;
  };
  ShiftsDailyQATotal?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ShiftsDailyQATotalKeySpecifier
      | (() => undefined | ShiftsDailyQATotalKeySpecifier);
    fields?: ShiftsDailyQATotalFieldPolicy;
  };
  ShiftsResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ShiftsResponseKeySpecifier
      | (() => undefined | ShiftsResponseKeySpecifier);
    fields?: ShiftsResponseFieldPolicy;
  };
  ShiftsWeeklyQA?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ShiftsWeeklyQAKeySpecifier
      | (() => undefined | ShiftsWeeklyQAKeySpecifier);
    fields?: ShiftsWeeklyQAFieldPolicy;
  };
  ShiftsWeeklyQATotal?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ShiftsWeeklyQATotalKeySpecifier
      | (() => undefined | ShiftsWeeklyQATotalKeySpecifier);
    fields?: ShiftsWeeklyQATotalFieldPolicy;
  };
  StandardMutationResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | StandardMutationResponseKeySpecifier
      | (() => undefined | StandardMutationResponseKeySpecifier);
    fields?: StandardMutationResponseFieldPolicy;
  };
  State?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | StateKeySpecifier
      | (() => undefined | StateKeySpecifier);
    fields?: StateFieldPolicy;
  };
  ThreeWeekTrailingAverages?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | ThreeWeekTrailingAveragesKeySpecifier
      | (() => undefined | ThreeWeekTrailingAveragesKeySpecifier);
    fields?: ThreeWeekTrailingAveragesFieldPolicy;
  };
  Trigger?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | TriggerKeySpecifier
      | (() => undefined | TriggerKeySpecifier);
    fields?: TriggerFieldPolicy;
  };
  UploadShiftsResponseLegacy?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | UploadShiftsResponseLegacyKeySpecifier
      | (() => undefined | UploadShiftsResponseLegacyKeySpecifier);
    fields?: UploadShiftsResponseLegacyFieldPolicy;
  };
  WeeklyMissingLocation?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | WeeklyMissingLocationKeySpecifier
      | (() => undefined | WeeklyMissingLocationKeySpecifier);
    fields?: WeeklyMissingLocationFieldPolicy;
  };
  WeeklyQA?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | WeeklyQAKeySpecifier
      | (() => undefined | WeeklyQAKeySpecifier);
    fields?: WeeklyQAFieldPolicy;
  };
  WeeklyQAByCountry?: Omit<TypePolicy, "fields" | "keyFields"> & {
    keyFields?:
      | false
      | WeeklyQAByCountryKeySpecifier
      | (() => undefined | WeeklyQAByCountryKeySpecifier);
    fields?: WeeklyQAByCountryFieldPolicy;
  };
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;
export type GetAdjustedDriverHourLocationsQueryVariables = Exact<{
  adjustedDriverHoursRunId: Scalars["NonNegativeInt"];
}>;

export type GetAdjustedDriverHourLocationsQuery = {
  __typename: "Query";
  adjustedDriverHourLocations: Array<{
    __typename: "AdjustedDriverHourLocation";
    id: number;
    title: string | null;
    driverHours: {
      __typename: "HourlyDriverHours";
      dates: Array<string>;
      hours: Array<{
        __typename: "MultiModalHourlyData";
        mode: string;
        values: Array<Array<number | null>>;
      }>;
    } | null;
  }>;
};

export type GetAdjustedDriverHoursRunsForWeekQueryVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
}>;

export type GetAdjustedDriverHoursRunsForWeekQuery = {
  __typename: "Query";
  getAdjustedDriverHoursRunsForWeek: Array<{
    __typename: "AdjustedDriverHoursRun";
    id: number;
    odhRunsId: number | null;
    name: string | null;
    source: string;
    createdAt: string | null;
  }>;
};

export type GetAdjustedOaHoursQueryVariables = Exact<{
  adjustedOaHoursRunId: Scalars["NonNegativeInt"];
}>;

export type GetAdjustedOaHoursQuery = {
  __typename: "Query";
  getAdjustedOaHours: Array<{
    __typename: "OaLaborHours";
    id: number;
    location_id: number;
    location_name: string | null;
    ops_date: string;
    local_time: string;
    role: string | null;
    gosked_total_hours: number | null;
    gosked_pack_hours: number | null;
    gosked_inbound_hours: number | null;
    gosked_hours: number;
    created_at: string;
  }>;
};

export type GetAdjustedOaHoursRunsForWeekQueryVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
}>;

export type GetAdjustedOaHoursRunsForWeekQuery = {
  __typename: "Query";
  getAdjustedOaHoursRunsForWeek: Array<{
    __typename: "OaDriverHoursRun";
    id: number;
    ophRunsId: number | null;
    name: string | null;
    source: string;
    createdAt: string | null;
  }>;
};

export type GetCountryCodesQueryVariables = Exact<{ [key: string]: never }>;

export type GetCountryCodesQuery = {
  __typename: "Query";
  countries: Array<{
    __typename: "Country";
    countryCode: string;
  } | null> | null;
};

export type GetForecasterIdsQueryVariables = Exact<{
  operationalWeekStartDate?: InputMaybe<Scalars["String"]>;
}>;

export type GetForecasterIdsQuery = {
  __typename: "Query";
  forecasters: Array<{ __typename: "Forecaster"; id: number } | null> | null;
};

export type UploadAdjustedDriverHoursMutationVariables = Exact<{
  file: Scalars["Upload"];
  selectedWeek: Scalars["String"];
  name: Scalars["String"];
}>;

export type UploadAdjustedDriverHoursMutation = {
  __typename: "Mutation";
  uploadDriverHoursCsv: {
    __typename: "StandardMutationResponse";
    success: boolean;
  };
};

export type UploadIncrementalAdjustedDriverHoursMutationVariables = Exact<{
  file: Scalars["Upload"];
  selectedWeek: Scalars["String"];
  name?: InputMaybe<Scalars["String"]>;
}>;

export type UploadIncrementalAdjustedDriverHoursMutation = {
  __typename: "Mutation";
  uploadIncrementalAdjustedDriverHoursCsv: {
    __typename: "StandardMutationResponse";
    success: boolean;
  };
};

export type UploadOaHoursMutationVariables = Exact<{
  file: Scalars["Upload"];
  selectedWeek: Scalars["String"];
  name: Scalars["String"];
}>;

export type UploadOaHoursMutation = {
  __typename: "Mutation";
  uploadOAHours: { __typename: "StandardMutationResponse"; success: boolean };
};

export type UploadOaLaborMappingMutationVariables = Exact<{
  file: Scalars["Upload"];
}>;

export type UploadOaLaborMappingMutation = {
  __typename: "Mutation";
  uploadOaLaborMapping: {
    __typename: "StandardMutationResponse";
    success: boolean;
  };
};

export type GenerateSasTokenMutationVariables = Exact<{
  connectionString: Scalars["String"];
  permissions: Scalars["String"];
  containerName: Scalars["String"];
}>;

export type GenerateSasTokenMutation = {
  __typename: "Mutation";
  generateSasToken: {
    __typename: "AzureSasToken";
    token: string | null;
    success: boolean | null;
    message: string | null;
  };
};

export type GetLatestJobStatusQueryVariables = Exact<{
  jobId: Scalars["NonNegativeInt"];
  environment?: InputMaybe<Scalars["String"]>;
}>;

export type GetLatestJobStatusQuery = {
  __typename: "Query";
  getLatestJobStatus: {
    __typename: "JobStatus";
    startDate: string | null;
    endDate: string | null;
    status: string | null;
  } | null;
};

export type TriggerJobRunMutationVariables = Exact<{
  jobId: Scalars["NonNegativeInt"];
  queryParams?: InputMaybe<Scalars["JSON"]>;
  environment?: InputMaybe<Scalars["String"]>;
}>;

export type TriggerJobRunMutation = {
  __typename: "Mutation";
  triggerJobRun: {
    __typename: "Trigger";
    run_id: number;
    number_in_job: number | null;
  } | null;
};

export type CancelAllJobRunsMutationVariables = Exact<{
  jobId: Scalars["NonNegativeInt"];
  environment?: InputMaybe<Scalars["String"]>;
}>;

export type CancelAllJobRunsMutation = {
  __typename: "Mutation";
  cancelAllJobRuns: {
    __typename: "StandardMutationResponse";
    success: boolean;
    message: string;
  };
};

export type GetSecretQueryVariables = Exact<{
  key: Scalars["String"];
}>;

export type GetSecretQuery = { __typename: "Query"; secret: string | null };

export type GetLocationIdsByForecasterQueryVariables = Exact<{
  forecaster?: InputMaybe<Scalars["String"]>;
  operationalWeekStartDate: Scalars["String"];
}>;

export type GetLocationIdsByForecasterQuery = {
  __typename: "Query";
  locations: Array<{ __typename: "Location"; id: string } | null> | null;
};

export type GetLocationSeasonalityAdjustmentsQueryVariables = Exact<{
  ids: Array<Scalars["NonNegativeInt"]> | Scalars["NonNegativeInt"];
  operationalWeekStartDate: Scalars["String"];
}>;

export type GetLocationSeasonalityAdjustmentsQuery = {
  __typename: "Query";
  locations: Array<{
    __typename: "Location";
    id: string;
    title: string;
    threeWeekTrailingAverage: {
      __typename: "ThreeWeekTrailingAverages";
      hourlyPercentages: Array<Array<number | null>>;
      dailyPercentages: Array<number | null>;
    } | null;
    seasonalityAdjustments: {
      __typename: "SeasonalityAdjustments";
      dates: Array<string>;
      dopplerForecast: Array<Array<number | null>>;
      hourlyOverrides: Array<Array<number | null>>;
      dailyOverrides: Array<number | null>;
      totalSeasonalityAdjustedForecastDistribution: Array<Array<number | null>>;
      dailySeasonalityAdjustedForecastDistribution: Array<number>;
    } | null;
  } | null> | null;
};

export type SetAllHourlyAdjustmentsToHistoricalAverageMutationVariables =
  Exact<{
    locationId: Scalars["NonNegativeInt"];
    operationalWeekStartDate: Scalars["String"];
    weeksInPast: Scalars["NonNegativeInt"];
    isMetroRegion?: InputMaybe<Scalars["Boolean"]>;
  }>;

export type SetAllHourlyAdjustmentsToHistoricalAverageMutation = {
  __typename: "Mutation";
  setAllHourlyAdjustmentsToHistoricalAverage: {
    __typename: "StandardMutationResponse";
    success: boolean;
  };
};

export type UpsertSeasonalAdjustmentMutationVariables = Exact<{
  locationId: Scalars["NonNegativeInt"];
  forecasterId?: InputMaybe<Scalars["NonNegativeInt"]>;
  adjustmentType: Scalars["String"];
  operationalWeekStartDate: Scalars["String"];
  dateString: Scalars["String"];
  value?: InputMaybe<Scalars["Float"]>;
}>;

export type UpsertSeasonalAdjustmentMutation = {
  __typename: "Mutation";
  upsertSeasonalAdjustment: {
    __typename: "SeasonalityAdjustments";
    success: boolean;
  };
};

export type GetCurrentlyActiveDopplerRunDateQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetCurrentlyActiveDopplerRunDateQuery = {
  __typename: "Query";
  currentlyActiveDopplerRunDate: string | null;
};

export type GetDopplerQaQueryVariables = Exact<{
  runId: Scalars["Int"];
}>;

export type GetDopplerQaQuery = {
  __typename: "Query";
  dopplerQA: {
    __typename: "DopplerQA";
    dopplerRunDateTime: string;
    qaRunDateTime: string;
    weeklyQAByCountry: Array<{
      __typename: "WeeklyQAByCountry";
      countryCode: string;
      weeklyQA: Array<{
        __typename: "WeeklyQA";
        operationalWeekStartDate: string;
        orders: number;
        locationsInDoppler: number;
        locationsInBackOffice: number;
        weeklyMissingLocations: Array<{
          __typename: "WeeklyMissingLocation";
          locationId: number;
          forecasterId: number | null;
          launchDate: string;
          missingInDoppler: boolean | null;
        } | null>;
        dailyMissingLocations: Array<{
          __typename: "DailyMissingLocation";
          locationId: number;
          forecasterId: number | null;
          date: string;
          missingInDoppler: boolean | null;
        } | null>;
        hourlyMissingLocations: Array<{
          __typename: "HourlyMissingLocation";
          locationId: number;
          forecasterId: number | null;
          datetime: string;
          missingInDoppler: boolean | null;
        } | null>;
      }>;
    }>;
  } | null;
};

export type GetDopplerRunTimestampsThisWeekQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetDopplerRunTimestampsThisWeekQuery = {
  __typename: "Query";
  dopplerRunTimestampsThisWeek: Array<{
    __typename: "DopplerRun";
    dopplerRunId: number;
    dopplerRunDateTime: string;
  }>;
};

export type SetSelectedDopplerRunMutationVariables = Exact<{
  dopplerQARunsId: Scalars["NonNegativeInt"];
}>;

export type SetSelectedDopplerRunMutation = {
  __typename: "Mutation";
  setSelectedDopplerRun: {
    __typename: "StandardMutationResponse";
    success: boolean;
    message: string;
  };
};

export type DeleteEventAdjustmentLayerMutationVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
  name: Scalars["String"];
}>;

export type DeleteEventAdjustmentLayerMutation = {
  __typename: "Mutation";
  deleteEventAdjustment: {
    __typename: "StandardMutationResponse";
    success: boolean;
  };
};

export type GetEventAdjustmentsForTableQueryVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
  tag?: InputMaybe<Scalars["String"]>;
  layerName?: InputMaybe<Scalars["String"]>;
  locationId?: InputMaybe<Scalars["NonNegativeInt"]>;
}>;

export type GetEventAdjustmentsForTableQuery = {
  __typename: "Query";
  eventAdjustments: Array<{
    __typename: "EventAdjustment";
    id: number;
    name: string;
    tag: string | null;
    adjustments: Array<{
      __typename: "DailyAdjustment";
      locationId: number;
      locationTitle: string;
      operationalDate: string;
      day: string;
      hourlyAdjustments: Array<number>;
    } | null> | null;
  } | null> | null;
};

export type GetLayerNamesQueryVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
  tag?: InputMaybe<Scalars["String"]>;
}>;

export type GetLayerNamesQuery = {
  __typename: "Query";
  eventAdjustments: Array<{
    __typename: "EventAdjustment";
    name: string;
  } | null> | null;
};

export type GetLocationIdsInLayerQueryVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
  layerName?: InputMaybe<Scalars["String"]>;
}>;

export type GetLocationIdsInLayerQuery = {
  __typename: "Query";
  eventAdjustments: Array<{
    __typename: "EventAdjustment";
    locationIds: Array<number | null> | null;
  } | null> | null;
};

export type GetLocationIdsInTagQueryVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
  tag?: InputMaybe<Scalars["String"]>;
}>;

export type GetLocationIdsInTagQuery = {
  __typename: "Query";
  eventAdjustments: Array<{
    __typename: "EventAdjustment";
    locationIdsInTag: Array<number | null> | null;
  } | null> | null;
};

export type UploadEventAdjustmentMutationVariables = Exact<{
  file: Scalars["Upload"];
  layerType?: InputMaybe<Scalars["String"]>;
  operationalWeekStartDate: Scalars["String"];
  allowDatesOutsideSelectedWeek: Scalars["Boolean"];
}>;

export type UploadEventAdjustmentMutation = {
  __typename: "Mutation";
  uploadEventAdjustmentCsv: {
    __typename: "StandardMutationResponse";
    success: boolean;
  };
};

export type UpdateForecasterAssignmentsMutationVariables = Exact<{
  [key: string]: never;
}>;

export type UpdateForecasterAssignmentsMutation = {
  __typename: "Mutation";
  updateForecastersAndForecasterAssignments: {
    __typename: "StandardMutationResponse";
    message: string;
    success: boolean;
  } | null;
};

export type CreateGlobalAdjustmentLayerMutationVariables = Exact<{
  tag?: InputMaybe<Scalars["String"]>;
  layerName: Scalars["String"];
  locationIds?: InputMaybe<
    Array<Scalars["NonNegativeInt"]> | Scalars["NonNegativeInt"]
  >;
  orderAdjustment: Scalars["Int"];
  forecasterId?: InputMaybe<Scalars["NonNegativeInt"]>;
  operationalWeekStartDate: Scalars["String"];
  countryCode?: InputMaybe<Scalars["String"]>;
}>;

export type CreateGlobalAdjustmentLayerMutation = {
  __typename: "Mutation";
  createGlobalAdjustmentLayer: {
    __typename: "StandardMutationResponse";
    success: boolean;
  };
};

export type GetGlobalAdjustmentLayerInfoQueryVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
  layerName: Scalars["String"];
}>;

export type GetGlobalAdjustmentLayerInfoQuery = {
  __typename: "Query";
  eventAdjustments: Array<{
    __typename: "EventAdjustment";
    name: string;
    locationIds: Array<number | null> | null;
    orderSum: number | null;
  } | null> | null;
};

export type GetLayerNamesByTagQueryVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
  tag?: InputMaybe<Scalars["String"]>;
}>;

export type GetLayerNamesByTagQuery = {
  __typename: "Query";
  eventAdjustments: Array<{
    __typename: "EventAdjustment";
    name: string;
  } | null> | null;
};

export type GetLocationsByCountryQueryVariables = Exact<{
  country: Scalars["String"];
}>;

export type GetLocationsByCountryQuery = {
  __typename: "Query";
  locations: Array<{ __typename: "Location"; id: string } | null> | null;
};

export type CreateLocationOdhTargetDataMutationVariables = Exact<{
  locationTargetCreateInput: LocationTargetCreateInput;
}>;

export type CreateLocationOdhTargetDataMutation = {
  __typename: "Mutation";
  createLocationTargets: {
    __typename: "CreateLocationTargetResponse";
    id: number;
  };
};

export type GetLocationOdhTargetFieldsFragment = {
  __typename: "LocationTarget";
  id: string;
  title: string;
  locationTargetId: string | null;
  locationId: number;
  minODH: number | null;
  maxODH: number | null;
  targetDate: string | null;
  targetODH: number | null;
  driverWaitTime: number | null;
  mindpCar: number | null;
  mindpBike: number | null;
  mindpFoot: number | null;
  constrainFlag: string | null;
  absenteeAdjustCar: boolean | null;
  absenteeAdjustBike: boolean | null;
  absenteeAdjustFoot: boolean | null;
  openFromOverride: string | null;
  openToOverride: string | null;
  shiftPad: number | null;
  shiftIncrement: number | null;
  absenteeismLookbackWindow: number;
  unscheduledPenalty: number;
  absenteeismPercentile: number;
  unscheduledPercentile: number;
  absenteeismCap: number;
  unscheduledCap: number;
  absenteeismCutPremium: number;
  unscheduledCutPremium: number;
  taperPreset: string | null;
  skipMui: boolean | null;
};

export type GetLocationOdhTargetDataQueryVariables = Exact<{
  first?: InputMaybe<Scalars["NonNegativeInt"]>;
  last?: InputMaybe<Scalars["NonNegativeInt"]>;
  cursor?: InputMaybe<Scalars["String"]>;
  targetWeek: Scalars["String"];
}>;

export type GetLocationOdhTargetDataQuery = {
  __typename: "Query";
  locationTargets: {
    __typename: "LocationTargetConnection";
    totalCount: number;
    pageInfo: {
      __typename: "PageInfo";
      hasNextPage: boolean;
      startCursor: string;
      endCursor: string;
    };
    edges: Array<{
      __typename: "LocationTargetEdge";
      node: {
        __typename: "LocationTarget";
        id: string;
        title: string;
        locationTargetId: string | null;
        locationId: number;
        minODH: number | null;
        maxODH: number | null;
        targetDate: string | null;
        targetODH: number | null;
        driverWaitTime: number | null;
        mindpCar: number | null;
        mindpBike: number | null;
        mindpFoot: number | null;
        constrainFlag: string | null;
        absenteeAdjustCar: boolean | null;
        absenteeAdjustBike: boolean | null;
        absenteeAdjustFoot: boolean | null;
        openFromOverride: string | null;
        openToOverride: string | null;
        shiftPad: number | null;
        shiftIncrement: number | null;
        absenteeismLookbackWindow: number;
        unscheduledPenalty: number;
        absenteeismPercentile: number;
        unscheduledPercentile: number;
        absenteeismCap: number;
        unscheduledCap: number;
        absenteeismCutPremium: number;
        unscheduledCutPremium: number;
        taperPreset: string | null;
        skipMui: boolean | null;
      } | null;
    } | null> | null;
  } | null;
};

export type UpdateLocationOdhTargetDataMutationVariables = Exact<{
  locationTargetUpdateInput: LocationTargetUpdateInput;
}>;

export type UpdateLocationOdhTargetDataMutation = {
  __typename: "Mutation";
  updateLocationTargets: {
    __typename: "StandardMutationResponse";
    success: boolean;
    message: string;
  };
};

export type UploadOdhTargetsMutationVariables = Exact<{
  file: Scalars["Upload"];
  selectedWeek: Scalars["String"];
  allowDatesOutsideSelectedWeek: Scalars["Boolean"];
}>;

export type UploadOdhTargetsMutation = {
  __typename: "Mutation";
  uploadLocationTargets: {
    __typename: "StandardMutationResponse";
    success: boolean;
    message: string;
  };
};

export type CreateOrEditReforecastLayerMutationVariables = Exact<{
  date: Scalars["String"];
  orderAdjustment?: InputMaybe<Scalars["Int"]>;
  locationIds?: InputMaybe<
    | Array<InputMaybe<Scalars["NonNegativeInt"]>>
    | InputMaybe<Scalars["NonNegativeInt"]>
  >;
  metroRegion?: InputMaybe<Scalars["String"]>;
  countryCode?: InputMaybe<Scalars["String"]>;
}>;

export type CreateOrEditReforecastLayerMutation = {
  __typename: "Mutation";
  createOrEditReforecastLayer: {
    __typename: "StandardMutationResponse";
    success: boolean;
  };
};

export type GetMidWeekReforecastQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars["NonNegativeInt"]>;
  metroRegion?: InputMaybe<Scalars["String"]>;
  countryCode?: InputMaybe<Scalars["String"]>;
  operationalWeekStartDate: Scalars["String"];
}>;

export type GetMidWeekReforecastQuery = {
  __typename: "Query";
  midweekReforecast: {
    __typename: "MidweekReforecast";
    actuals: Array<number | null>;
    projection: Array<number | null>;
    ovfPublished: Array<number | null>;
    ovfPublishedVsActualsOrProjection: Array<number | null>;
    ovfReforecast: Array<number | null>;
    ovfReforecastVsProjection: Array<number | null>;
    seasonalAdjustments: Array<number | null>;
    referrals: Array<number | null>;
    promos: Array<number | null>;
    partners: Array<number | null>;
    planning: Array<number | null>;
    other: Array<number | null>;
    dailyReforecastAdjustment: Array<number | null>;
    totalAdjustments: Array<number | null>;
    dopplerRunActive: Array<number | null>;
    dopplerVsDoppler: Array<number | null>;
    dopplerRunPublished: Array<number | null>;
  } | null;
};

export type SubmitMidweekReforecastAdjustedOvfMutationVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
}>;

export type SubmitMidweekReforecastAdjustedOvfMutation = {
  __typename: "Mutation";
  submitMidweekReforecastAdjustedOvf: {
    __typename: "StandardMutationResponse";
    success: boolean;
    message: string;
  };
};

export type GetForecastLocationsByMetroRegionsQueryVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
  countryCode: Scalars["String"];
  weeksToInclude?: InputMaybe<Scalars["NonNegativeInt"]>;
}>;

export type GetForecastLocationsByMetroRegionsQuery = {
  __typename: "Query";
  forecastLocationsByMetroRegions: Array<{
    __typename: "LocationsByMetroRegion";
    name: string;
    locationIds: Array<number>;
  }>;
};

export type GetMidweekReforecastForMultiweekForecastQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars["NonNegativeInt"]>;
  metroRegion?: InputMaybe<Scalars["String"]>;
  countryCode?: InputMaybe<Scalars["String"]>;
  operationalWeekStartDate: Scalars["String"];
}>;

export type GetMidweekReforecastForMultiweekForecastQuery = {
  __typename: "Query";
  midweekReforecast: {
    __typename: "MidweekReforecast";
    dopplerRunActive: Array<number | null>;
    dopplerRunPublished: Array<number | null>;
    ovfPublished: Array<number | null>;
    ovfReforecast: Array<number | null>;
  } | null;
};

export type GetMultiweekForecastQueryVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
  locationIds: Array<Scalars["NonNegativeInt"]> | Scalars["NonNegativeInt"];
  weeks: Scalars["NonNegativeInt"];
}>;

export type GetMultiweekForecastQuery = {
  __typename: "Query";
  multiweekForecast: {
    __typename: "MultiweekForecast";
    adjustmentsWeeklyTotals: Array<number | null>;
    adjustmentsWeeklyTotalsGrowthRates: Array<number | null>;
    activeDopplerWeeklyTotals: Array<number | null>;
    ovfPublishedByWeek: Array<number | null>;
    ovfPublishedByWeekGrowthRates: Array<number | null>;
    thisYearActualsByWeek: Array<number | null>;
    thisYearActualsByWeekGrowthRates: Array<number | null>;
    lastYearActualsByWeek: Array<number | null>;
    lastYearActualsByWeekGrowthRates: Array<number | null>;
  } | null;
};

export type GetEibXlsxUrlQueryVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
  runId?: InputMaybe<Scalars["NonNegativeInt"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
}>;

export type GetEibXlsxUrlQuery = { __typename: "Query"; eibXlsxUrl: string };

export type GetMetroRegionsQueryVariables = Exact<{
  countryCode?: InputMaybe<Scalars["String"]>;
}>;

export type GetMetroRegionsQuery = {
  __typename: "Query";
  metroRegions: Array<string | null> | null;
};

export type GetMostRecentLaborMappingUploadTimestampQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetMostRecentLaborMappingUploadTimestampQuery = {
  __typename: "Query";
  getMostRecentLaborMappingUploadTimestamp: {
    __typename: "MostRecentLaborMappingUpload";
    date: string | null;
  } | null;
};

export type GetMostRecentOaLaborUploadTimestampQueryVariables = Exact<{
  operationalWeekStartDate?: InputMaybe<Scalars["String"]>;
}>;

export type GetMostRecentOaLaborUploadTimestampQuery = {
  __typename: "Query";
  getMostRecentOaLaborUploadTimestamp: {
    __typename: "MostRecentOaLaborUpload";
    date: string | null;
  } | null;
};

export type GetOaLocationClustersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  oaLocationClustersId?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  locationIds?: InputMaybe<Array<Scalars["Int"]> | Scalars["Int"]>;
}>;

export type GetOaLocationClustersQuery = {
  __typename: "Query";
  oaLocationClusters: Array<{
    __typename: "OaLocationCluster";
    id: number;
    name: string;
    location_ids: Array<number>;
    created_at: string;
    updated_at: string;
  } | null>;
};

export type GetOaLocationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  oaLocationsInput?: InputMaybe<OaLocationsInput>;
}>;

export type GetOaLocationsQuery = {
  __typename: "Query";
  oaLocations: Array<{
    __typename: "OaLocation";
    location_id: number;
    country_code: string;
    created_at: string | null;
    location_name: string;
    metro_region: string | null;
    state_code: string | null;
    updated_at: string | null;
  } | null>;
};

export type GetOaShiftsQueryVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
  adjustedOaHoursRunId: Scalars["NonNegativeInt"];
}>;

export type GetOaShiftsQuery = {
  __typename: "Query";
  oaShifts: Array<{
    __typename: "OaShift";
    locationName: string;
    opsDate: string;
    weekday: string;
    startTime: string;
    endTime: string;
    length: number;
    shiftLeader: string | null;
  }>;
};

export type RunGoSkedMutationVariables = Exact<{
  goSkedInput: GoSkedInput;
}>;

export type RunGoSkedMutation = {
  __typename: "Mutation";
  runGoSked: { __typename: "StandardMutationResponse"; success: boolean };
};

export type RunOaShifterMutationVariables = Exact<{
  oaShifterInput: OaShifterInput;
}>;

export type RunOaShifterMutation = {
  __typename: "Mutation";
  runOaShifter: { __typename: "StandardMutationResponse"; success: boolean };
};

export type GetShiftLeaderShiftRequestsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetShiftLeaderShiftRequestsQuery = {
  __typename: "Query";
  getShiftLeaderShiftRequests: Array<{
    __typename: "ShiftLeaderShiftRequest";
    location_id: number;
    shift_leader: string;
    location_name: string | null;
    day_of_week: string;
    start_time: string;
    length: number;
  } | null>;
};

export type UploadShiftLeaderShiftRequestsMutationVariables = Exact<{
  file: Scalars["Upload"];
}>;

export type UploadShiftLeaderShiftRequestsMutation = {
  __typename: "Mutation";
  uploadShiftLeaderShiftRequests: {
    __typename: "StandardMutationResponse";
    success: boolean;
  };
};

export type GetEventAdjustmentTotalsByDayQueryVariables = Exact<{
  country: Scalars["String"];
  operationalWeekStartDate: Scalars["String"];
}>;

export type GetEventAdjustmentTotalsByDayQuery = {
  __typename: "Query";
  eventAdjustmentTotalsByDay: Array<number>;
};

export type GetMostRecentOvfSubmitDateQueryVariables = Exact<{
  selectedWeek: Scalars["String"];
}>;

export type GetMostRecentOvfSubmitDateQuery = {
  __typename: "Query";
  mostRecentOvfSubmit: string | null;
};

export type GetOvfQaQueryVariables = Exact<{
  country: Scalars["String"];
  operationalWeekStartDate: Scalars["String"];
}>;

export type GetOvfQaQuery = {
  __typename: "Query";
  ovfQaLocations: Array<{
    __typename: "Location";
    id: string;
    title: string;
    forecasterId: number | null;
    threeWeekOrderHistory: number | null;
    dopplerForecast: number | null;
    dailyThreeWeekTrailingAverage: Array<number> | null;
    seasonalityAdjustments: {
      __typename: "SeasonalityAdjustments";
      weeklyLayer: Array<Array<number | null>>;
      dailyLayer: Array<Array<number | null>>;
      hourlyLayer: Array<Array<number | null>>;
      dopplerForecast: Array<Array<number | null>>;
    } | null;
    eventAdjustmentTotals: Array<{
      __typename: "EventAdjustmentTotal";
      tag: string;
      total: number;
    } | null> | null;
  } | null> | null;
};

export type SubmitOvfMutationVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
}>;

export type SubmitOvfMutation = {
  __typename: "Mutation";
  submitAdjustedOvf: {
    __typename: "StandardMutationResponse";
    success: boolean;
    message: string;
  };
};

export type ApproveAndReleaseShiftsMutationVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
  adjustedDHRunId: Scalars["NonNegativeInt"];
}>;

export type ApproveAndReleaseShiftsMutation = {
  __typename: "Mutation";
  approveAndReleaseShifts: {
    __typename: "StandardMutationResponse";
    success: boolean;
    message: string;
  };
};

export type GetMostRecentAdjustedHoursUploadDateQueryVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
}>;

export type GetMostRecentAdjustedHoursUploadDateQuery = {
  __typename: "Query";
  mostRecentAdjustedHoursUploadDate: {
    __typename: "MostRecentAdjustedHoursUpload";
    date: string | null;
  } | null;
};

export type GetMostRecentOdhTransformRunTimestampsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetMostRecentOdhTransformRunTimestampsQuery = {
  __typename: "Query";
  mostRecentOdhTransformRun: {
    __typename: "MostRecentOdhTransformRun";
    startDate: string | null;
    endDate: string | null;
    status: string | null;
  } | null;
  mostRecentOdhTransformJobDate: {
    __typename: "MostRecentOdhTransformJob";
    date: string | null;
    batch: string | null;
  } | null;
};

export type GetMostRecentShiftsApprovalTimestampQueryVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
  adjustedDHRunId: Scalars["NonNegativeInt"];
}>;

export type GetMostRecentShiftsApprovalTimestampQuery = {
  __typename: "Query";
  mostRecentShiftsApprovalTimestamp: string | null;
};

export type GetMostRecentShiftsPublishTimestampQueryVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
  adjustedDHRunId: Scalars["NonNegativeInt"];
}>;

export type GetMostRecentShiftsPublishTimestampQuery = {
  __typename: "Query";
  mostRecentShiftsPublishTimestamp: string | null;
};

export type GetMostRecentReportingBundleUploadTimestampQueryVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
  adjustedDHRunId: Scalars["NonNegativeInt"];
}>;

export type GetMostRecentReportingBundleUploadTimestampQuery = {
  __typename: "Query";
  mostRecentShiftsReportingBundleUploadTimestamp: string | null;
};

export type GetOdhLocationsQueryVariables = Exact<{
  batchId?: InputMaybe<Scalars["String"]>;
  operationalWeekStartDate: Scalars["String"];
}>;

export type GetOdhLocationsQuery = {
  __typename: "Query";
  odhLocations: Array<{
    __typename: "Location";
    id: string;
    title: string;
    ovf: {
      __typename: "HourlyOVF";
      dates: Array<string>;
      ovfs: Array<{
        __typename: "MultiModalHourlyData";
        mode: string;
        values: Array<Array<number | null>>;
      }>;
    } | null;
    driverHours: {
      __typename: "HourlyDriverHours";
      hours: Array<{
        __typename: "MultiModalHourlyData";
        mode: string;
        values: Array<Array<number | null>>;
      }>;
    } | null;
  } | null> | null;
};

export type GetSasUrlForFileInDsBlobStorageQueryVariables = Exact<{
  filename: Scalars["String"];
}>;

export type GetSasUrlForFileInDsBlobStorageQuery = {
  __typename: "Query";
  getSasUrlForFileInDSBlobStorage: string | null;
};

export type GetShifterPipelineRunsIdQueryVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
  adjustedDHRunId: Scalars["NonNegativeInt"];
}>;

export type GetShifterPipelineRunsIdQuery = {
  __typename: "Query";
  shifterPipelineRunsId: number | null;
};

export type GetShifterStatusQueryVariables = Exact<{
  adjustedDHRunId: Scalars["NonNegativeInt"];
}>;

export type GetShifterStatusQuery = {
  __typename: "Query";
  shifterStatus: {
    __typename: "ShifterStatus";
    state: string;
    databricksRunId: number | null;
  } | null;
};

export type GetShiftsQaLocationsByMetroRegionsQueryVariables = Exact<{
  countryCode: Scalars["String"];
  operationalWeekStartDate: Scalars["String"];
  adjustedDHRunId: Scalars["NonNegativeInt"];
}>;

export type GetShiftsQaLocationsByMetroRegionsQuery = {
  __typename: "Query";
  shiftsQALocationsByMetroRegions: Array<{
    __typename: "LocationsByMetroRegion";
    name: string;
    locationIds: Array<number>;
  }>;
};

export type GetShiftsDailyQaQueryVariables = Exact<{
  locationIds: Array<Scalars["NonNegativeInt"]> | Scalars["NonNegativeInt"];
  flaggedOnly?: InputMaybe<Scalars["Boolean"]>;
  operationalWeekStartDate: Scalars["String"];
  adjustedDHRunId: Scalars["NonNegativeInt"];
}>;

export type GetShiftsDailyQaQuery = {
  __typename: "Query";
  shiftsDailyQA: Array<{
    __typename: "ShiftsDailyQA";
    metroRegion: string | null;
    locationId: number;
    mode: string | null;
    date: string;
    weekday: string;
    ovf: number | null;
    odhTargetMin: number | null;
    odhTarget: number | null;
    odhTargetMax: number | null;
    odhPlan: number | null;
    odhPlanVar: number | null;
    odhSched: number | null;
    odhSchedVar: number | null;
    dhModeled: number | null;
    dhAdjusted: number | null;
    appliedAbsenteeismAdjustmentPercentage: number | null;
    appliedAbsenteeismAdjustmentHours: number | null;
    appliedUnscheduledPercentage: number | null;
    appliedUnscheduledHours: number | null;
    netAbsenteeismAdjustmentHours: number | null;
    dhNetOfAbsenteeismAdjustments: number | null;
    minimumDpAdjustment: number | null;
    dhPlanned: number | null;
    taperAdjustmentHours: number | null;
    dhPlannedTapered: number | null;
    dhPlannedTaperedPercentage: number | null;
    dhAssignedInitial: number | null;
    dhUnassignedInitial: number | null;
    dhNetOfAssigned: number | null;
    dhScheduled: number | null;
    dhScheduledMustRequest: number | null;
    dhTotalExpected: number | null;
    dhTotalUpdated: number | null;
    dhTotalDelta: number | null;
    dhAssignedDelta: number | null;
    dhFailedUpload: number | null;
    minHooStart: string | null;
    maxHooEnd: string | null;
    minShiftStart: string | null;
    maxShiftEnd: string | null;
    startEndFlag: boolean | null;
    dhVarFlag: boolean | null;
    odhFlag: boolean | null;
  }>;
};

export type GetShiftsHourlyQaCsvUrlQueryVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
  adjustedDHRunId: Scalars["NonNegativeInt"];
}>;

export type GetShiftsHourlyQaCsvUrlQuery = {
  __typename: "Query";
  shiftsHourlyQaCsvUrl: string;
};

export type GetDhFailedUploadQueryVariables = Exact<{
  locationIds: Array<Scalars["NonNegativeInt"]> | Scalars["NonNegativeInt"];
  operationalWeekStartDate: Scalars["String"];
  adjustedDHRunId: Scalars["NonNegativeInt"];
}>;

export type GetDhFailedUploadQuery = {
  __typename: "Query";
  shifts: Array<{
    __typename: "ShiftModelOutput";
    date: string;
    locationId: number;
    locationName: string;
    weekday: string;
    startTime: string;
    endTime: string;
    driverSlots: number;
    length: string;
    position: string;
    deliveryMode: string;
    createdTime: string;
    updatedTime: string;
    mustRequest: boolean | null;
    submitStatus: string | null;
  } | null> | null;
};

export type GetShiftsWeeklyQaQueryVariables = Exact<{
  locationIds: Array<Scalars["NonNegativeInt"]> | Scalars["NonNegativeInt"];
  flaggedOnly?: InputMaybe<Scalars["Boolean"]>;
  operationalWeekStartDate: Scalars["String"];
  adjustedDHRunId: Scalars["NonNegativeInt"];
}>;

export type GetShiftsWeeklyQaQuery = {
  __typename: "Query";
  shiftsWeeklyQA: Array<{
    __typename: "ShiftsWeeklyQA";
    metroRegion: string | null;
    locationId: number;
    ovf: number | null;
    odhTargetMin: number | null;
    odhTarget: number | null;
    odhTargetMax: number | null;
    odhPlan: number | null;
    odhPlanVar: number | null;
    odhSched: number | null;
    odhSchedVar: number | null;
    dhModeled: number | null;
    dhAdjusted: number | null;
    appliedAbsenteeismAdjustmentPercentage: number | null;
    appliedAbsenteeismAdjustmentHours: number | null;
    appliedUnscheduledPercentage: number | null;
    appliedUnscheduledHours: number | null;
    netAbsenteeismAdjustmentHours: number | null;
    dhNetOfAbsenteeismAdjustments: number | null;
    minimumDpAdjustment: number | null;
    dhPlanned: number | null;
    taperAdjustmentHours: number | null;
    dhPlannedTapered: number | null;
    dhAssignedInitial: number | null;
    dhUnassignedInitial: number | null;
    dhNetOfAssigned: number | null;
    dhScheduled: number | null;
    dhScheduledMustRequest: number | null;
    dhTotalExpected: number | null;
    dhTotalUpdated: number | null;
    dhTotalDelta: number | null;
    dhAssignedDelta: number | null;
    dhFailedUpload: number | null;
    flagged: boolean | null;
  }>;
};

export type PublishShifterPipelineMutationVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
  adjustedDHRunId: Scalars["NonNegativeInt"];
}>;

export type PublishShifterPipelineMutation = {
  __typename: "Mutation";
  publishShifterShifts: {
    __typename: "StandardMutationResponse";
    success: boolean;
    message: string;
  };
};

export type StartShifterPipelineMutationVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
  adjustedDHRunId: Scalars["NonNegativeInt"];
}>;

export type StartShifterPipelineMutation = {
  __typename: "Mutation";
  startShifterPipeline: {
    __typename: "StandardMutationResponse";
    success: boolean;
  };
};

export type StartTransformMutationVariables = Exact<{
  selectedWeek: Scalars["String"];
}>;

export type StartTransformMutation = {
  __typename: "Mutation";
  startOdhTransform: {
    __typename: "StandardMutationResponse";
    success: boolean;
  };
};

export type GetShiftsDailyQaTotalQueryVariables = Exact<{
  countryCode: Scalars["String"];
  operationalWeekStartDate: Scalars["String"];
  adjustedDHRunId: Scalars["NonNegativeInt"];
}>;

export type GetShiftsDailyQaTotalQuery = {
  __typename: "Query";
  shiftsDailyQATotal: Array<{
    __typename: "ShiftsDailyQATotal";
    date: string;
    weekday: string;
    ovf: number | null;
    dhModeled: number;
    dhAdjusted: number | null;
    dhNetOfHoursOfOperationAdjustments: number | null;
    appliedAbsenteeismAdjustmentPercentage: number | null;
    predictedAbsenteeismAdjustmentHours: number | null;
    appliedAbsenteeismAdjustmentHours: number | null;
    appliedUnscheduledPercentage: number | null;
    predictedUnscheduledHours: number | null;
    appliedUnscheduledHours: number | null;
    netAbsenteeismAdjustmentHours: number | null;
    dhNetOfAbsenteeismAdjustments: number | null;
    minimumDpAdjustment: number | null;
    dhPlanned: number | null;
    taperAdjustmentHours: number | null;
    dhPlannedTapered: number | null;
    dhAssignedInitial: number | null;
    dhUnassignedInitial: number | null;
    dhNetOfAssigned: number | null;
    dhScheduled: number | null;
    dhScheduledMustRequest: number | null;
    dhTotalExpected: number | null;
    dhTotalUpdated: number | null;
    dhTotalDelta: number | null;
    dhAssignedDelta: number | null;
    dhFailedUpload: number | null;
  }>;
};

export type GetShiftsWeeklyQaTotalQueryVariables = Exact<{
  countryCode: Scalars["String"];
  operationalWeekStartDate: Scalars["String"];
  adjustedDHRunId: Scalars["NonNegativeInt"];
}>;

export type GetShiftsWeeklyQaTotalQuery = {
  __typename: "Query";
  shiftsWeeklyQATotal: {
    __typename: "ShiftsWeeklyQATotal";
    ovf: number | null;
    dhModeled: number | null;
    dhAdjusted: number | null;
    dhNetOfHoursOfOperationAdjustments: number | null;
    appliedAbsenteeismAdjustmentPercentage: number | null;
    predictedAbsenteeismAdjustmentHours: number | null;
    appliedAbsenteeismAdjustmentHours: number | null;
    appliedUnscheduledPercentage: number | null;
    predictedUnscheduledHours: number | null;
    appliedUnscheduledHours: number | null;
    netAbsenteeismAdjustmentHours: number | null;
    dhNetOfAbsenteeismAdjustments: number | null;
    minimumDpAdjustment: number | null;
    dhPlanned: number | null;
    taperAdjustmentHours: number | null;
    dhPlannedTapered: number | null;
    dhAssignedInitial: number | null;
    dhUnassignedInitial: number | null;
    dhNetOfAssigned: number | null;
    dhScheduled: number | null;
    dhScheduledMustRequest: number | null;
    dhTotalExpected: number | null;
    dhTotalUpdated: number | null;
    dhTotalDelta: number | null;
    dhAssignedDelta: number | null;
    dhFailedUpload: number | null;
  };
};

export type UploadShiftsReportingBundleMutationVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
  adjustedDHRunId: Scalars["NonNegativeInt"];
}>;

export type UploadShiftsReportingBundleMutation = {
  __typename: "Mutation";
  uploadShiftsReportingBundle: {
    __typename: "StandardMutationResponse";
    success: boolean;
  };
};

export type ValidateShifterPipelineMutationVariables = Exact<{
  operationalWeekStartDate: Scalars["String"];
  adjustedDHRunId: Scalars["NonNegativeInt"];
}>;

export type ValidateShifterPipelineMutation = {
  __typename: "Mutation";
  validateShifterShifts: {
    __typename: "StandardMutationResponse";
    success: boolean;
    message: string;
  };
};

export type GetRunsQueryVariables = Exact<{
  runsListParams: RunsListParams;
  environment?: InputMaybe<Scalars["String"]>;
}>;

export type GetRunsQuery = {
  __typename: "Query";
  getRunsList: {
    __typename: "Job";
    runs: Array<{
      __typename: "Run";
      job_id: number;
      run_id: number;
      number_in_job: number | null;
      original_attempt_run_id: number | null;
      start_time: any | null;
      setup_duration: any | null;
      execution_duration: any | null;
      cleanup_duration: any | null;
      end_time: any | null;
      trigger: string | null;
      creator_user_name: string | null;
      run_name: string | null;
      run_page_url: string | null;
      run_type: string | null;
      format: string | null;
      state: {
        __typename: "State";
        life_cycle_state: string | null;
        result_state: string | null;
        state_message: string | null;
        user_cancelled_or_timedout: boolean | null;
      } | null;
      overriding_parameters: {
        __typename: "OverridingParameters";
        notebook_params: {
          __typename: "NotebookParams";
          run_time: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type UploadAdjustedOvfMutationVariables = Exact<{
  file: Scalars["Upload"];
  selectedWeek: Scalars["String"];
  allowDatesOutsideSelectedWeek?: InputMaybe<Scalars["Boolean"]>;
}>;

export type UploadAdjustedOvfMutation = {
  __typename: "Mutation";
  uploadOvfCsv: {
    __typename: "StandardMutationResponse";
    success: boolean;
    message: string;
  };
};

export type GetWeeklyAdjustTableDataQueryVariables = Exact<{
  forecasterId?: InputMaybe<Scalars["String"]>;
  operationalWeekStartDate: Scalars["String"];
}>;

export type GetWeeklyAdjustTableDataQuery = {
  __typename: "Query";
  weeklyAdjustLocations: Array<{
    __typename: "Location";
    id: string;
    title: string;
    threeWeekOrderHistory: number | null;
    dopplerForecast: number | null;
    seasonalityAdjustments: {
      __typename: "SeasonalityAdjustments";
      weeklyLayer: Array<Array<number | null>>;
      weeklyOverride: number;
      dailyLayer: Array<Array<number | null>>;
      hourlyLayer: Array<Array<number | null>>;
    } | null;
    eventAdjustmentTotals: Array<{
      __typename: "EventAdjustmentTotal";
      tag: string;
      total: number;
    } | null> | null;
  } | null> | null;
};

export type UpsertWeeklyAdjustmentMutationVariables = Exact<{
  locationId: Scalars["NonNegativeInt"];
  forecasterId?: InputMaybe<Scalars["NonNegativeInt"]>;
  adjustmentType: Scalars["String"];
  operationalWeekStartDate: Scalars["String"];
  dateString: Scalars["String"];
  value?: InputMaybe<Scalars["Float"]>;
}>;

export type UpsertWeeklyAdjustmentMutation = {
  __typename: "Mutation";
  upsertSeasonalAdjustment: {
    __typename: "SeasonalityAdjustments";
    dates: Array<string>;
    success: boolean;
    dopplerForecast: Array<Array<number | null>>;
    weeklyOverride: number;
    weeklyLayer: Array<Array<number | null>>;
    dailyOverrides: Array<number | null>;
    dailyLayer: Array<Array<number | null>>;
    hourlyOverrides: Array<Array<number | null>>;
    hourlyLayer: Array<Array<number | null>>;
    totalSeasonalityAdjustedForecastDistribution: Array<Array<number | null>>;
    dailySeasonalityAdjustedForecastDistribution: Array<number>;
  };
};

export const GetLocationOdhTargetFieldsFragmentDoc = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GetLocationODHTargetFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LocationTarget" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "locationTargetId" } },
          { kind: "Field", name: { kind: "Name", value: "locationId" } },
          { kind: "Field", name: { kind: "Name", value: "minODH" } },
          { kind: "Field", name: { kind: "Name", value: "maxODH" } },
          { kind: "Field", name: { kind: "Name", value: "targetDate" } },
          { kind: "Field", name: { kind: "Name", value: "targetODH" } },
          { kind: "Field", name: { kind: "Name", value: "driverWaitTime" } },
          { kind: "Field", name: { kind: "Name", value: "mindpCar" } },
          { kind: "Field", name: { kind: "Name", value: "mindpBike" } },
          { kind: "Field", name: { kind: "Name", value: "mindpFoot" } },
          { kind: "Field", name: { kind: "Name", value: "constrainFlag" } },
          { kind: "Field", name: { kind: "Name", value: "absenteeAdjustCar" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "absenteeAdjustBike" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "absenteeAdjustFoot" },
          },
          { kind: "Field", name: { kind: "Name", value: "openFromOverride" } },
          { kind: "Field", name: { kind: "Name", value: "openToOverride" } },
          { kind: "Field", name: { kind: "Name", value: "shiftPad" } },
          { kind: "Field", name: { kind: "Name", value: "shiftIncrement" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "absenteeismLookbackWindow" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "unscheduledPenalty" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "absenteeismPercentile" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "unscheduledPercentile" },
          },
          { kind: "Field", name: { kind: "Name", value: "absenteeismCap" } },
          { kind: "Field", name: { kind: "Name", value: "unscheduledCap" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "absenteeismCutPremium" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "unscheduledCutPremium" },
          },
          { kind: "Field", name: { kind: "Name", value: "taperPreset" } },
          { kind: "Field", name: { kind: "Name", value: "skipMui" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GetAdjustedDriverHourLocationsDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAdjustedDriverHourLocations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "adjustedDriverHoursRunId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adjustedDriverHourLocations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "runId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "adjustedDriverHoursRunId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "driverHours" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "dates" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hours" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "values" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAdjustedDriverHourLocationsQuery__
 *
 * To run a query within a React component, call `useGetAdjustedDriverHourLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdjustedDriverHourLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdjustedDriverHourLocationsQuery({
 *   variables: {
 *      adjustedDriverHoursRunId: // value for 'adjustedDriverHoursRunId'
 *   },
 * });
 */
export function useGetAdjustedDriverHourLocationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdjustedDriverHourLocationsQuery,
    GetAdjustedDriverHourLocationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAdjustedDriverHourLocationsQuery,
    GetAdjustedDriverHourLocationsQueryVariables
  >(GetAdjustedDriverHourLocationsDocument, options);
}
export function useGetAdjustedDriverHourLocationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdjustedDriverHourLocationsQuery,
    GetAdjustedDriverHourLocationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAdjustedDriverHourLocationsQuery,
    GetAdjustedDriverHourLocationsQueryVariables
  >(GetAdjustedDriverHourLocationsDocument, options);
}
export type GetAdjustedDriverHourLocationsQueryHookResult = ReturnType<
  typeof useGetAdjustedDriverHourLocationsQuery
>;
export type GetAdjustedDriverHourLocationsLazyQueryHookResult = ReturnType<
  typeof useGetAdjustedDriverHourLocationsLazyQuery
>;
export const GetAdjustedDriverHoursRunsForWeekDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAdjustedDriverHoursRunsForWeek" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAdjustedDriverHoursRunsForWeek" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "odhRunsId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAdjustedDriverHoursRunsForWeekQuery__
 *
 * To run a query within a React component, call `useGetAdjustedDriverHoursRunsForWeekQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdjustedDriverHoursRunsForWeekQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdjustedDriverHoursRunsForWeekQuery({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *   },
 * });
 */
export function useGetAdjustedDriverHoursRunsForWeekQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdjustedDriverHoursRunsForWeekQuery,
    GetAdjustedDriverHoursRunsForWeekQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAdjustedDriverHoursRunsForWeekQuery,
    GetAdjustedDriverHoursRunsForWeekQueryVariables
  >(GetAdjustedDriverHoursRunsForWeekDocument, options);
}
export function useGetAdjustedDriverHoursRunsForWeekLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdjustedDriverHoursRunsForWeekQuery,
    GetAdjustedDriverHoursRunsForWeekQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAdjustedDriverHoursRunsForWeekQuery,
    GetAdjustedDriverHoursRunsForWeekQueryVariables
  >(GetAdjustedDriverHoursRunsForWeekDocument, options);
}
export type GetAdjustedDriverHoursRunsForWeekQueryHookResult = ReturnType<
  typeof useGetAdjustedDriverHoursRunsForWeekQuery
>;
export type GetAdjustedDriverHoursRunsForWeekLazyQueryHookResult = ReturnType<
  typeof useGetAdjustedDriverHoursRunsForWeekLazyQuery
>;
export const GetAdjustedOaHoursDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAdjustedOaHours" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "adjustedOaHoursRunId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAdjustedOaHours" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "runId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "adjustedOaHoursRunId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "location_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location_name" },
                },
                { kind: "Field", name: { kind: "Name", value: "ops_date" } },
                { kind: "Field", name: { kind: "Name", value: "local_time" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "gosked_total_hours" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "gosked_pack_hours" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "gosked_inbound_hours" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "gosked_hours" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAdjustedOaHoursQuery__
 *
 * To run a query within a React component, call `useGetAdjustedOaHoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdjustedOaHoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdjustedOaHoursQuery({
 *   variables: {
 *      adjustedOaHoursRunId: // value for 'adjustedOaHoursRunId'
 *   },
 * });
 */
export function useGetAdjustedOaHoursQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdjustedOaHoursQuery,
    GetAdjustedOaHoursQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAdjustedOaHoursQuery,
    GetAdjustedOaHoursQueryVariables
  >(GetAdjustedOaHoursDocument, options);
}
export function useGetAdjustedOaHoursLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdjustedOaHoursQuery,
    GetAdjustedOaHoursQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAdjustedOaHoursQuery,
    GetAdjustedOaHoursQueryVariables
  >(GetAdjustedOaHoursDocument, options);
}
export type GetAdjustedOaHoursQueryHookResult = ReturnType<
  typeof useGetAdjustedOaHoursQuery
>;
export type GetAdjustedOaHoursLazyQueryHookResult = ReturnType<
  typeof useGetAdjustedOaHoursLazyQuery
>;
export const GetAdjustedOaHoursRunsForWeekDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAdjustedOaHoursRunsForWeek" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAdjustedOaHoursRunsForWeek" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "ophRunsId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAdjustedOaHoursRunsForWeekQuery__
 *
 * To run a query within a React component, call `useGetAdjustedOaHoursRunsForWeekQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdjustedOaHoursRunsForWeekQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdjustedOaHoursRunsForWeekQuery({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *   },
 * });
 */
export function useGetAdjustedOaHoursRunsForWeekQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdjustedOaHoursRunsForWeekQuery,
    GetAdjustedOaHoursRunsForWeekQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAdjustedOaHoursRunsForWeekQuery,
    GetAdjustedOaHoursRunsForWeekQueryVariables
  >(GetAdjustedOaHoursRunsForWeekDocument, options);
}
export function useGetAdjustedOaHoursRunsForWeekLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdjustedOaHoursRunsForWeekQuery,
    GetAdjustedOaHoursRunsForWeekQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAdjustedOaHoursRunsForWeekQuery,
    GetAdjustedOaHoursRunsForWeekQueryVariables
  >(GetAdjustedOaHoursRunsForWeekDocument, options);
}
export type GetAdjustedOaHoursRunsForWeekQueryHookResult = ReturnType<
  typeof useGetAdjustedOaHoursRunsForWeekQuery
>;
export type GetAdjustedOaHoursRunsForWeekLazyQueryHookResult = ReturnType<
  typeof useGetAdjustedOaHoursRunsForWeekLazyQuery
>;
export const GetCountryCodesDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCountryCodes" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countries" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "countryCode" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetCountryCodesQuery__
 *
 * To run a query within a React component, call `useGetCountryCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountryCodesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCountryCodesQuery,
    GetCountryCodesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCountryCodesQuery, GetCountryCodesQueryVariables>(
    GetCountryCodesDocument,
    options
  );
}
export function useGetCountryCodesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCountryCodesQuery,
    GetCountryCodesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCountryCodesQuery,
    GetCountryCodesQueryVariables
  >(GetCountryCodesDocument, options);
}
export type GetCountryCodesQueryHookResult = ReturnType<
  typeof useGetCountryCodesQuery
>;
export type GetCountryCodesLazyQueryHookResult = ReturnType<
  typeof useGetCountryCodesLazyQuery
>;
export const GetForecasterIdsDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetForecasterIds" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "forecasters" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetForecasterIdsQuery__
 *
 * To run a query within a React component, call `useGetForecasterIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetForecasterIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetForecasterIdsQuery({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *   },
 * });
 */
export function useGetForecasterIdsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetForecasterIdsQuery,
    GetForecasterIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetForecasterIdsQuery, GetForecasterIdsQueryVariables>(
    GetForecasterIdsDocument,
    options
  );
}
export function useGetForecasterIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetForecasterIdsQuery,
    GetForecasterIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetForecasterIdsQuery,
    GetForecasterIdsQueryVariables
  >(GetForecasterIdsDocument, options);
}
export type GetForecasterIdsQueryHookResult = ReturnType<
  typeof useGetForecasterIdsQuery
>;
export type GetForecasterIdsLazyQueryHookResult = ReturnType<
  typeof useGetForecasterIdsLazyQuery
>;
export const UploadAdjustedDriverHoursDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UploadAdjustedDriverHours" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "file" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Upload" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "selectedWeek" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadDriverHoursCsv" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "uploadDriverHoursCsvInput" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "file" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "file" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "selectedWeek" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "selectedWeek" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UploadAdjustedDriverHoursMutationFn = Apollo.MutationFunction<
  UploadAdjustedDriverHoursMutation,
  UploadAdjustedDriverHoursMutationVariables
>;

/**
 * __useUploadAdjustedDriverHoursMutation__
 *
 * To run a mutation, you first call `useUploadAdjustedDriverHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAdjustedDriverHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAdjustedDriverHoursMutation, { data, loading, error }] = useUploadAdjustedDriverHoursMutation({
 *   variables: {
 *      file: // value for 'file'
 *      selectedWeek: // value for 'selectedWeek'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUploadAdjustedDriverHoursMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadAdjustedDriverHoursMutation,
    UploadAdjustedDriverHoursMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadAdjustedDriverHoursMutation,
    UploadAdjustedDriverHoursMutationVariables
  >(UploadAdjustedDriverHoursDocument, options);
}
export type UploadAdjustedDriverHoursMutationHookResult = ReturnType<
  typeof useUploadAdjustedDriverHoursMutation
>;
export const UploadIncrementalAdjustedDriverHoursDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UploadIncrementalAdjustedDriverHours" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "file" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Upload" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "selectedWeek" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "uploadIncrementalAdjustedDriverHoursCsv",
            },
            arguments: [
              {
                kind: "Argument",
                name: {
                  kind: "Name",
                  value: "uploadIncrementalDriverHoursCsvInput",
                },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "file" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "file" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "selectedWeek" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "selectedWeek" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UploadIncrementalAdjustedDriverHoursMutationFn =
  Apollo.MutationFunction<
    UploadIncrementalAdjustedDriverHoursMutation,
    UploadIncrementalAdjustedDriverHoursMutationVariables
  >;

/**
 * __useUploadIncrementalAdjustedDriverHoursMutation__
 *
 * To run a mutation, you first call `useUploadIncrementalAdjustedDriverHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadIncrementalAdjustedDriverHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadIncrementalAdjustedDriverHoursMutation, { data, loading, error }] = useUploadIncrementalAdjustedDriverHoursMutation({
 *   variables: {
 *      file: // value for 'file'
 *      selectedWeek: // value for 'selectedWeek'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUploadIncrementalAdjustedDriverHoursMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadIncrementalAdjustedDriverHoursMutation,
    UploadIncrementalAdjustedDriverHoursMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadIncrementalAdjustedDriverHoursMutation,
    UploadIncrementalAdjustedDriverHoursMutationVariables
  >(UploadIncrementalAdjustedDriverHoursDocument, options);
}
export type UploadIncrementalAdjustedDriverHoursMutationHookResult = ReturnType<
  typeof useUploadIncrementalAdjustedDriverHoursMutation
>;
export const UploadOaHoursDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UploadOaHours" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "file" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Upload" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "selectedWeek" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadOAHours" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "uploadOAHoursInput" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "file" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "file" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "selectedWeek" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "selectedWeek" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UploadOaHoursMutationFn = Apollo.MutationFunction<
  UploadOaHoursMutation,
  UploadOaHoursMutationVariables
>;

/**
 * __useUploadOaHoursMutation__
 *
 * To run a mutation, you first call `useUploadOaHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadOaHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadOaHoursMutation, { data, loading, error }] = useUploadOaHoursMutation({
 *   variables: {
 *      file: // value for 'file'
 *      selectedWeek: // value for 'selectedWeek'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUploadOaHoursMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadOaHoursMutation,
    UploadOaHoursMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadOaHoursMutation,
    UploadOaHoursMutationVariables
  >(UploadOaHoursDocument, options);
}
export type UploadOaHoursMutationHookResult = ReturnType<
  typeof useUploadOaHoursMutation
>;
export const UploadOaLaborMappingDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UploadOaLaborMapping" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "file" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Upload" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadOaLaborMapping" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "uploadOaLaborMappingInput" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "file" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "file" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UploadOaLaborMappingMutationFn = Apollo.MutationFunction<
  UploadOaLaborMappingMutation,
  UploadOaLaborMappingMutationVariables
>;

/**
 * __useUploadOaLaborMappingMutation__
 *
 * To run a mutation, you first call `useUploadOaLaborMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadOaLaborMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadOaLaborMappingMutation, { data, loading, error }] = useUploadOaLaborMappingMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadOaLaborMappingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadOaLaborMappingMutation,
    UploadOaLaborMappingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadOaLaborMappingMutation,
    UploadOaLaborMappingMutationVariables
  >(UploadOaLaborMappingDocument, options);
}
export type UploadOaLaborMappingMutationHookResult = ReturnType<
  typeof useUploadOaLaborMappingMutation
>;
export const GenerateSasTokenDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "GenerateSasToken" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "connectionString" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "permissions" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "containerName" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "generateSasToken" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "connectionString" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "connectionString" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "permissions" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "permissions" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "containerName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "containerName" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "token" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type GenerateSasTokenMutationFn = Apollo.MutationFunction<
  GenerateSasTokenMutation,
  GenerateSasTokenMutationVariables
>;

/**
 * __useGenerateSasTokenMutation__
 *
 * To run a mutation, you first call `useGenerateSasTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSasTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSasTokenMutation, { data, loading, error }] = useGenerateSasTokenMutation({
 *   variables: {
 *      connectionString: // value for 'connectionString'
 *      permissions: // value for 'permissions'
 *      containerName: // value for 'containerName'
 *   },
 * });
 */
export function useGenerateSasTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateSasTokenMutation,
    GenerateSasTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateSasTokenMutation,
    GenerateSasTokenMutationVariables
  >(GenerateSasTokenDocument, options);
}
export type GenerateSasTokenMutationHookResult = ReturnType<
  typeof useGenerateSasTokenMutation
>;
export const GetLatestJobStatusDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLatestJobStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "jobId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "environment" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getLatestJobStatus" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "jobID" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "jobId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "environment" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "environment" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetLatestJobStatusQuery__
 *
 * To run a query within a React component, call `useGetLatestJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestJobStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      environment: // value for 'environment'
 *   },
 * });
 */
export function useGetLatestJobStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLatestJobStatusQuery,
    GetLatestJobStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLatestJobStatusQuery,
    GetLatestJobStatusQueryVariables
  >(GetLatestJobStatusDocument, options);
}
export function useGetLatestJobStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLatestJobStatusQuery,
    GetLatestJobStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLatestJobStatusQuery,
    GetLatestJobStatusQueryVariables
  >(GetLatestJobStatusDocument, options);
}
export type GetLatestJobStatusQueryHookResult = ReturnType<
  typeof useGetLatestJobStatusQuery
>;
export type GetLatestJobStatusLazyQueryHookResult = ReturnType<
  typeof useGetLatestJobStatusLazyQuery
>;
export const TriggerJobRunDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "TriggerJobRun" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "jobId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "queryParams" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "JSON" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "environment" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "triggerJobRun" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "jobId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "jobId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "queryParams" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "queryParams" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "environment" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "environment" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "run_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "number_in_job" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type TriggerJobRunMutationFn = Apollo.MutationFunction<
  TriggerJobRunMutation,
  TriggerJobRunMutationVariables
>;

/**
 * __useTriggerJobRunMutation__
 *
 * To run a mutation, you first call `useTriggerJobRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerJobRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerJobRunMutation, { data, loading, error }] = useTriggerJobRunMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      queryParams: // value for 'queryParams'
 *      environment: // value for 'environment'
 *   },
 * });
 */
export function useTriggerJobRunMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriggerJobRunMutation,
    TriggerJobRunMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TriggerJobRunMutation,
    TriggerJobRunMutationVariables
  >(TriggerJobRunDocument, options);
}
export type TriggerJobRunMutationHookResult = ReturnType<
  typeof useTriggerJobRunMutation
>;
export const CancelAllJobRunsDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelAllJobRuns" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "jobId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "environment" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelAllJobRuns" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "jobId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "jobId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "environment" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "environment" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CancelAllJobRunsMutationFn = Apollo.MutationFunction<
  CancelAllJobRunsMutation,
  CancelAllJobRunsMutationVariables
>;

/**
 * __useCancelAllJobRunsMutation__
 *
 * To run a mutation, you first call `useCancelAllJobRunsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAllJobRunsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAllJobRunsMutation, { data, loading, error }] = useCancelAllJobRunsMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      environment: // value for 'environment'
 *   },
 * });
 */
export function useCancelAllJobRunsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelAllJobRunsMutation,
    CancelAllJobRunsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelAllJobRunsMutation,
    CancelAllJobRunsMutationVariables
  >(CancelAllJobRunsDocument, options);
}
export type CancelAllJobRunsMutationHookResult = ReturnType<
  typeof useCancelAllJobRunsMutation
>;
export const GetSecretDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSecret" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "key" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "secret" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "key" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "key" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetSecretQuery__
 *
 * To run a query within a React component, call `useGetSecretQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSecretQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSecretQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetSecretQuery(
  baseOptions: Apollo.QueryHookOptions<GetSecretQuery, GetSecretQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSecretQuery, GetSecretQueryVariables>(
    GetSecretDocument,
    options
  );
}
export function useGetSecretLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSecretQuery,
    GetSecretQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSecretQuery, GetSecretQueryVariables>(
    GetSecretDocument,
    options
  );
}
export type GetSecretQueryHookResult = ReturnType<typeof useGetSecretQuery>;
export type GetSecretLazyQueryHookResult = ReturnType<
  typeof useGetSecretLazyQuery
>;
export const GetLocationIdsByForecasterDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLocationIdsByForecaster" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "forecaster" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "locations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "forecasterId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "forecaster" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetLocationIdsByForecasterQuery__
 *
 * To run a query within a React component, call `useGetLocationIdsByForecasterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationIdsByForecasterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationIdsByForecasterQuery({
 *   variables: {
 *      forecaster: // value for 'forecaster'
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *   },
 * });
 */
export function useGetLocationIdsByForecasterQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLocationIdsByForecasterQuery,
    GetLocationIdsByForecasterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLocationIdsByForecasterQuery,
    GetLocationIdsByForecasterQueryVariables
  >(GetLocationIdsByForecasterDocument, options);
}
export function useGetLocationIdsByForecasterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLocationIdsByForecasterQuery,
    GetLocationIdsByForecasterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLocationIdsByForecasterQuery,
    GetLocationIdsByForecasterQueryVariables
  >(GetLocationIdsByForecasterDocument, options);
}
export type GetLocationIdsByForecasterQueryHookResult = ReturnType<
  typeof useGetLocationIdsByForecasterQuery
>;
export type GetLocationIdsByForecasterLazyQueryHookResult = ReturnType<
  typeof useGetLocationIdsByForecasterLazyQuery
>;
export const GetLocationSeasonalityAdjustmentsDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLocationSeasonalityAdjustments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "NonNegativeInt" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "locations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "ids" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "ids" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "threeWeekTrailingAverage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hourlyPercentages" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dailyPercentages" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "seasonalityAdjustments" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "operationalWeekStartDate" },
                      value: {
                        kind: "Variable",
                        name: {
                          kind: "Name",
                          value: "operationalWeekStartDate",
                        },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "dates" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dopplerForecast" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hourlyOverrides" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dailyOverrides" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "totalSeasonalityAdjustedForecastDistribution",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "dailySeasonalityAdjustedForecastDistribution",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetLocationSeasonalityAdjustmentsQuery__
 *
 * To run a query within a React component, call `useGetLocationSeasonalityAdjustmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationSeasonalityAdjustmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationSeasonalityAdjustmentsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *   },
 * });
 */
export function useGetLocationSeasonalityAdjustmentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLocationSeasonalityAdjustmentsQuery,
    GetLocationSeasonalityAdjustmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLocationSeasonalityAdjustmentsQuery,
    GetLocationSeasonalityAdjustmentsQueryVariables
  >(GetLocationSeasonalityAdjustmentsDocument, options);
}
export function useGetLocationSeasonalityAdjustmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLocationSeasonalityAdjustmentsQuery,
    GetLocationSeasonalityAdjustmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLocationSeasonalityAdjustmentsQuery,
    GetLocationSeasonalityAdjustmentsQueryVariables
  >(GetLocationSeasonalityAdjustmentsDocument, options);
}
export type GetLocationSeasonalityAdjustmentsQueryHookResult = ReturnType<
  typeof useGetLocationSeasonalityAdjustmentsQuery
>;
export type GetLocationSeasonalityAdjustmentsLazyQueryHookResult = ReturnType<
  typeof useGetLocationSeasonalityAdjustmentsLazyQuery
>;
export const SetAllHourlyAdjustmentsToHistoricalAverageDocument =
  /*#__PURE__*/ {
    kind: "Document",
    definitions: [
      {
        kind: "OperationDefinition",
        operation: "mutation",
        name: {
          kind: "Name",
          value: "SetAllHourlyAdjustmentsToHistoricalAverage",
        },
        variableDefinitions: [
          {
            kind: "VariableDefinition",
            variable: {
              kind: "Variable",
              name: { kind: "Name", value: "locationId" },
            },
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "NonNegativeInt" },
              },
            },
          },
          {
            kind: "VariableDefinition",
            variable: {
              kind: "Variable",
              name: { kind: "Name", value: "operationalWeekStartDate" },
            },
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" },
              },
            },
          },
          {
            kind: "VariableDefinition",
            variable: {
              kind: "Variable",
              name: { kind: "Name", value: "weeksInPast" },
            },
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "NonNegativeInt" },
              },
            },
          },
          {
            kind: "VariableDefinition",
            variable: {
              kind: "Variable",
              name: { kind: "Name", value: "isMetroRegion" },
            },
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        ],
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "setAllHourlyAdjustmentsToHistoricalAverage",
              },
              arguments: [
                {
                  kind: "Argument",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                  value: {
                    kind: "Variable",
                    name: { kind: "Name", value: "operationalWeekStartDate" },
                  },
                },
                {
                  kind: "Argument",
                  name: { kind: "Name", value: "locationId" },
                  value: {
                    kind: "Variable",
                    name: { kind: "Name", value: "locationId" },
                  },
                },
                {
                  kind: "Argument",
                  name: { kind: "Name", value: "weeksInPast" },
                  value: {
                    kind: "Variable",
                    name: { kind: "Name", value: "weeksInPast" },
                  },
                },
                {
                  kind: "Argument",
                  name: { kind: "Name", value: "isMetroRegion" },
                  value: {
                    kind: "Variable",
                    name: { kind: "Name", value: "isMetroRegion" },
                  },
                },
              ],
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  { kind: "Field", name: { kind: "Name", value: "success" } },
                ],
              },
            },
          ],
        },
      },
    ],
  } as unknown as DocumentNode;
export type SetAllHourlyAdjustmentsToHistoricalAverageMutationFn =
  Apollo.MutationFunction<
    SetAllHourlyAdjustmentsToHistoricalAverageMutation,
    SetAllHourlyAdjustmentsToHistoricalAverageMutationVariables
  >;

/**
 * __useSetAllHourlyAdjustmentsToHistoricalAverageMutation__
 *
 * To run a mutation, you first call `useSetAllHourlyAdjustmentsToHistoricalAverageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAllHourlyAdjustmentsToHistoricalAverageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAllHourlyAdjustmentsToHistoricalAverageMutation, { data, loading, error }] = useSetAllHourlyAdjustmentsToHistoricalAverageMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      weeksInPast: // value for 'weeksInPast'
 *      isMetroRegion: // value for 'isMetroRegion'
 *   },
 * });
 */
export function useSetAllHourlyAdjustmentsToHistoricalAverageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetAllHourlyAdjustmentsToHistoricalAverageMutation,
    SetAllHourlyAdjustmentsToHistoricalAverageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetAllHourlyAdjustmentsToHistoricalAverageMutation,
    SetAllHourlyAdjustmentsToHistoricalAverageMutationVariables
  >(SetAllHourlyAdjustmentsToHistoricalAverageDocument, options);
}
export type SetAllHourlyAdjustmentsToHistoricalAverageMutationHookResult =
  ReturnType<typeof useSetAllHourlyAdjustmentsToHistoricalAverageMutation>;
export const UpsertSeasonalAdjustmentDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpsertSeasonalAdjustment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locationId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "forecasterId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "NonNegativeInt" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "adjustmentType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateString" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "value" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "upsertSeasonalAdjustment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "forecasterId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "forecasterId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "adjustmentType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "adjustmentType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dateString" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dateString" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "value" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "value" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpsertSeasonalAdjustmentMutationFn = Apollo.MutationFunction<
  UpsertSeasonalAdjustmentMutation,
  UpsertSeasonalAdjustmentMutationVariables
>;

/**
 * __useUpsertSeasonalAdjustmentMutation__
 *
 * To run a mutation, you first call `useUpsertSeasonalAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSeasonalAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSeasonalAdjustmentMutation, { data, loading, error }] = useUpsertSeasonalAdjustmentMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      forecasterId: // value for 'forecasterId'
 *      adjustmentType: // value for 'adjustmentType'
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      dateString: // value for 'dateString'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpsertSeasonalAdjustmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertSeasonalAdjustmentMutation,
    UpsertSeasonalAdjustmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertSeasonalAdjustmentMutation,
    UpsertSeasonalAdjustmentMutationVariables
  >(UpsertSeasonalAdjustmentDocument, options);
}
export type UpsertSeasonalAdjustmentMutationHookResult = ReturnType<
  typeof useUpsertSeasonalAdjustmentMutation
>;
export const GetCurrentlyActiveDopplerRunDateDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCurrentlyActiveDopplerRunDate" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentlyActiveDopplerRunDate" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetCurrentlyActiveDopplerRunDateQuery__
 *
 * To run a query within a React component, call `useGetCurrentlyActiveDopplerRunDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentlyActiveDopplerRunDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentlyActiveDopplerRunDateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentlyActiveDopplerRunDateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCurrentlyActiveDopplerRunDateQuery,
    GetCurrentlyActiveDopplerRunDateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCurrentlyActiveDopplerRunDateQuery,
    GetCurrentlyActiveDopplerRunDateQueryVariables
  >(GetCurrentlyActiveDopplerRunDateDocument, options);
}
export function useGetCurrentlyActiveDopplerRunDateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCurrentlyActiveDopplerRunDateQuery,
    GetCurrentlyActiveDopplerRunDateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCurrentlyActiveDopplerRunDateQuery,
    GetCurrentlyActiveDopplerRunDateQueryVariables
  >(GetCurrentlyActiveDopplerRunDateDocument, options);
}
export type GetCurrentlyActiveDopplerRunDateQueryHookResult = ReturnType<
  typeof useGetCurrentlyActiveDopplerRunDateQuery
>;
export type GetCurrentlyActiveDopplerRunDateLazyQueryHookResult = ReturnType<
  typeof useGetCurrentlyActiveDopplerRunDateLazyQuery
>;
export const GetDopplerQaDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDopplerQA" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "runId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "dopplerQA" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "runId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "runId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dopplerRunDateTime" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "qaRunDateTime" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "weeklyQAByCountry" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "countryCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "weeklyQA" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "operationalWeekStartDate",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "orders" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "locationsInDoppler",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "locationsInBackOffice",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "weeklyMissingLocations",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "locationId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "forecasterId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "launchDate" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "missingInDoppler",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "dailyMissingLocations",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "locationId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "forecasterId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "date" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "missingInDoppler",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "hourlyMissingLocations",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "locationId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "forecasterId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "datetime" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "missingInDoppler",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetDopplerQaQuery__
 *
 * To run a query within a React component, call `useGetDopplerQaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDopplerQaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDopplerQaQuery({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useGetDopplerQaQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDopplerQaQuery,
    GetDopplerQaQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDopplerQaQuery, GetDopplerQaQueryVariables>(
    GetDopplerQaDocument,
    options
  );
}
export function useGetDopplerQaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDopplerQaQuery,
    GetDopplerQaQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDopplerQaQuery, GetDopplerQaQueryVariables>(
    GetDopplerQaDocument,
    options
  );
}
export type GetDopplerQaQueryHookResult = ReturnType<
  typeof useGetDopplerQaQuery
>;
export type GetDopplerQaLazyQueryHookResult = ReturnType<
  typeof useGetDopplerQaLazyQuery
>;
export const GetDopplerRunTimestampsThisWeekDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDopplerRunTimestampsThisWeek" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "dopplerRunTimestampsThisWeek" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dopplerRunId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dopplerRunDateTime" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetDopplerRunTimestampsThisWeekQuery__
 *
 * To run a query within a React component, call `useGetDopplerRunTimestampsThisWeekQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDopplerRunTimestampsThisWeekQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDopplerRunTimestampsThisWeekQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDopplerRunTimestampsThisWeekQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDopplerRunTimestampsThisWeekQuery,
    GetDopplerRunTimestampsThisWeekQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDopplerRunTimestampsThisWeekQuery,
    GetDopplerRunTimestampsThisWeekQueryVariables
  >(GetDopplerRunTimestampsThisWeekDocument, options);
}
export function useGetDopplerRunTimestampsThisWeekLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDopplerRunTimestampsThisWeekQuery,
    GetDopplerRunTimestampsThisWeekQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDopplerRunTimestampsThisWeekQuery,
    GetDopplerRunTimestampsThisWeekQueryVariables
  >(GetDopplerRunTimestampsThisWeekDocument, options);
}
export type GetDopplerRunTimestampsThisWeekQueryHookResult = ReturnType<
  typeof useGetDopplerRunTimestampsThisWeekQuery
>;
export type GetDopplerRunTimestampsThisWeekLazyQueryHookResult = ReturnType<
  typeof useGetDopplerRunTimestampsThisWeekLazyQuery
>;
export const SetSelectedDopplerRunDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetSelectedDopplerRun" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dopplerQARunsId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setSelectedDopplerRun" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "dopplerQARunsId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dopplerQARunsId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetSelectedDopplerRunMutationFn = Apollo.MutationFunction<
  SetSelectedDopplerRunMutation,
  SetSelectedDopplerRunMutationVariables
>;

/**
 * __useSetSelectedDopplerRunMutation__
 *
 * To run a mutation, you first call `useSetSelectedDopplerRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSelectedDopplerRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSelectedDopplerRunMutation, { data, loading, error }] = useSetSelectedDopplerRunMutation({
 *   variables: {
 *      dopplerQARunsId: // value for 'dopplerQARunsId'
 *   },
 * });
 */
export function useSetSelectedDopplerRunMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetSelectedDopplerRunMutation,
    SetSelectedDopplerRunMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetSelectedDopplerRunMutation,
    SetSelectedDopplerRunMutationVariables
  >(SetSelectedDopplerRunDocument, options);
}
export type SetSelectedDopplerRunMutationHookResult = ReturnType<
  typeof useSetSelectedDopplerRunMutation
>;
export const DeleteEventAdjustmentLayerDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteEventAdjustmentLayer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteEventAdjustment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteEventAdjustmentLayerMutationFn = Apollo.MutationFunction<
  DeleteEventAdjustmentLayerMutation,
  DeleteEventAdjustmentLayerMutationVariables
>;

/**
 * __useDeleteEventAdjustmentLayerMutation__
 *
 * To run a mutation, you first call `useDeleteEventAdjustmentLayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventAdjustmentLayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventAdjustmentLayerMutation, { data, loading, error }] = useDeleteEventAdjustmentLayerMutation({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteEventAdjustmentLayerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteEventAdjustmentLayerMutation,
    DeleteEventAdjustmentLayerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteEventAdjustmentLayerMutation,
    DeleteEventAdjustmentLayerMutationVariables
  >(DeleteEventAdjustmentLayerDocument, options);
}
export type DeleteEventAdjustmentLayerMutationHookResult = ReturnType<
  typeof useDeleteEventAdjustmentLayerMutation
>;
export const GetEventAdjustmentsForTableDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEventAdjustmentsForTable" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "tag" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "layerName" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locationId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "NonNegativeInt" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "eventAdjustments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "tag" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tag" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "layerName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "layerName" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "adjustments" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "locationId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "locationId" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "locationId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "locationTitle" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "operationalDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "day" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hourlyAdjustments" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventAdjustmentsForTableQuery__
 *
 * To run a query within a React component, call `useGetEventAdjustmentsForTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventAdjustmentsForTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventAdjustmentsForTableQuery({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      tag: // value for 'tag'
 *      layerName: // value for 'layerName'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetEventAdjustmentsForTableQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEventAdjustmentsForTableQuery,
    GetEventAdjustmentsForTableQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEventAdjustmentsForTableQuery,
    GetEventAdjustmentsForTableQueryVariables
  >(GetEventAdjustmentsForTableDocument, options);
}
export function useGetEventAdjustmentsForTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventAdjustmentsForTableQuery,
    GetEventAdjustmentsForTableQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEventAdjustmentsForTableQuery,
    GetEventAdjustmentsForTableQueryVariables
  >(GetEventAdjustmentsForTableDocument, options);
}
export type GetEventAdjustmentsForTableQueryHookResult = ReturnType<
  typeof useGetEventAdjustmentsForTableQuery
>;
export type GetEventAdjustmentsForTableLazyQueryHookResult = ReturnType<
  typeof useGetEventAdjustmentsForTableLazyQuery
>;
export const GetLayerNamesDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLayerNames" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "tag" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "eventAdjustments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "tag" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tag" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetLayerNamesQuery__
 *
 * To run a query within a React component, call `useGetLayerNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLayerNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLayerNamesQuery({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useGetLayerNamesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLayerNamesQuery,
    GetLayerNamesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLayerNamesQuery, GetLayerNamesQueryVariables>(
    GetLayerNamesDocument,
    options
  );
}
export function useGetLayerNamesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLayerNamesQuery,
    GetLayerNamesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLayerNamesQuery, GetLayerNamesQueryVariables>(
    GetLayerNamesDocument,
    options
  );
}
export type GetLayerNamesQueryHookResult = ReturnType<
  typeof useGetLayerNamesQuery
>;
export type GetLayerNamesLazyQueryHookResult = ReturnType<
  typeof useGetLayerNamesLazyQuery
>;
export const GetLocationIdsInLayerDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLocationIdsInLayer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "layerName" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "eventAdjustments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "layerName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "layerName" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "locationIds" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetLocationIdsInLayerQuery__
 *
 * To run a query within a React component, call `useGetLocationIdsInLayerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationIdsInLayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationIdsInLayerQuery({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      layerName: // value for 'layerName'
 *   },
 * });
 */
export function useGetLocationIdsInLayerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLocationIdsInLayerQuery,
    GetLocationIdsInLayerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLocationIdsInLayerQuery,
    GetLocationIdsInLayerQueryVariables
  >(GetLocationIdsInLayerDocument, options);
}
export function useGetLocationIdsInLayerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLocationIdsInLayerQuery,
    GetLocationIdsInLayerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLocationIdsInLayerQuery,
    GetLocationIdsInLayerQueryVariables
  >(GetLocationIdsInLayerDocument, options);
}
export type GetLocationIdsInLayerQueryHookResult = ReturnType<
  typeof useGetLocationIdsInLayerQuery
>;
export type GetLocationIdsInLayerLazyQueryHookResult = ReturnType<
  typeof useGetLocationIdsInLayerLazyQuery
>;
export const GetLocationIdsInTagDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLocationIdsInTag" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "tag" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "eventAdjustments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "tag" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tag" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "locationIdsInTag" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetLocationIdsInTagQuery__
 *
 * To run a query within a React component, call `useGetLocationIdsInTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationIdsInTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationIdsInTagQuery({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useGetLocationIdsInTagQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLocationIdsInTagQuery,
    GetLocationIdsInTagQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLocationIdsInTagQuery,
    GetLocationIdsInTagQueryVariables
  >(GetLocationIdsInTagDocument, options);
}
export function useGetLocationIdsInTagLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLocationIdsInTagQuery,
    GetLocationIdsInTagQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLocationIdsInTagQuery,
    GetLocationIdsInTagQueryVariables
  >(GetLocationIdsInTagDocument, options);
}
export type GetLocationIdsInTagQueryHookResult = ReturnType<
  typeof useGetLocationIdsInTagQuery
>;
export type GetLocationIdsInTagLazyQueryHookResult = ReturnType<
  typeof useGetLocationIdsInTagLazyQuery
>;
export const UploadEventAdjustmentDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UploadEventAdjustment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "file" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Upload" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "layerType" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "allowDatesOutsideSelectedWeek" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadEventAdjustmentCsv" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "uploadEventAdjustmentCsvInput" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "file" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "file" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "layerType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "layerType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "allowDatesOutsideSelectedWeek" },
                value: {
                  kind: "Variable",
                  name: {
                    kind: "Name",
                    value: "allowDatesOutsideSelectedWeek",
                  },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UploadEventAdjustmentMutationFn = Apollo.MutationFunction<
  UploadEventAdjustmentMutation,
  UploadEventAdjustmentMutationVariables
>;

/**
 * __useUploadEventAdjustmentMutation__
 *
 * To run a mutation, you first call `useUploadEventAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadEventAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadEventAdjustmentMutation, { data, loading, error }] = useUploadEventAdjustmentMutation({
 *   variables: {
 *      file: // value for 'file'
 *      layerType: // value for 'layerType'
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      allowDatesOutsideSelectedWeek: // value for 'allowDatesOutsideSelectedWeek'
 *   },
 * });
 */
export function useUploadEventAdjustmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadEventAdjustmentMutation,
    UploadEventAdjustmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadEventAdjustmentMutation,
    UploadEventAdjustmentMutationVariables
  >(UploadEventAdjustmentDocument, options);
}
export type UploadEventAdjustmentMutationHookResult = ReturnType<
  typeof useUploadEventAdjustmentMutation
>;
export const UpdateForecasterAssignmentsDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateForecasterAssignments" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "updateForecastersAndForecasterAssignments",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateForecasterAssignmentsMutationFn = Apollo.MutationFunction<
  UpdateForecasterAssignmentsMutation,
  UpdateForecasterAssignmentsMutationVariables
>;

/**
 * __useUpdateForecasterAssignmentsMutation__
 *
 * To run a mutation, you first call `useUpdateForecasterAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateForecasterAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateForecasterAssignmentsMutation, { data, loading, error }] = useUpdateForecasterAssignmentsMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateForecasterAssignmentsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateForecasterAssignmentsMutation,
    UpdateForecasterAssignmentsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateForecasterAssignmentsMutation,
    UpdateForecasterAssignmentsMutationVariables
  >(UpdateForecasterAssignmentsDocument, options);
}
export type UpdateForecasterAssignmentsMutationHookResult = ReturnType<
  typeof useUpdateForecasterAssignmentsMutation
>;
export const CreateGlobalAdjustmentLayerDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateGlobalAdjustmentLayer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "tag" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "layerName" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locationIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "NonNegativeInt" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderAdjustment" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "forecasterId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "NonNegativeInt" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "countryCode" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createGlobalAdjustmentLayer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "tag" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tag" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "layerName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "layerName" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locationIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locationIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderAdjustment" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderAdjustment" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "forecasterId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "forecasterId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "countryCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "countryCode" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateGlobalAdjustmentLayerMutationFn = Apollo.MutationFunction<
  CreateGlobalAdjustmentLayerMutation,
  CreateGlobalAdjustmentLayerMutationVariables
>;

/**
 * __useCreateGlobalAdjustmentLayerMutation__
 *
 * To run a mutation, you first call `useCreateGlobalAdjustmentLayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGlobalAdjustmentLayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGlobalAdjustmentLayerMutation, { data, loading, error }] = useCreateGlobalAdjustmentLayerMutation({
 *   variables: {
 *      tag: // value for 'tag'
 *      layerName: // value for 'layerName'
 *      locationIds: // value for 'locationIds'
 *      orderAdjustment: // value for 'orderAdjustment'
 *      forecasterId: // value for 'forecasterId'
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useCreateGlobalAdjustmentLayerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateGlobalAdjustmentLayerMutation,
    CreateGlobalAdjustmentLayerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateGlobalAdjustmentLayerMutation,
    CreateGlobalAdjustmentLayerMutationVariables
  >(CreateGlobalAdjustmentLayerDocument, options);
}
export type CreateGlobalAdjustmentLayerMutationHookResult = ReturnType<
  typeof useCreateGlobalAdjustmentLayerMutation
>;
export const GetGlobalAdjustmentLayerInfoDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetGlobalAdjustmentLayerInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "layerName" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "eventAdjustments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "layerName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "layerName" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "locationIds" } },
                { kind: "Field", name: { kind: "Name", value: "orderSum" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetGlobalAdjustmentLayerInfoQuery__
 *
 * To run a query within a React component, call `useGetGlobalAdjustmentLayerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalAdjustmentLayerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalAdjustmentLayerInfoQuery({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      layerName: // value for 'layerName'
 *   },
 * });
 */
export function useGetGlobalAdjustmentLayerInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetGlobalAdjustmentLayerInfoQuery,
    GetGlobalAdjustmentLayerInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetGlobalAdjustmentLayerInfoQuery,
    GetGlobalAdjustmentLayerInfoQueryVariables
  >(GetGlobalAdjustmentLayerInfoDocument, options);
}
export function useGetGlobalAdjustmentLayerInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGlobalAdjustmentLayerInfoQuery,
    GetGlobalAdjustmentLayerInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetGlobalAdjustmentLayerInfoQuery,
    GetGlobalAdjustmentLayerInfoQueryVariables
  >(GetGlobalAdjustmentLayerInfoDocument, options);
}
export type GetGlobalAdjustmentLayerInfoQueryHookResult = ReturnType<
  typeof useGetGlobalAdjustmentLayerInfoQuery
>;
export type GetGlobalAdjustmentLayerInfoLazyQueryHookResult = ReturnType<
  typeof useGetGlobalAdjustmentLayerInfoLazyQuery
>;
export const GetLayerNamesByTagDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLayerNamesByTag" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "tag" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "eventAdjustments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "tag" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tag" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetLayerNamesByTagQuery__
 *
 * To run a query within a React component, call `useGetLayerNamesByTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLayerNamesByTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLayerNamesByTagQuery({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useGetLayerNamesByTagQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLayerNamesByTagQuery,
    GetLayerNamesByTagQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLayerNamesByTagQuery,
    GetLayerNamesByTagQueryVariables
  >(GetLayerNamesByTagDocument, options);
}
export function useGetLayerNamesByTagLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLayerNamesByTagQuery,
    GetLayerNamesByTagQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLayerNamesByTagQuery,
    GetLayerNamesByTagQueryVariables
  >(GetLayerNamesByTagDocument, options);
}
export type GetLayerNamesByTagQueryHookResult = ReturnType<
  typeof useGetLayerNamesByTagQuery
>;
export type GetLayerNamesByTagLazyQueryHookResult = ReturnType<
  typeof useGetLayerNamesByTagLazyQuery
>;
export const GetLocationsByCountryDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLocationsByCountry" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "country" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "locations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "country" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "country" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetLocationsByCountryQuery__
 *
 * To run a query within a React component, call `useGetLocationsByCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsByCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsByCountryQuery({
 *   variables: {
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetLocationsByCountryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLocationsByCountryQuery,
    GetLocationsByCountryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLocationsByCountryQuery,
    GetLocationsByCountryQueryVariables
  >(GetLocationsByCountryDocument, options);
}
export function useGetLocationsByCountryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLocationsByCountryQuery,
    GetLocationsByCountryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLocationsByCountryQuery,
    GetLocationsByCountryQueryVariables
  >(GetLocationsByCountryDocument, options);
}
export type GetLocationsByCountryQueryHookResult = ReturnType<
  typeof useGetLocationsByCountryQuery
>;
export type GetLocationsByCountryLazyQueryHookResult = ReturnType<
  typeof useGetLocationsByCountryLazyQuery
>;
export const CreateLocationOdhTargetDataDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateLocationODHTargetData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locationTargetCreateInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LocationTargetCreateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createLocationTargets" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locationTargetCreateInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locationTargetCreateInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateLocationOdhTargetDataMutationFn = Apollo.MutationFunction<
  CreateLocationOdhTargetDataMutation,
  CreateLocationOdhTargetDataMutationVariables
>;

/**
 * __useCreateLocationOdhTargetDataMutation__
 *
 * To run a mutation, you first call `useCreateLocationOdhTargetDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationOdhTargetDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationOdhTargetDataMutation, { data, loading, error }] = useCreateLocationOdhTargetDataMutation({
 *   variables: {
 *      locationTargetCreateInput: // value for 'locationTargetCreateInput'
 *   },
 * });
 */
export function useCreateLocationOdhTargetDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateLocationOdhTargetDataMutation,
    CreateLocationOdhTargetDataMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateLocationOdhTargetDataMutation,
    CreateLocationOdhTargetDataMutationVariables
  >(CreateLocationOdhTargetDataDocument, options);
}
export type CreateLocationOdhTargetDataMutationHookResult = ReturnType<
  typeof useCreateLocationOdhTargetDataMutation
>;
export const GetLocationOdhTargetDataDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLocationODHTargetData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "first" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "NonNegativeInt" },
          },
          defaultValue: { kind: "IntValue", value: "0" },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "last" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "NonNegativeInt" },
          },
          defaultValue: { kind: "IntValue", value: "200" },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cursor" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "targetWeek" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "locationTargets" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "first" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "last" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "last" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cursor" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "targetWeek" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "targetWeek" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasNextPage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startCursor" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endCursor" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "GetLocationODHTargetFields",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GetLocationODHTargetFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LocationTarget" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "locationTargetId" } },
          { kind: "Field", name: { kind: "Name", value: "locationId" } },
          { kind: "Field", name: { kind: "Name", value: "minODH" } },
          { kind: "Field", name: { kind: "Name", value: "maxODH" } },
          { kind: "Field", name: { kind: "Name", value: "targetDate" } },
          { kind: "Field", name: { kind: "Name", value: "targetODH" } },
          { kind: "Field", name: { kind: "Name", value: "driverWaitTime" } },
          { kind: "Field", name: { kind: "Name", value: "mindpCar" } },
          { kind: "Field", name: { kind: "Name", value: "mindpBike" } },
          { kind: "Field", name: { kind: "Name", value: "mindpFoot" } },
          { kind: "Field", name: { kind: "Name", value: "constrainFlag" } },
          { kind: "Field", name: { kind: "Name", value: "absenteeAdjustCar" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "absenteeAdjustBike" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "absenteeAdjustFoot" },
          },
          { kind: "Field", name: { kind: "Name", value: "openFromOverride" } },
          { kind: "Field", name: { kind: "Name", value: "openToOverride" } },
          { kind: "Field", name: { kind: "Name", value: "shiftPad" } },
          { kind: "Field", name: { kind: "Name", value: "shiftIncrement" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "absenteeismLookbackWindow" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "unscheduledPenalty" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "absenteeismPercentile" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "unscheduledPercentile" },
          },
          { kind: "Field", name: { kind: "Name", value: "absenteeismCap" } },
          { kind: "Field", name: { kind: "Name", value: "unscheduledCap" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "absenteeismCutPremium" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "unscheduledCutPremium" },
          },
          { kind: "Field", name: { kind: "Name", value: "taperPreset" } },
          { kind: "Field", name: { kind: "Name", value: "skipMui" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetLocationOdhTargetDataQuery__
 *
 * To run a query within a React component, call `useGetLocationOdhTargetDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationOdhTargetDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationOdhTargetDataQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      cursor: // value for 'cursor'
 *      targetWeek: // value for 'targetWeek'
 *   },
 * });
 */
export function useGetLocationOdhTargetDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLocationOdhTargetDataQuery,
    GetLocationOdhTargetDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLocationOdhTargetDataQuery,
    GetLocationOdhTargetDataQueryVariables
  >(GetLocationOdhTargetDataDocument, options);
}
export function useGetLocationOdhTargetDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLocationOdhTargetDataQuery,
    GetLocationOdhTargetDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLocationOdhTargetDataQuery,
    GetLocationOdhTargetDataQueryVariables
  >(GetLocationOdhTargetDataDocument, options);
}
export type GetLocationOdhTargetDataQueryHookResult = ReturnType<
  typeof useGetLocationOdhTargetDataQuery
>;
export type GetLocationOdhTargetDataLazyQueryHookResult = ReturnType<
  typeof useGetLocationOdhTargetDataLazyQuery
>;
export const UpdateLocationOdhTargetDataDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateLocationODHTargetData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locationTargetUpdateInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LocationTargetUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateLocationTargets" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locationTargetUpdateInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locationTargetUpdateInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateLocationOdhTargetDataMutationFn = Apollo.MutationFunction<
  UpdateLocationOdhTargetDataMutation,
  UpdateLocationOdhTargetDataMutationVariables
>;

/**
 * __useUpdateLocationOdhTargetDataMutation__
 *
 * To run a mutation, you first call `useUpdateLocationOdhTargetDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationOdhTargetDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationOdhTargetDataMutation, { data, loading, error }] = useUpdateLocationOdhTargetDataMutation({
 *   variables: {
 *      locationTargetUpdateInput: // value for 'locationTargetUpdateInput'
 *   },
 * });
 */
export function useUpdateLocationOdhTargetDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLocationOdhTargetDataMutation,
    UpdateLocationOdhTargetDataMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateLocationOdhTargetDataMutation,
    UpdateLocationOdhTargetDataMutationVariables
  >(UpdateLocationOdhTargetDataDocument, options);
}
export type UpdateLocationOdhTargetDataMutationHookResult = ReturnType<
  typeof useUpdateLocationOdhTargetDataMutation
>;
export const UploadOdhTargetsDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UploadOdhTargets" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "file" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Upload" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "selectedWeek" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "allowDatesOutsideSelectedWeek" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadLocationTargets" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "uploadLocationTargetsInput" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "file" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "file" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "selectedWeek" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "selectedWeek" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "allowDatesOutsideSelectedWeek" },
                value: {
                  kind: "Variable",
                  name: {
                    kind: "Name",
                    value: "allowDatesOutsideSelectedWeek",
                  },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UploadOdhTargetsMutationFn = Apollo.MutationFunction<
  UploadOdhTargetsMutation,
  UploadOdhTargetsMutationVariables
>;

/**
 * __useUploadOdhTargetsMutation__
 *
 * To run a mutation, you first call `useUploadOdhTargetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadOdhTargetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadOdhTargetsMutation, { data, loading, error }] = useUploadOdhTargetsMutation({
 *   variables: {
 *      file: // value for 'file'
 *      selectedWeek: // value for 'selectedWeek'
 *      allowDatesOutsideSelectedWeek: // value for 'allowDatesOutsideSelectedWeek'
 *   },
 * });
 */
export function useUploadOdhTargetsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadOdhTargetsMutation,
    UploadOdhTargetsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadOdhTargetsMutation,
    UploadOdhTargetsMutationVariables
  >(UploadOdhTargetsDocument, options);
}
export type UploadOdhTargetsMutationHookResult = ReturnType<
  typeof useUploadOdhTargetsMutation
>;
export const CreateOrEditReforecastLayerDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateOrEditReforecastLayer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "date" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderAdjustment" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locationIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "metroRegion" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "countryCode" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createOrEditReforecastLayer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "date" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "date" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderAdjustment" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderAdjustment" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locationIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locationIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "metroRegion" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "metroRegion" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "countryCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "countryCode" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateOrEditReforecastLayerMutationFn = Apollo.MutationFunction<
  CreateOrEditReforecastLayerMutation,
  CreateOrEditReforecastLayerMutationVariables
>;

/**
 * __useCreateOrEditReforecastLayerMutation__
 *
 * To run a mutation, you first call `useCreateOrEditReforecastLayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrEditReforecastLayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrEditReforecastLayerMutation, { data, loading, error }] = useCreateOrEditReforecastLayerMutation({
 *   variables: {
 *      date: // value for 'date'
 *      orderAdjustment: // value for 'orderAdjustment'
 *      locationIds: // value for 'locationIds'
 *      metroRegion: // value for 'metroRegion'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useCreateOrEditReforecastLayerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateOrEditReforecastLayerMutation,
    CreateOrEditReforecastLayerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateOrEditReforecastLayerMutation,
    CreateOrEditReforecastLayerMutationVariables
  >(CreateOrEditReforecastLayerDocument, options);
}
export type CreateOrEditReforecastLayerMutationHookResult = ReturnType<
  typeof useCreateOrEditReforecastLayerMutation
>;
export const GetMidWeekReforecastDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMidWeekReforecast" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locationId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "NonNegativeInt" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "metroRegion" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "countryCode" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "midweekReforecast" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "metroRegion" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "metroRegion" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "countryCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "countryCode" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "actuals" } },
                { kind: "Field", name: { kind: "Name", value: "projection" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ovfPublished" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "ovfPublishedVsActualsOrProjection",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ovfReforecast" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ovfReforecastVsProjection" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "seasonalAdjustments" },
                },
                { kind: "Field", name: { kind: "Name", value: "referrals" } },
                { kind: "Field", name: { kind: "Name", value: "promos" } },
                { kind: "Field", name: { kind: "Name", value: "partners" } },
                { kind: "Field", name: { kind: "Name", value: "planning" } },
                { kind: "Field", name: { kind: "Name", value: "other" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dailyReforecastAdjustment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalAdjustments" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dopplerRunActive" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dopplerVsDoppler" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dopplerRunPublished" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetMidWeekReforecastQuery__
 *
 * To run a query within a React component, call `useGetMidWeekReforecastQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMidWeekReforecastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMidWeekReforecastQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      metroRegion: // value for 'metroRegion'
 *      countryCode: // value for 'countryCode'
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *   },
 * });
 */
export function useGetMidWeekReforecastQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMidWeekReforecastQuery,
    GetMidWeekReforecastQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMidWeekReforecastQuery,
    GetMidWeekReforecastQueryVariables
  >(GetMidWeekReforecastDocument, options);
}
export function useGetMidWeekReforecastLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMidWeekReforecastQuery,
    GetMidWeekReforecastQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMidWeekReforecastQuery,
    GetMidWeekReforecastQueryVariables
  >(GetMidWeekReforecastDocument, options);
}
export type GetMidWeekReforecastQueryHookResult = ReturnType<
  typeof useGetMidWeekReforecastQuery
>;
export type GetMidWeekReforecastLazyQueryHookResult = ReturnType<
  typeof useGetMidWeekReforecastLazyQuery
>;
export const SubmitMidweekReforecastAdjustedOvfDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SubmitMidweekReforecastAdjustedOvf" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "submitMidweekReforecastAdjustedOvf" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SubmitMidweekReforecastAdjustedOvfMutationFn =
  Apollo.MutationFunction<
    SubmitMidweekReforecastAdjustedOvfMutation,
    SubmitMidweekReforecastAdjustedOvfMutationVariables
  >;

/**
 * __useSubmitMidweekReforecastAdjustedOvfMutation__
 *
 * To run a mutation, you first call `useSubmitMidweekReforecastAdjustedOvfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitMidweekReforecastAdjustedOvfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitMidweekReforecastAdjustedOvfMutation, { data, loading, error }] = useSubmitMidweekReforecastAdjustedOvfMutation({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *   },
 * });
 */
export function useSubmitMidweekReforecastAdjustedOvfMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitMidweekReforecastAdjustedOvfMutation,
    SubmitMidweekReforecastAdjustedOvfMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitMidweekReforecastAdjustedOvfMutation,
    SubmitMidweekReforecastAdjustedOvfMutationVariables
  >(SubmitMidweekReforecastAdjustedOvfDocument, options);
}
export type SubmitMidweekReforecastAdjustedOvfMutationHookResult = ReturnType<
  typeof useSubmitMidweekReforecastAdjustedOvfMutation
>;
export const GetForecastLocationsByMetroRegionsDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetForecastLocationsByMetroRegions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "countryCode" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "weeksToInclude" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "NonNegativeInt" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "forecastLocationsByMetroRegions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "countryCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "countryCode" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "weeksToInclude" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "weeksToInclude" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "locationIds" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetForecastLocationsByMetroRegionsQuery__
 *
 * To run a query within a React component, call `useGetForecastLocationsByMetroRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetForecastLocationsByMetroRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetForecastLocationsByMetroRegionsQuery({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      countryCode: // value for 'countryCode'
 *      weeksToInclude: // value for 'weeksToInclude'
 *   },
 * });
 */
export function useGetForecastLocationsByMetroRegionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetForecastLocationsByMetroRegionsQuery,
    GetForecastLocationsByMetroRegionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetForecastLocationsByMetroRegionsQuery,
    GetForecastLocationsByMetroRegionsQueryVariables
  >(GetForecastLocationsByMetroRegionsDocument, options);
}
export function useGetForecastLocationsByMetroRegionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetForecastLocationsByMetroRegionsQuery,
    GetForecastLocationsByMetroRegionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetForecastLocationsByMetroRegionsQuery,
    GetForecastLocationsByMetroRegionsQueryVariables
  >(GetForecastLocationsByMetroRegionsDocument, options);
}
export type GetForecastLocationsByMetroRegionsQueryHookResult = ReturnType<
  typeof useGetForecastLocationsByMetroRegionsQuery
>;
export type GetForecastLocationsByMetroRegionsLazyQueryHookResult = ReturnType<
  typeof useGetForecastLocationsByMetroRegionsLazyQuery
>;
export const GetMidweekReforecastForMultiweekForecastDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMidweekReforecastForMultiweekForecast" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locationId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "NonNegativeInt" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "metroRegion" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "countryCode" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "midweekReforecast" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "metroRegion" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "metroRegion" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "countryCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "countryCode" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dopplerRunActive" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dopplerRunPublished" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ovfPublished" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ovfReforecast" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetMidweekReforecastForMultiweekForecastQuery__
 *
 * To run a query within a React component, call `useGetMidweekReforecastForMultiweekForecastQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMidweekReforecastForMultiweekForecastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMidweekReforecastForMultiweekForecastQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      metroRegion: // value for 'metroRegion'
 *      countryCode: // value for 'countryCode'
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *   },
 * });
 */
export function useGetMidweekReforecastForMultiweekForecastQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMidweekReforecastForMultiweekForecastQuery,
    GetMidweekReforecastForMultiweekForecastQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMidweekReforecastForMultiweekForecastQuery,
    GetMidweekReforecastForMultiweekForecastQueryVariables
  >(GetMidweekReforecastForMultiweekForecastDocument, options);
}
export function useGetMidweekReforecastForMultiweekForecastLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMidweekReforecastForMultiweekForecastQuery,
    GetMidweekReforecastForMultiweekForecastQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMidweekReforecastForMultiweekForecastQuery,
    GetMidweekReforecastForMultiweekForecastQueryVariables
  >(GetMidweekReforecastForMultiweekForecastDocument, options);
}
export type GetMidweekReforecastForMultiweekForecastQueryHookResult =
  ReturnType<typeof useGetMidweekReforecastForMultiweekForecastQuery>;
export type GetMidweekReforecastForMultiweekForecastLazyQueryHookResult =
  ReturnType<typeof useGetMidweekReforecastForMultiweekForecastLazyQuery>;
export const GetMultiweekForecastDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMultiweekForecast" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locationIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "NonNegativeInt" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "weeks" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "multiweekForecast" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locationIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locationIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "weeks" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "weeks" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "adjustmentsWeeklyTotals" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "adjustmentsWeeklyTotalsGrowthRates",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "activeDopplerWeeklyTotals" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ovfPublishedByWeek" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "ovfPublishedByWeekGrowthRates",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "thisYearActualsByWeek" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "thisYearActualsByWeekGrowthRates",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lastYearActualsByWeek" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "lastYearActualsByWeekGrowthRates",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetMultiweekForecastQuery__
 *
 * To run a query within a React component, call `useGetMultiweekForecastQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMultiweekForecastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMultiweekForecastQuery({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      locationIds: // value for 'locationIds'
 *      weeks: // value for 'weeks'
 *   },
 * });
 */
export function useGetMultiweekForecastQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMultiweekForecastQuery,
    GetMultiweekForecastQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMultiweekForecastQuery,
    GetMultiweekForecastQueryVariables
  >(GetMultiweekForecastDocument, options);
}
export function useGetMultiweekForecastLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMultiweekForecastQuery,
    GetMultiweekForecastQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMultiweekForecastQuery,
    GetMultiweekForecastQueryVariables
  >(GetMultiweekForecastDocument, options);
}
export type GetMultiweekForecastQueryHookResult = ReturnType<
  typeof useGetMultiweekForecastQuery
>;
export type GetMultiweekForecastLazyQueryHookResult = ReturnType<
  typeof useGetMultiweekForecastLazyQuery
>;
export const GetEibXlsxUrlDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEibXlsxUrl" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "runId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "NonNegativeInt" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "eibXlsxUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "runId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "runId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEibXlsxUrlQuery__
 *
 * To run a query within a React component, call `useGetEibXlsxUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEibXlsxUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEibXlsxUrlQuery({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      runId: // value for 'runId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetEibXlsxUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEibXlsxUrlQuery,
    GetEibXlsxUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEibXlsxUrlQuery, GetEibXlsxUrlQueryVariables>(
    GetEibXlsxUrlDocument,
    options
  );
}
export function useGetEibXlsxUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEibXlsxUrlQuery,
    GetEibXlsxUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEibXlsxUrlQuery, GetEibXlsxUrlQueryVariables>(
    GetEibXlsxUrlDocument,
    options
  );
}
export type GetEibXlsxUrlQueryHookResult = ReturnType<
  typeof useGetEibXlsxUrlQuery
>;
export type GetEibXlsxUrlLazyQueryHookResult = ReturnType<
  typeof useGetEibXlsxUrlLazyQuery
>;
export const GetMetroRegionsDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMetroRegions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "countryCode" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "metroRegions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "countryCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "countryCode" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetMetroRegionsQuery__
 *
 * To run a query within a React component, call `useGetMetroRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetroRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetroRegionsQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useGetMetroRegionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMetroRegionsQuery,
    GetMetroRegionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMetroRegionsQuery, GetMetroRegionsQueryVariables>(
    GetMetroRegionsDocument,
    options
  );
}
export function useGetMetroRegionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMetroRegionsQuery,
    GetMetroRegionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMetroRegionsQuery,
    GetMetroRegionsQueryVariables
  >(GetMetroRegionsDocument, options);
}
export type GetMetroRegionsQueryHookResult = ReturnType<
  typeof useGetMetroRegionsQuery
>;
export type GetMetroRegionsLazyQueryHookResult = ReturnType<
  typeof useGetMetroRegionsLazyQuery
>;
export const GetMostRecentLaborMappingUploadTimestampDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMostRecentLaborMappingUploadTimestamp" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "getMostRecentLaborMappingUploadTimestamp",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "date" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetMostRecentLaborMappingUploadTimestampQuery__
 *
 * To run a query within a React component, call `useGetMostRecentLaborMappingUploadTimestampQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMostRecentLaborMappingUploadTimestampQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMostRecentLaborMappingUploadTimestampQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMostRecentLaborMappingUploadTimestampQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMostRecentLaborMappingUploadTimestampQuery,
    GetMostRecentLaborMappingUploadTimestampQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMostRecentLaborMappingUploadTimestampQuery,
    GetMostRecentLaborMappingUploadTimestampQueryVariables
  >(GetMostRecentLaborMappingUploadTimestampDocument, options);
}
export function useGetMostRecentLaborMappingUploadTimestampLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMostRecentLaborMappingUploadTimestampQuery,
    GetMostRecentLaborMappingUploadTimestampQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMostRecentLaborMappingUploadTimestampQuery,
    GetMostRecentLaborMappingUploadTimestampQueryVariables
  >(GetMostRecentLaborMappingUploadTimestampDocument, options);
}
export type GetMostRecentLaborMappingUploadTimestampQueryHookResult =
  ReturnType<typeof useGetMostRecentLaborMappingUploadTimestampQuery>;
export type GetMostRecentLaborMappingUploadTimestampLazyQueryHookResult =
  ReturnType<typeof useGetMostRecentLaborMappingUploadTimestampLazyQuery>;
export const GetMostRecentOaLaborUploadTimestampDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMostRecentOaLaborUploadTimestamp" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "getMostRecentOaLaborUploadTimestamp",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "date" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetMostRecentOaLaborUploadTimestampQuery__
 *
 * To run a query within a React component, call `useGetMostRecentOaLaborUploadTimestampQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMostRecentOaLaborUploadTimestampQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMostRecentOaLaborUploadTimestampQuery({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *   },
 * });
 */
export function useGetMostRecentOaLaborUploadTimestampQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMostRecentOaLaborUploadTimestampQuery,
    GetMostRecentOaLaborUploadTimestampQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMostRecentOaLaborUploadTimestampQuery,
    GetMostRecentOaLaborUploadTimestampQueryVariables
  >(GetMostRecentOaLaborUploadTimestampDocument, options);
}
export function useGetMostRecentOaLaborUploadTimestampLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMostRecentOaLaborUploadTimestampQuery,
    GetMostRecentOaLaborUploadTimestampQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMostRecentOaLaborUploadTimestampQuery,
    GetMostRecentOaLaborUploadTimestampQueryVariables
  >(GetMostRecentOaLaborUploadTimestampDocument, options);
}
export type GetMostRecentOaLaborUploadTimestampQueryHookResult = ReturnType<
  typeof useGetMostRecentOaLaborUploadTimestampQuery
>;
export type GetMostRecentOaLaborUploadTimestampLazyQueryHookResult = ReturnType<
  typeof useGetMostRecentOaLaborUploadTimestampLazyQuery
>;
export const GetOaLocationClustersDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOaLocationClusters" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "oaLocationClustersId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locationIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "oaLocationClusters" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "oaLocationClustersId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "location_ids" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locationIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location_ids" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetOaLocationClustersQuery__
 *
 * To run a query within a React component, call `useGetOaLocationClustersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOaLocationClustersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOaLocationClustersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      oaLocationClustersId: // value for 'oaLocationClustersId'
 *      name: // value for 'name'
 *      locationIds: // value for 'locationIds'
 *   },
 * });
 */
export function useGetOaLocationClustersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetOaLocationClustersQuery,
    GetOaLocationClustersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOaLocationClustersQuery,
    GetOaLocationClustersQueryVariables
  >(GetOaLocationClustersDocument, options);
}
export function useGetOaLocationClustersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOaLocationClustersQuery,
    GetOaLocationClustersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOaLocationClustersQuery,
    GetOaLocationClustersQueryVariables
  >(GetOaLocationClustersDocument, options);
}
export type GetOaLocationClustersQueryHookResult = ReturnType<
  typeof useGetOaLocationClustersQuery
>;
export type GetOaLocationClustersLazyQueryHookResult = ReturnType<
  typeof useGetOaLocationClustersLazyQuery
>;
export const GetOaLocationsDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOaLocations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "oaLocationsInput" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "OaLocationsInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "oaLocations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "oaLocationsInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "oaLocationsInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "location_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "country_code" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metro_region" },
                },
                { kind: "Field", name: { kind: "Name", value: "state_code" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetOaLocationsQuery__
 *
 * To run a query within a React component, call `useGetOaLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOaLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOaLocationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      oaLocationsInput: // value for 'oaLocationsInput'
 *   },
 * });
 */
export function useGetOaLocationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetOaLocationsQuery,
    GetOaLocationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOaLocationsQuery, GetOaLocationsQueryVariables>(
    GetOaLocationsDocument,
    options
  );
}
export function useGetOaLocationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOaLocationsQuery,
    GetOaLocationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOaLocationsQuery, GetOaLocationsQueryVariables>(
    GetOaLocationsDocument,
    options
  );
}
export type GetOaLocationsQueryHookResult = ReturnType<
  typeof useGetOaLocationsQuery
>;
export type GetOaLocationsLazyQueryHookResult = ReturnType<
  typeof useGetOaLocationsLazyQuery
>;
export const GetOaShiftsDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOaShifts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "adjustedOaHoursRunId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "oaShifts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "adjustedOaHoursRunId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "adjustedOaHoursRunId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "locationName" },
                },
                { kind: "Field", name: { kind: "Name", value: "opsDate" } },
                { kind: "Field", name: { kind: "Name", value: "weekday" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
                { kind: "Field", name: { kind: "Name", value: "endTime" } },
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "shiftLeader" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetOaShiftsQuery__
 *
 * To run a query within a React component, call `useGetOaShiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOaShiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOaShiftsQuery({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      adjustedOaHoursRunId: // value for 'adjustedOaHoursRunId'
 *   },
 * });
 */
export function useGetOaShiftsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOaShiftsQuery,
    GetOaShiftsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOaShiftsQuery, GetOaShiftsQueryVariables>(
    GetOaShiftsDocument,
    options
  );
}
export function useGetOaShiftsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOaShiftsQuery,
    GetOaShiftsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOaShiftsQuery, GetOaShiftsQueryVariables>(
    GetOaShiftsDocument,
    options
  );
}
export type GetOaShiftsQueryHookResult = ReturnType<typeof useGetOaShiftsQuery>;
export type GetOaShiftsLazyQueryHookResult = ReturnType<
  typeof useGetOaShiftsLazyQuery
>;
export const RunGoSkedDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RunGoSked" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "goSkedInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GoSkedInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "runGoSked" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "goSkedInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "goSkedInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RunGoSkedMutationFn = Apollo.MutationFunction<
  RunGoSkedMutation,
  RunGoSkedMutationVariables
>;

/**
 * __useRunGoSkedMutation__
 *
 * To run a mutation, you first call `useRunGoSkedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunGoSkedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runGoSkedMutation, { data, loading, error }] = useRunGoSkedMutation({
 *   variables: {
 *      goSkedInput: // value for 'goSkedInput'
 *   },
 * });
 */
export function useRunGoSkedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RunGoSkedMutation,
    RunGoSkedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RunGoSkedMutation, RunGoSkedMutationVariables>(
    RunGoSkedDocument,
    options
  );
}
export type RunGoSkedMutationHookResult = ReturnType<
  typeof useRunGoSkedMutation
>;
export const RunOaShifterDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RunOaShifter" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "oaShifterInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "OaShifterInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "runOaShifter" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "oaShifterInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "oaShifterInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RunOaShifterMutationFn = Apollo.MutationFunction<
  RunOaShifterMutation,
  RunOaShifterMutationVariables
>;

/**
 * __useRunOaShifterMutation__
 *
 * To run a mutation, you first call `useRunOaShifterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunOaShifterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runOaShifterMutation, { data, loading, error }] = useRunOaShifterMutation({
 *   variables: {
 *      oaShifterInput: // value for 'oaShifterInput'
 *   },
 * });
 */
export function useRunOaShifterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RunOaShifterMutation,
    RunOaShifterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RunOaShifterMutation,
    RunOaShifterMutationVariables
  >(RunOaShifterDocument, options);
}
export type RunOaShifterMutationHookResult = ReturnType<
  typeof useRunOaShifterMutation
>;
export const GetShiftLeaderShiftRequestsDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetShiftLeaderShiftRequests" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getShiftLeaderShiftRequests" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "location_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shift_leader" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location_name" },
                },
                { kind: "Field", name: { kind: "Name", value: "day_of_week" } },
                { kind: "Field", name: { kind: "Name", value: "start_time" } },
                { kind: "Field", name: { kind: "Name", value: "length" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetShiftLeaderShiftRequestsQuery__
 *
 * To run a query within a React component, call `useGetShiftLeaderShiftRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShiftLeaderShiftRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShiftLeaderShiftRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetShiftLeaderShiftRequestsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetShiftLeaderShiftRequestsQuery,
    GetShiftLeaderShiftRequestsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetShiftLeaderShiftRequestsQuery,
    GetShiftLeaderShiftRequestsQueryVariables
  >(GetShiftLeaderShiftRequestsDocument, options);
}
export function useGetShiftLeaderShiftRequestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetShiftLeaderShiftRequestsQuery,
    GetShiftLeaderShiftRequestsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetShiftLeaderShiftRequestsQuery,
    GetShiftLeaderShiftRequestsQueryVariables
  >(GetShiftLeaderShiftRequestsDocument, options);
}
export type GetShiftLeaderShiftRequestsQueryHookResult = ReturnType<
  typeof useGetShiftLeaderShiftRequestsQuery
>;
export type GetShiftLeaderShiftRequestsLazyQueryHookResult = ReturnType<
  typeof useGetShiftLeaderShiftRequestsLazyQuery
>;
export const UploadShiftLeaderShiftRequestsDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UploadShiftLeaderShiftRequests" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "file" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Upload" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadShiftLeaderShiftRequests" },
            arguments: [
              {
                kind: "Argument",
                name: {
                  kind: "Name",
                  value: "uploadShiftLeaderShiftRequestsCsvInput",
                },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "file" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "file" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UploadShiftLeaderShiftRequestsMutationFn = Apollo.MutationFunction<
  UploadShiftLeaderShiftRequestsMutation,
  UploadShiftLeaderShiftRequestsMutationVariables
>;

/**
 * __useUploadShiftLeaderShiftRequestsMutation__
 *
 * To run a mutation, you first call `useUploadShiftLeaderShiftRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadShiftLeaderShiftRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadShiftLeaderShiftRequestsMutation, { data, loading, error }] = useUploadShiftLeaderShiftRequestsMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadShiftLeaderShiftRequestsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadShiftLeaderShiftRequestsMutation,
    UploadShiftLeaderShiftRequestsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadShiftLeaderShiftRequestsMutation,
    UploadShiftLeaderShiftRequestsMutationVariables
  >(UploadShiftLeaderShiftRequestsDocument, options);
}
export type UploadShiftLeaderShiftRequestsMutationHookResult = ReturnType<
  typeof useUploadShiftLeaderShiftRequestsMutation
>;
export const GetEventAdjustmentTotalsByDayDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEventAdjustmentTotalsByDay" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "country" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "eventAdjustmentTotalsByDay" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "country" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "country" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventAdjustmentTotalsByDayQuery__
 *
 * To run a query within a React component, call `useGetEventAdjustmentTotalsByDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventAdjustmentTotalsByDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventAdjustmentTotalsByDayQuery({
 *   variables: {
 *      country: // value for 'country'
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *   },
 * });
 */
export function useGetEventAdjustmentTotalsByDayQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEventAdjustmentTotalsByDayQuery,
    GetEventAdjustmentTotalsByDayQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEventAdjustmentTotalsByDayQuery,
    GetEventAdjustmentTotalsByDayQueryVariables
  >(GetEventAdjustmentTotalsByDayDocument, options);
}
export function useGetEventAdjustmentTotalsByDayLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventAdjustmentTotalsByDayQuery,
    GetEventAdjustmentTotalsByDayQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEventAdjustmentTotalsByDayQuery,
    GetEventAdjustmentTotalsByDayQueryVariables
  >(GetEventAdjustmentTotalsByDayDocument, options);
}
export type GetEventAdjustmentTotalsByDayQueryHookResult = ReturnType<
  typeof useGetEventAdjustmentTotalsByDayQuery
>;
export type GetEventAdjustmentTotalsByDayLazyQueryHookResult = ReturnType<
  typeof useGetEventAdjustmentTotalsByDayLazyQuery
>;
export const GetMostRecentOvfSubmitDateDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getMostRecentOvfSubmitDate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "selectedWeek" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentOvfSubmit" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "selectedWeek" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "selectedWeek" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetMostRecentOvfSubmitDateQuery__
 *
 * To run a query within a React component, call `useGetMostRecentOvfSubmitDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMostRecentOvfSubmitDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMostRecentOvfSubmitDateQuery({
 *   variables: {
 *      selectedWeek: // value for 'selectedWeek'
 *   },
 * });
 */
export function useGetMostRecentOvfSubmitDateQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMostRecentOvfSubmitDateQuery,
    GetMostRecentOvfSubmitDateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMostRecentOvfSubmitDateQuery,
    GetMostRecentOvfSubmitDateQueryVariables
  >(GetMostRecentOvfSubmitDateDocument, options);
}
export function useGetMostRecentOvfSubmitDateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMostRecentOvfSubmitDateQuery,
    GetMostRecentOvfSubmitDateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMostRecentOvfSubmitDateQuery,
    GetMostRecentOvfSubmitDateQueryVariables
  >(GetMostRecentOvfSubmitDateDocument, options);
}
export type GetMostRecentOvfSubmitDateQueryHookResult = ReturnType<
  typeof useGetMostRecentOvfSubmitDateQuery
>;
export type GetMostRecentOvfSubmitDateLazyQueryHookResult = ReturnType<
  typeof useGetMostRecentOvfSubmitDateLazyQuery
>;
export const GetOvfQaDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOvfQA" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "country" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ovfQaLocations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "country" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "country" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "forecasterId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "threeWeekOrderHistory" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dopplerForecast" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "seasonalityAdjustments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "weeklyLayer" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dailyLayer" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hourlyLayer" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dopplerForecast" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "eventAdjustmentTotals" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "dailyThreeWeekTrailingAverage",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetOvfQaQuery__
 *
 * To run a query within a React component, call `useGetOvfQaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOvfQaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOvfQaQuery({
 *   variables: {
 *      country: // value for 'country'
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *   },
 * });
 */
export function useGetOvfQaQuery(
  baseOptions: Apollo.QueryHookOptions<GetOvfQaQuery, GetOvfQaQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOvfQaQuery, GetOvfQaQueryVariables>(
    GetOvfQaDocument,
    options
  );
}
export function useGetOvfQaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOvfQaQuery,
    GetOvfQaQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOvfQaQuery, GetOvfQaQueryVariables>(
    GetOvfQaDocument,
    options
  );
}
export type GetOvfQaQueryHookResult = ReturnType<typeof useGetOvfQaQuery>;
export type GetOvfQaLazyQueryHookResult = ReturnType<
  typeof useGetOvfQaLazyQuery
>;
export const SubmitOvfDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SubmitOvf" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "submitAdjustedOvf" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SubmitOvfMutationFn = Apollo.MutationFunction<
  SubmitOvfMutation,
  SubmitOvfMutationVariables
>;

/**
 * __useSubmitOvfMutation__
 *
 * To run a mutation, you first call `useSubmitOvfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitOvfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitOvfMutation, { data, loading, error }] = useSubmitOvfMutation({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *   },
 * });
 */
export function useSubmitOvfMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitOvfMutation,
    SubmitOvfMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SubmitOvfMutation, SubmitOvfMutationVariables>(
    SubmitOvfDocument,
    options
  );
}
export type SubmitOvfMutationHookResult = ReturnType<
  typeof useSubmitOvfMutation
>;
export const ApproveAndReleaseShiftsDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ApproveAndReleaseShifts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "adjustedDHRunId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "approveAndReleaseShifts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "adjustedDHRunId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "adjustedDHRunId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ApproveAndReleaseShiftsMutationFn = Apollo.MutationFunction<
  ApproveAndReleaseShiftsMutation,
  ApproveAndReleaseShiftsMutationVariables
>;

/**
 * __useApproveAndReleaseShiftsMutation__
 *
 * To run a mutation, you first call `useApproveAndReleaseShiftsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveAndReleaseShiftsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveAndReleaseShiftsMutation, { data, loading, error }] = useApproveAndReleaseShiftsMutation({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      adjustedDHRunId: // value for 'adjustedDHRunId'
 *   },
 * });
 */
export function useApproveAndReleaseShiftsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApproveAndReleaseShiftsMutation,
    ApproveAndReleaseShiftsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApproveAndReleaseShiftsMutation,
    ApproveAndReleaseShiftsMutationVariables
  >(ApproveAndReleaseShiftsDocument, options);
}
export type ApproveAndReleaseShiftsMutationHookResult = ReturnType<
  typeof useApproveAndReleaseShiftsMutation
>;
export const GetMostRecentAdjustedHoursUploadDateDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMostRecentAdjustedHoursUploadDate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentAdjustedHoursUploadDate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "date" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetMostRecentAdjustedHoursUploadDateQuery__
 *
 * To run a query within a React component, call `useGetMostRecentAdjustedHoursUploadDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMostRecentAdjustedHoursUploadDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMostRecentAdjustedHoursUploadDateQuery({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *   },
 * });
 */
export function useGetMostRecentAdjustedHoursUploadDateQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMostRecentAdjustedHoursUploadDateQuery,
    GetMostRecentAdjustedHoursUploadDateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMostRecentAdjustedHoursUploadDateQuery,
    GetMostRecentAdjustedHoursUploadDateQueryVariables
  >(GetMostRecentAdjustedHoursUploadDateDocument, options);
}
export function useGetMostRecentAdjustedHoursUploadDateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMostRecentAdjustedHoursUploadDateQuery,
    GetMostRecentAdjustedHoursUploadDateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMostRecentAdjustedHoursUploadDateQuery,
    GetMostRecentAdjustedHoursUploadDateQueryVariables
  >(GetMostRecentAdjustedHoursUploadDateDocument, options);
}
export type GetMostRecentAdjustedHoursUploadDateQueryHookResult = ReturnType<
  typeof useGetMostRecentAdjustedHoursUploadDateQuery
>;
export type GetMostRecentAdjustedHoursUploadDateLazyQueryHookResult =
  ReturnType<typeof useGetMostRecentAdjustedHoursUploadDateLazyQuery>;
export const GetMostRecentOdhTransformRunTimestampsDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMostRecentODHTransformRunTimestamps" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentOdhTransformRun" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentOdhTransformJobDate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "date" } },
                { kind: "Field", name: { kind: "Name", value: "batch" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetMostRecentOdhTransformRunTimestampsQuery__
 *
 * To run a query within a React component, call `useGetMostRecentOdhTransformRunTimestampsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMostRecentOdhTransformRunTimestampsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMostRecentOdhTransformRunTimestampsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMostRecentOdhTransformRunTimestampsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMostRecentOdhTransformRunTimestampsQuery,
    GetMostRecentOdhTransformRunTimestampsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMostRecentOdhTransformRunTimestampsQuery,
    GetMostRecentOdhTransformRunTimestampsQueryVariables
  >(GetMostRecentOdhTransformRunTimestampsDocument, options);
}
export function useGetMostRecentOdhTransformRunTimestampsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMostRecentOdhTransformRunTimestampsQuery,
    GetMostRecentOdhTransformRunTimestampsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMostRecentOdhTransformRunTimestampsQuery,
    GetMostRecentOdhTransformRunTimestampsQueryVariables
  >(GetMostRecentOdhTransformRunTimestampsDocument, options);
}
export type GetMostRecentOdhTransformRunTimestampsQueryHookResult = ReturnType<
  typeof useGetMostRecentOdhTransformRunTimestampsQuery
>;
export type GetMostRecentOdhTransformRunTimestampsLazyQueryHookResult =
  ReturnType<typeof useGetMostRecentOdhTransformRunTimestampsLazyQuery>;
export const GetMostRecentShiftsApprovalTimestampDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMostRecentShiftsApprovalTimestamp" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "adjustedDHRunId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentShiftsApprovalTimestamp" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "adjustedDHRunId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "adjustedDHRunId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetMostRecentShiftsApprovalTimestampQuery__
 *
 * To run a query within a React component, call `useGetMostRecentShiftsApprovalTimestampQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMostRecentShiftsApprovalTimestampQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMostRecentShiftsApprovalTimestampQuery({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      adjustedDHRunId: // value for 'adjustedDHRunId'
 *   },
 * });
 */
export function useGetMostRecentShiftsApprovalTimestampQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMostRecentShiftsApprovalTimestampQuery,
    GetMostRecentShiftsApprovalTimestampQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMostRecentShiftsApprovalTimestampQuery,
    GetMostRecentShiftsApprovalTimestampQueryVariables
  >(GetMostRecentShiftsApprovalTimestampDocument, options);
}
export function useGetMostRecentShiftsApprovalTimestampLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMostRecentShiftsApprovalTimestampQuery,
    GetMostRecentShiftsApprovalTimestampQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMostRecentShiftsApprovalTimestampQuery,
    GetMostRecentShiftsApprovalTimestampQueryVariables
  >(GetMostRecentShiftsApprovalTimestampDocument, options);
}
export type GetMostRecentShiftsApprovalTimestampQueryHookResult = ReturnType<
  typeof useGetMostRecentShiftsApprovalTimestampQuery
>;
export type GetMostRecentShiftsApprovalTimestampLazyQueryHookResult =
  ReturnType<typeof useGetMostRecentShiftsApprovalTimestampLazyQuery>;
export const GetMostRecentShiftsPublishTimestampDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMostRecentShiftsPublishTimestamp" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "adjustedDHRunId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentShiftsPublishTimestamp" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "adjustedDHRunId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "adjustedDHRunId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetMostRecentShiftsPublishTimestampQuery__
 *
 * To run a query within a React component, call `useGetMostRecentShiftsPublishTimestampQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMostRecentShiftsPublishTimestampQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMostRecentShiftsPublishTimestampQuery({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      adjustedDHRunId: // value for 'adjustedDHRunId'
 *   },
 * });
 */
export function useGetMostRecentShiftsPublishTimestampQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMostRecentShiftsPublishTimestampQuery,
    GetMostRecentShiftsPublishTimestampQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMostRecentShiftsPublishTimestampQuery,
    GetMostRecentShiftsPublishTimestampQueryVariables
  >(GetMostRecentShiftsPublishTimestampDocument, options);
}
export function useGetMostRecentShiftsPublishTimestampLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMostRecentShiftsPublishTimestampQuery,
    GetMostRecentShiftsPublishTimestampQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMostRecentShiftsPublishTimestampQuery,
    GetMostRecentShiftsPublishTimestampQueryVariables
  >(GetMostRecentShiftsPublishTimestampDocument, options);
}
export type GetMostRecentShiftsPublishTimestampQueryHookResult = ReturnType<
  typeof useGetMostRecentShiftsPublishTimestampQuery
>;
export type GetMostRecentShiftsPublishTimestampLazyQueryHookResult = ReturnType<
  typeof useGetMostRecentShiftsPublishTimestampLazyQuery
>;
export const GetMostRecentReportingBundleUploadTimestampDocument =
  /*#__PURE__*/ {
    kind: "Document",
    definitions: [
      {
        kind: "OperationDefinition",
        operation: "query",
        name: {
          kind: "Name",
          value: "GetMostRecentReportingBundleUploadTimestamp",
        },
        variableDefinitions: [
          {
            kind: "VariableDefinition",
            variable: {
              kind: "Variable",
              name: { kind: "Name", value: "operationalWeekStartDate" },
            },
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" },
              },
            },
          },
          {
            kind: "VariableDefinition",
            variable: {
              kind: "Variable",
              name: { kind: "Name", value: "adjustedDHRunId" },
            },
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "NonNegativeInt" },
              },
            },
          },
        ],
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "mostRecentShiftsReportingBundleUploadTimestamp",
              },
              arguments: [
                {
                  kind: "Argument",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                  value: {
                    kind: "Variable",
                    name: { kind: "Name", value: "operationalWeekStartDate" },
                  },
                },
                {
                  kind: "Argument",
                  name: { kind: "Name", value: "adjustedDHRunId" },
                  value: {
                    kind: "Variable",
                    name: { kind: "Name", value: "adjustedDHRunId" },
                  },
                },
              ],
            },
          ],
        },
      },
    ],
  } as unknown as DocumentNode;

/**
 * __useGetMostRecentReportingBundleUploadTimestampQuery__
 *
 * To run a query within a React component, call `useGetMostRecentReportingBundleUploadTimestampQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMostRecentReportingBundleUploadTimestampQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMostRecentReportingBundleUploadTimestampQuery({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      adjustedDHRunId: // value for 'adjustedDHRunId'
 *   },
 * });
 */
export function useGetMostRecentReportingBundleUploadTimestampQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMostRecentReportingBundleUploadTimestampQuery,
    GetMostRecentReportingBundleUploadTimestampQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMostRecentReportingBundleUploadTimestampQuery,
    GetMostRecentReportingBundleUploadTimestampQueryVariables
  >(GetMostRecentReportingBundleUploadTimestampDocument, options);
}
export function useGetMostRecentReportingBundleUploadTimestampLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMostRecentReportingBundleUploadTimestampQuery,
    GetMostRecentReportingBundleUploadTimestampQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMostRecentReportingBundleUploadTimestampQuery,
    GetMostRecentReportingBundleUploadTimestampQueryVariables
  >(GetMostRecentReportingBundleUploadTimestampDocument, options);
}
export type GetMostRecentReportingBundleUploadTimestampQueryHookResult =
  ReturnType<typeof useGetMostRecentReportingBundleUploadTimestampQuery>;
export type GetMostRecentReportingBundleUploadTimestampLazyQueryHookResult =
  ReturnType<typeof useGetMostRecentReportingBundleUploadTimestampLazyQuery>;
export const GetOdhLocationsDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetODHLocations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "batchId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "odhLocations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "batchId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "batchId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ovf" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "dates" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ovfs" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "values" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "driverHours" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hours" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "values" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetOdhLocationsQuery__
 *
 * To run a query within a React component, call `useGetOdhLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOdhLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOdhLocationsQuery({
 *   variables: {
 *      batchId: // value for 'batchId'
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *   },
 * });
 */
export function useGetOdhLocationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOdhLocationsQuery,
    GetOdhLocationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOdhLocationsQuery, GetOdhLocationsQueryVariables>(
    GetOdhLocationsDocument,
    options
  );
}
export function useGetOdhLocationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOdhLocationsQuery,
    GetOdhLocationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOdhLocationsQuery,
    GetOdhLocationsQueryVariables
  >(GetOdhLocationsDocument, options);
}
export type GetOdhLocationsQueryHookResult = ReturnType<
  typeof useGetOdhLocationsQuery
>;
export type GetOdhLocationsLazyQueryHookResult = ReturnType<
  typeof useGetOdhLocationsLazyQuery
>;
export const GetSasUrlForFileInDsBlobStorageDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSasUrlForFileInDSBlobStorage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filename" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getSasUrlForFileInDSBlobStorage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filename" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filename" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetSasUrlForFileInDsBlobStorageQuery__
 *
 * To run a query within a React component, call `useGetSasUrlForFileInDsBlobStorageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSasUrlForFileInDsBlobStorageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSasUrlForFileInDsBlobStorageQuery({
 *   variables: {
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGetSasUrlForFileInDsBlobStorageQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSasUrlForFileInDsBlobStorageQuery,
    GetSasUrlForFileInDsBlobStorageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSasUrlForFileInDsBlobStorageQuery,
    GetSasUrlForFileInDsBlobStorageQueryVariables
  >(GetSasUrlForFileInDsBlobStorageDocument, options);
}
export function useGetSasUrlForFileInDsBlobStorageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSasUrlForFileInDsBlobStorageQuery,
    GetSasUrlForFileInDsBlobStorageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSasUrlForFileInDsBlobStorageQuery,
    GetSasUrlForFileInDsBlobStorageQueryVariables
  >(GetSasUrlForFileInDsBlobStorageDocument, options);
}
export type GetSasUrlForFileInDsBlobStorageQueryHookResult = ReturnType<
  typeof useGetSasUrlForFileInDsBlobStorageQuery
>;
export type GetSasUrlForFileInDsBlobStorageLazyQueryHookResult = ReturnType<
  typeof useGetSasUrlForFileInDsBlobStorageLazyQuery
>;
export const GetShifterPipelineRunsIdDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetShifterPipelineRunsId" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "adjustedDHRunId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shifterPipelineRunsId" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "adjustedDHRunId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "adjustedDHRunId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetShifterPipelineRunsIdQuery__
 *
 * To run a query within a React component, call `useGetShifterPipelineRunsIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShifterPipelineRunsIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShifterPipelineRunsIdQuery({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      adjustedDHRunId: // value for 'adjustedDHRunId'
 *   },
 * });
 */
export function useGetShifterPipelineRunsIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetShifterPipelineRunsIdQuery,
    GetShifterPipelineRunsIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetShifterPipelineRunsIdQuery,
    GetShifterPipelineRunsIdQueryVariables
  >(GetShifterPipelineRunsIdDocument, options);
}
export function useGetShifterPipelineRunsIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetShifterPipelineRunsIdQuery,
    GetShifterPipelineRunsIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetShifterPipelineRunsIdQuery,
    GetShifterPipelineRunsIdQueryVariables
  >(GetShifterPipelineRunsIdDocument, options);
}
export type GetShifterPipelineRunsIdQueryHookResult = ReturnType<
  typeof useGetShifterPipelineRunsIdQuery
>;
export type GetShifterPipelineRunsIdLazyQueryHookResult = ReturnType<
  typeof useGetShifterPipelineRunsIdLazyQuery
>;
export const GetShifterStatusDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetShifterStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "adjustedDHRunId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shifterStatus" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "adjustedDHRunId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "adjustedDHRunId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "state" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "databricksRunId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetShifterStatusQuery__
 *
 * To run a query within a React component, call `useGetShifterStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShifterStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShifterStatusQuery({
 *   variables: {
 *      adjustedDHRunId: // value for 'adjustedDHRunId'
 *   },
 * });
 */
export function useGetShifterStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetShifterStatusQuery,
    GetShifterStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetShifterStatusQuery, GetShifterStatusQueryVariables>(
    GetShifterStatusDocument,
    options
  );
}
export function useGetShifterStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetShifterStatusQuery,
    GetShifterStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetShifterStatusQuery,
    GetShifterStatusQueryVariables
  >(GetShifterStatusDocument, options);
}
export type GetShifterStatusQueryHookResult = ReturnType<
  typeof useGetShifterStatusQuery
>;
export type GetShifterStatusLazyQueryHookResult = ReturnType<
  typeof useGetShifterStatusLazyQuery
>;
export const GetShiftsQaLocationsByMetroRegionsDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetShiftsQALocationsByMetroRegions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "countryCode" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "adjustedDHRunId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shiftsQALocationsByMetroRegions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "countryCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "countryCode" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "adjustedDHRunId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "adjustedDHRunId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "locationIds" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetShiftsQaLocationsByMetroRegionsQuery__
 *
 * To run a query within a React component, call `useGetShiftsQaLocationsByMetroRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShiftsQaLocationsByMetroRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShiftsQaLocationsByMetroRegionsQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      adjustedDHRunId: // value for 'adjustedDHRunId'
 *   },
 * });
 */
export function useGetShiftsQaLocationsByMetroRegionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetShiftsQaLocationsByMetroRegionsQuery,
    GetShiftsQaLocationsByMetroRegionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetShiftsQaLocationsByMetroRegionsQuery,
    GetShiftsQaLocationsByMetroRegionsQueryVariables
  >(GetShiftsQaLocationsByMetroRegionsDocument, options);
}
export function useGetShiftsQaLocationsByMetroRegionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetShiftsQaLocationsByMetroRegionsQuery,
    GetShiftsQaLocationsByMetroRegionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetShiftsQaLocationsByMetroRegionsQuery,
    GetShiftsQaLocationsByMetroRegionsQueryVariables
  >(GetShiftsQaLocationsByMetroRegionsDocument, options);
}
export type GetShiftsQaLocationsByMetroRegionsQueryHookResult = ReturnType<
  typeof useGetShiftsQaLocationsByMetroRegionsQuery
>;
export type GetShiftsQaLocationsByMetroRegionsLazyQueryHookResult = ReturnType<
  typeof useGetShiftsQaLocationsByMetroRegionsLazyQuery
>;
export const GetShiftsDailyQaDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetShiftsDailyQA" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locationIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "NonNegativeInt" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "flaggedOnly" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "adjustedDHRunId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shiftsDailyQA" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locationIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locationIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "flaggedOnly" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "flaggedOnly" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "adjustedDHRunId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "adjustedDHRunId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "metroRegion" } },
                { kind: "Field", name: { kind: "Name", value: "locationId" } },
                { kind: "Field", name: { kind: "Name", value: "mode" } },
                { kind: "Field", name: { kind: "Name", value: "date" } },
                { kind: "Field", name: { kind: "Name", value: "weekday" } },
                { kind: "Field", name: { kind: "Name", value: "ovf" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "odhTargetMin" },
                },
                { kind: "Field", name: { kind: "Name", value: "odhTarget" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "odhTargetMax" },
                },
                { kind: "Field", name: { kind: "Name", value: "odhPlan" } },
                { kind: "Field", name: { kind: "Name", value: "odhPlanVar" } },
                { kind: "Field", name: { kind: "Name", value: "odhSched" } },
                { kind: "Field", name: { kind: "Name", value: "odhSchedVar" } },
                { kind: "Field", name: { kind: "Name", value: "dhModeled" } },
                { kind: "Field", name: { kind: "Name", value: "dhAdjusted" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "appliedAbsenteeismAdjustmentPercentage",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "appliedAbsenteeismAdjustmentHours",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "appliedUnscheduledPercentage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "appliedUnscheduledHours" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "netAbsenteeismAdjustmentHours",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "dhNetOfAbsenteeismAdjustments",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minimumDpAdjustment" },
                },
                { kind: "Field", name: { kind: "Name", value: "dhPlanned" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "taperAdjustmentHours" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhPlannedTapered" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhPlannedTaperedPercentage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhAssignedInitial" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhUnassignedInitial" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhNetOfAssigned" },
                },
                { kind: "Field", name: { kind: "Name", value: "dhScheduled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhScheduledMustRequest" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhTotalExpected" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhTotalUpdated" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhTotalDelta" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhAssignedDelta" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhFailedUpload" },
                },
                { kind: "Field", name: { kind: "Name", value: "minHooStart" } },
                { kind: "Field", name: { kind: "Name", value: "maxHooEnd" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minShiftStart" },
                },
                { kind: "Field", name: { kind: "Name", value: "maxShiftEnd" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "startEndFlag" },
                },
                { kind: "Field", name: { kind: "Name", value: "dhVarFlag" } },
                { kind: "Field", name: { kind: "Name", value: "odhFlag" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetShiftsDailyQaQuery__
 *
 * To run a query within a React component, call `useGetShiftsDailyQaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShiftsDailyQaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShiftsDailyQaQuery({
 *   variables: {
 *      locationIds: // value for 'locationIds'
 *      flaggedOnly: // value for 'flaggedOnly'
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      adjustedDHRunId: // value for 'adjustedDHRunId'
 *   },
 * });
 */
export function useGetShiftsDailyQaQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetShiftsDailyQaQuery,
    GetShiftsDailyQaQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetShiftsDailyQaQuery, GetShiftsDailyQaQueryVariables>(
    GetShiftsDailyQaDocument,
    options
  );
}
export function useGetShiftsDailyQaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetShiftsDailyQaQuery,
    GetShiftsDailyQaQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetShiftsDailyQaQuery,
    GetShiftsDailyQaQueryVariables
  >(GetShiftsDailyQaDocument, options);
}
export type GetShiftsDailyQaQueryHookResult = ReturnType<
  typeof useGetShiftsDailyQaQuery
>;
export type GetShiftsDailyQaLazyQueryHookResult = ReturnType<
  typeof useGetShiftsDailyQaLazyQuery
>;
export const GetShiftsHourlyQaCsvUrlDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetShiftsHourlyQaCsvUrl" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "adjustedDHRunId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shiftsHourlyQaCsvUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "adjustedDHRunId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "adjustedDHRunId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetShiftsHourlyQaCsvUrlQuery__
 *
 * To run a query within a React component, call `useGetShiftsHourlyQaCsvUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShiftsHourlyQaCsvUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShiftsHourlyQaCsvUrlQuery({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      adjustedDHRunId: // value for 'adjustedDHRunId'
 *   },
 * });
 */
export function useGetShiftsHourlyQaCsvUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetShiftsHourlyQaCsvUrlQuery,
    GetShiftsHourlyQaCsvUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetShiftsHourlyQaCsvUrlQuery,
    GetShiftsHourlyQaCsvUrlQueryVariables
  >(GetShiftsHourlyQaCsvUrlDocument, options);
}
export function useGetShiftsHourlyQaCsvUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetShiftsHourlyQaCsvUrlQuery,
    GetShiftsHourlyQaCsvUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetShiftsHourlyQaCsvUrlQuery,
    GetShiftsHourlyQaCsvUrlQueryVariables
  >(GetShiftsHourlyQaCsvUrlDocument, options);
}
export type GetShiftsHourlyQaCsvUrlQueryHookResult = ReturnType<
  typeof useGetShiftsHourlyQaCsvUrlQuery
>;
export type GetShiftsHourlyQaCsvUrlLazyQueryHookResult = ReturnType<
  typeof useGetShiftsHourlyQaCsvUrlLazyQuery
>;
export const GetDhFailedUploadDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDHFailedUpload" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locationIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "NonNegativeInt" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "adjustedDHRunId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shifts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locationIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locationIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "adjustedDHRunId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "adjustedDHRunId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "submitStatuses" },
                value: {
                  kind: "ListValue",
                  values: [
                    { kind: "StringValue", value: "failed", block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "date" } },
                { kind: "Field", name: { kind: "Name", value: "locationId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "locationName" },
                },
                { kind: "Field", name: { kind: "Name", value: "weekday" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
                { kind: "Field", name: { kind: "Name", value: "endTime" } },
                { kind: "Field", name: { kind: "Name", value: "driverSlots" } },
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "position" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deliveryMode" },
                },
                { kind: "Field", name: { kind: "Name", value: "createdTime" } },
                { kind: "Field", name: { kind: "Name", value: "updatedTime" } },
                { kind: "Field", name: { kind: "Name", value: "mustRequest" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "submitStatus" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetDhFailedUploadQuery__
 *
 * To run a query within a React component, call `useGetDhFailedUploadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDhFailedUploadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDhFailedUploadQuery({
 *   variables: {
 *      locationIds: // value for 'locationIds'
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      adjustedDHRunId: // value for 'adjustedDHRunId'
 *   },
 * });
 */
export function useGetDhFailedUploadQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDhFailedUploadQuery,
    GetDhFailedUploadQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDhFailedUploadQuery,
    GetDhFailedUploadQueryVariables
  >(GetDhFailedUploadDocument, options);
}
export function useGetDhFailedUploadLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDhFailedUploadQuery,
    GetDhFailedUploadQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDhFailedUploadQuery,
    GetDhFailedUploadQueryVariables
  >(GetDhFailedUploadDocument, options);
}
export type GetDhFailedUploadQueryHookResult = ReturnType<
  typeof useGetDhFailedUploadQuery
>;
export type GetDhFailedUploadLazyQueryHookResult = ReturnType<
  typeof useGetDhFailedUploadLazyQuery
>;
export const GetShiftsWeeklyQaDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetShiftsWeeklyQA" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locationIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "NonNegativeInt" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "flaggedOnly" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "adjustedDHRunId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shiftsWeeklyQA" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locationIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locationIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "flaggedOnly" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "flaggedOnly" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "adjustedDHRunId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "adjustedDHRunId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "metroRegion" } },
                { kind: "Field", name: { kind: "Name", value: "locationId" } },
                { kind: "Field", name: { kind: "Name", value: "ovf" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "odhTargetMin" },
                },
                { kind: "Field", name: { kind: "Name", value: "odhTarget" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "odhTargetMax" },
                },
                { kind: "Field", name: { kind: "Name", value: "odhPlan" } },
                { kind: "Field", name: { kind: "Name", value: "odhPlanVar" } },
                { kind: "Field", name: { kind: "Name", value: "odhSched" } },
                { kind: "Field", name: { kind: "Name", value: "odhSchedVar" } },
                { kind: "Field", name: { kind: "Name", value: "dhModeled" } },
                { kind: "Field", name: { kind: "Name", value: "dhAdjusted" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "appliedAbsenteeismAdjustmentPercentage",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "appliedAbsenteeismAdjustmentHours",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "appliedUnscheduledPercentage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "appliedUnscheduledHours" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "netAbsenteeismAdjustmentHours",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "dhNetOfAbsenteeismAdjustments",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minimumDpAdjustment" },
                },
                { kind: "Field", name: { kind: "Name", value: "dhPlanned" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "taperAdjustmentHours" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhPlannedTapered" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhAssignedInitial" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhUnassignedInitial" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhNetOfAssigned" },
                },
                { kind: "Field", name: { kind: "Name", value: "dhScheduled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhScheduledMustRequest" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhTotalExpected" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhTotalUpdated" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhTotalDelta" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhAssignedDelta" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhFailedUpload" },
                },
                { kind: "Field", name: { kind: "Name", value: "flagged" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetShiftsWeeklyQaQuery__
 *
 * To run a query within a React component, call `useGetShiftsWeeklyQaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShiftsWeeklyQaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShiftsWeeklyQaQuery({
 *   variables: {
 *      locationIds: // value for 'locationIds'
 *      flaggedOnly: // value for 'flaggedOnly'
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      adjustedDHRunId: // value for 'adjustedDHRunId'
 *   },
 * });
 */
export function useGetShiftsWeeklyQaQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetShiftsWeeklyQaQuery,
    GetShiftsWeeklyQaQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetShiftsWeeklyQaQuery,
    GetShiftsWeeklyQaQueryVariables
  >(GetShiftsWeeklyQaDocument, options);
}
export function useGetShiftsWeeklyQaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetShiftsWeeklyQaQuery,
    GetShiftsWeeklyQaQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetShiftsWeeklyQaQuery,
    GetShiftsWeeklyQaQueryVariables
  >(GetShiftsWeeklyQaDocument, options);
}
export type GetShiftsWeeklyQaQueryHookResult = ReturnType<
  typeof useGetShiftsWeeklyQaQuery
>;
export type GetShiftsWeeklyQaLazyQueryHookResult = ReturnType<
  typeof useGetShiftsWeeklyQaLazyQuery
>;
export const PublishShifterPipelineDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PublishShifterPipeline" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "adjustedDHRunId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "publishShifterShifts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "adjustedDHRunId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "adjustedDHRunId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type PublishShifterPipelineMutationFn = Apollo.MutationFunction<
  PublishShifterPipelineMutation,
  PublishShifterPipelineMutationVariables
>;

/**
 * __usePublishShifterPipelineMutation__
 *
 * To run a mutation, you first call `usePublishShifterPipelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishShifterPipelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishShifterPipelineMutation, { data, loading, error }] = usePublishShifterPipelineMutation({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      adjustedDHRunId: // value for 'adjustedDHRunId'
 *   },
 * });
 */
export function usePublishShifterPipelineMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishShifterPipelineMutation,
    PublishShifterPipelineMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PublishShifterPipelineMutation,
    PublishShifterPipelineMutationVariables
  >(PublishShifterPipelineDocument, options);
}
export type PublishShifterPipelineMutationHookResult = ReturnType<
  typeof usePublishShifterPipelineMutation
>;
export const StartShifterPipelineDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "StartShifterPipeline" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "adjustedDHRunId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "startShifterPipeline" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "adjustedDHRunId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "adjustedDHRunId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type StartShifterPipelineMutationFn = Apollo.MutationFunction<
  StartShifterPipelineMutation,
  StartShifterPipelineMutationVariables
>;

/**
 * __useStartShifterPipelineMutation__
 *
 * To run a mutation, you first call `useStartShifterPipelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartShifterPipelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startShifterPipelineMutation, { data, loading, error }] = useStartShifterPipelineMutation({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      adjustedDHRunId: // value for 'adjustedDHRunId'
 *   },
 * });
 */
export function useStartShifterPipelineMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartShifterPipelineMutation,
    StartShifterPipelineMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StartShifterPipelineMutation,
    StartShifterPipelineMutationVariables
  >(StartShifterPipelineDocument, options);
}
export type StartShifterPipelineMutationHookResult = ReturnType<
  typeof useStartShifterPipelineMutation
>;
export const StartTransformDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "StartTransform" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "selectedWeek" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "startOdhTransform" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "selectedWeek" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "selectedWeek" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type StartTransformMutationFn = Apollo.MutationFunction<
  StartTransformMutation,
  StartTransformMutationVariables
>;

/**
 * __useStartTransformMutation__
 *
 * To run a mutation, you first call `useStartTransformMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTransformMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTransformMutation, { data, loading, error }] = useStartTransformMutation({
 *   variables: {
 *      selectedWeek: // value for 'selectedWeek'
 *   },
 * });
 */
export function useStartTransformMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartTransformMutation,
    StartTransformMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StartTransformMutation,
    StartTransformMutationVariables
  >(StartTransformDocument, options);
}
export type StartTransformMutationHookResult = ReturnType<
  typeof useStartTransformMutation
>;
export const GetShiftsDailyQaTotalDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetShiftsDailyQATotal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "countryCode" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "adjustedDHRunId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shiftsDailyQATotal" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "countryCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "countryCode" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "adjustedDHRunId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "adjustedDHRunId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "date" } },
                { kind: "Field", name: { kind: "Name", value: "weekday" } },
                { kind: "Field", name: { kind: "Name", value: "ovf" } },
                { kind: "Field", name: { kind: "Name", value: "dhModeled" } },
                { kind: "Field", name: { kind: "Name", value: "dhAdjusted" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "dhNetOfHoursOfOperationAdjustments",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "appliedAbsenteeismAdjustmentPercentage",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "predictedAbsenteeismAdjustmentHours",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "appliedAbsenteeismAdjustmentHours",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "appliedUnscheduledPercentage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "predictedUnscheduledHours" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "appliedUnscheduledHours" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "netAbsenteeismAdjustmentHours",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "dhNetOfAbsenteeismAdjustments",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minimumDpAdjustment" },
                },
                { kind: "Field", name: { kind: "Name", value: "dhPlanned" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "taperAdjustmentHours" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhPlannedTapered" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhAssignedInitial" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhUnassignedInitial" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhNetOfAssigned" },
                },
                { kind: "Field", name: { kind: "Name", value: "dhScheduled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhScheduledMustRequest" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhTotalExpected" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhTotalUpdated" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhTotalDelta" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhAssignedDelta" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhFailedUpload" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetShiftsDailyQaTotalQuery__
 *
 * To run a query within a React component, call `useGetShiftsDailyQaTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShiftsDailyQaTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShiftsDailyQaTotalQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      adjustedDHRunId: // value for 'adjustedDHRunId'
 *   },
 * });
 */
export function useGetShiftsDailyQaTotalQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetShiftsDailyQaTotalQuery,
    GetShiftsDailyQaTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetShiftsDailyQaTotalQuery,
    GetShiftsDailyQaTotalQueryVariables
  >(GetShiftsDailyQaTotalDocument, options);
}
export function useGetShiftsDailyQaTotalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetShiftsDailyQaTotalQuery,
    GetShiftsDailyQaTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetShiftsDailyQaTotalQuery,
    GetShiftsDailyQaTotalQueryVariables
  >(GetShiftsDailyQaTotalDocument, options);
}
export type GetShiftsDailyQaTotalQueryHookResult = ReturnType<
  typeof useGetShiftsDailyQaTotalQuery
>;
export type GetShiftsDailyQaTotalLazyQueryHookResult = ReturnType<
  typeof useGetShiftsDailyQaTotalLazyQuery
>;
export const GetShiftsWeeklyQaTotalDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetShiftsWeeklyQATotal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "countryCode" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "adjustedDHRunId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shiftsWeeklyQATotal" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "countryCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "countryCode" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "adjustedDHRunId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "adjustedDHRunId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ovf" } },
                { kind: "Field", name: { kind: "Name", value: "dhModeled" } },
                { kind: "Field", name: { kind: "Name", value: "dhAdjusted" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "dhNetOfHoursOfOperationAdjustments",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "appliedAbsenteeismAdjustmentPercentage",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "predictedAbsenteeismAdjustmentHours",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "appliedAbsenteeismAdjustmentHours",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "appliedUnscheduledPercentage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "predictedUnscheduledHours" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "appliedUnscheduledHours" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "netAbsenteeismAdjustmentHours",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "dhNetOfAbsenteeismAdjustments",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minimumDpAdjustment" },
                },
                { kind: "Field", name: { kind: "Name", value: "dhPlanned" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "taperAdjustmentHours" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhPlannedTapered" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhAssignedInitial" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhUnassignedInitial" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhNetOfAssigned" },
                },
                { kind: "Field", name: { kind: "Name", value: "dhScheduled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhScheduledMustRequest" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhTotalExpected" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhTotalUpdated" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhTotalDelta" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhAssignedDelta" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dhFailedUpload" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetShiftsWeeklyQaTotalQuery__
 *
 * To run a query within a React component, call `useGetShiftsWeeklyQaTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShiftsWeeklyQaTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShiftsWeeklyQaTotalQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      adjustedDHRunId: // value for 'adjustedDHRunId'
 *   },
 * });
 */
export function useGetShiftsWeeklyQaTotalQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetShiftsWeeklyQaTotalQuery,
    GetShiftsWeeklyQaTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetShiftsWeeklyQaTotalQuery,
    GetShiftsWeeklyQaTotalQueryVariables
  >(GetShiftsWeeklyQaTotalDocument, options);
}
export function useGetShiftsWeeklyQaTotalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetShiftsWeeklyQaTotalQuery,
    GetShiftsWeeklyQaTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetShiftsWeeklyQaTotalQuery,
    GetShiftsWeeklyQaTotalQueryVariables
  >(GetShiftsWeeklyQaTotalDocument, options);
}
export type GetShiftsWeeklyQaTotalQueryHookResult = ReturnType<
  typeof useGetShiftsWeeklyQaTotalQuery
>;
export type GetShiftsWeeklyQaTotalLazyQueryHookResult = ReturnType<
  typeof useGetShiftsWeeklyQaTotalLazyQuery
>;
export const UploadShiftsReportingBundleDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UploadShiftsReportingBundle" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "adjustedDHRunId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadShiftsReportingBundle" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "adjustedDHRunId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "adjustedDHRunId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UploadShiftsReportingBundleMutationFn = Apollo.MutationFunction<
  UploadShiftsReportingBundleMutation,
  UploadShiftsReportingBundleMutationVariables
>;

/**
 * __useUploadShiftsReportingBundleMutation__
 *
 * To run a mutation, you first call `useUploadShiftsReportingBundleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadShiftsReportingBundleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadShiftsReportingBundleMutation, { data, loading, error }] = useUploadShiftsReportingBundleMutation({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      adjustedDHRunId: // value for 'adjustedDHRunId'
 *   },
 * });
 */
export function useUploadShiftsReportingBundleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadShiftsReportingBundleMutation,
    UploadShiftsReportingBundleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadShiftsReportingBundleMutation,
    UploadShiftsReportingBundleMutationVariables
  >(UploadShiftsReportingBundleDocument, options);
}
export type UploadShiftsReportingBundleMutationHookResult = ReturnType<
  typeof useUploadShiftsReportingBundleMutation
>;
export const ValidateShifterPipelineDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ValidateShifterPipeline" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "adjustedDHRunId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "validateShifterShifts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "adjustedDHRunId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "adjustedDHRunId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ValidateShifterPipelineMutationFn = Apollo.MutationFunction<
  ValidateShifterPipelineMutation,
  ValidateShifterPipelineMutationVariables
>;

/**
 * __useValidateShifterPipelineMutation__
 *
 * To run a mutation, you first call `useValidateShifterPipelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateShifterPipelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateShifterPipelineMutation, { data, loading, error }] = useValidateShifterPipelineMutation({
 *   variables: {
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      adjustedDHRunId: // value for 'adjustedDHRunId'
 *   },
 * });
 */
export function useValidateShifterPipelineMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateShifterPipelineMutation,
    ValidateShifterPipelineMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidateShifterPipelineMutation,
    ValidateShifterPipelineMutationVariables
  >(ValidateShifterPipelineDocument, options);
}
export type ValidateShifterPipelineMutationHookResult = ReturnType<
  typeof useValidateShifterPipelineMutation
>;
export const GetRunsDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getRuns" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "runsListParams" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RunsListParams" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "environment" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getRunsList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "runsListParams" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "runsListParams" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "environment" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "environment" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "runs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "job_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "run_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number_in_job" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "original_attempt_run_id",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "state" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "life_cycle_state" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "result_state" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "state_message" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "user_cancelled_or_timedout",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "overriding_parameters" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "notebook_params" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "run_time" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "start_time" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "setup_duration" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "execution_duration" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cleanup_duration" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "end_time" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "trigger" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "creator_user_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "run_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "run_page_url" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "run_type" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "format" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRunsQuery__
 *
 * To run a query within a React component, call `useGetRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRunsQuery({
 *   variables: {
 *      runsListParams: // value for 'runsListParams'
 *      environment: // value for 'environment'
 *   },
 * });
 */
export function useGetRunsQuery(
  baseOptions: Apollo.QueryHookOptions<GetRunsQuery, GetRunsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRunsQuery, GetRunsQueryVariables>(
    GetRunsDocument,
    options
  );
}
export function useGetRunsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRunsQuery, GetRunsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRunsQuery, GetRunsQueryVariables>(
    GetRunsDocument,
    options
  );
}
export type GetRunsQueryHookResult = ReturnType<typeof useGetRunsQuery>;
export type GetRunsLazyQueryHookResult = ReturnType<typeof useGetRunsLazyQuery>;
export const UploadAdjustedOvfDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UploadAdjustedOvf" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "file" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Upload" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "selectedWeek" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "allowDatesOutsideSelectedWeek" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadOvfCsv" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "uploadOvfCsvInput" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "file" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "file" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "selectedWeek" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "selectedWeek" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "allowDatesOutsideSelectedWeek" },
                value: {
                  kind: "Variable",
                  name: {
                    kind: "Name",
                    value: "allowDatesOutsideSelectedWeek",
                  },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UploadAdjustedOvfMutationFn = Apollo.MutationFunction<
  UploadAdjustedOvfMutation,
  UploadAdjustedOvfMutationVariables
>;

/**
 * __useUploadAdjustedOvfMutation__
 *
 * To run a mutation, you first call `useUploadAdjustedOvfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAdjustedOvfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAdjustedOvfMutation, { data, loading, error }] = useUploadAdjustedOvfMutation({
 *   variables: {
 *      file: // value for 'file'
 *      selectedWeek: // value for 'selectedWeek'
 *      allowDatesOutsideSelectedWeek: // value for 'allowDatesOutsideSelectedWeek'
 *   },
 * });
 */
export function useUploadAdjustedOvfMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadAdjustedOvfMutation,
    UploadAdjustedOvfMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadAdjustedOvfMutation,
    UploadAdjustedOvfMutationVariables
  >(UploadAdjustedOvfDocument, options);
}
export type UploadAdjustedOvfMutationHookResult = ReturnType<
  typeof useUploadAdjustedOvfMutation
>;
export const GetWeeklyAdjustTableDataDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetWeeklyAdjustTableData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "forecasterId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          defaultValue: { kind: "StringValue", value: "all", block: false },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "weeklyAdjustLocations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "forecasterId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "forecasterId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "threeWeekOrderHistory" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dopplerForecast" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "seasonalityAdjustments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "weeklyLayer" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "weeklyOverride" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dailyLayer" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hourlyLayer" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "eventAdjustmentTotals" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetWeeklyAdjustTableDataQuery__
 *
 * To run a query within a React component, call `useGetWeeklyAdjustTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWeeklyAdjustTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWeeklyAdjustTableDataQuery({
 *   variables: {
 *      forecasterId: // value for 'forecasterId'
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *   },
 * });
 */
export function useGetWeeklyAdjustTableDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWeeklyAdjustTableDataQuery,
    GetWeeklyAdjustTableDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWeeklyAdjustTableDataQuery,
    GetWeeklyAdjustTableDataQueryVariables
  >(GetWeeklyAdjustTableDataDocument, options);
}
export function useGetWeeklyAdjustTableDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWeeklyAdjustTableDataQuery,
    GetWeeklyAdjustTableDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWeeklyAdjustTableDataQuery,
    GetWeeklyAdjustTableDataQueryVariables
  >(GetWeeklyAdjustTableDataDocument, options);
}
export type GetWeeklyAdjustTableDataQueryHookResult = ReturnType<
  typeof useGetWeeklyAdjustTableDataQuery
>;
export type GetWeeklyAdjustTableDataLazyQueryHookResult = ReturnType<
  typeof useGetWeeklyAdjustTableDataLazyQuery
>;
export const UpsertWeeklyAdjustmentDocument = /*#__PURE__*/ {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpsertWeeklyAdjustment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locationId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NonNegativeInt" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "forecasterId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "NonNegativeInt" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "adjustmentType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "operationalWeekStartDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateString" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "value" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "upsertSeasonalAdjustment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "forecasterId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "forecasterId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "adjustmentType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "adjustmentType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "operationalWeekStartDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "operationalWeekStartDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dateString" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dateString" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "value" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "value" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "dates" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dopplerForecast" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "weeklyOverride" },
                },
                { kind: "Field", name: { kind: "Name", value: "weeklyLayer" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dailyOverrides" },
                },
                { kind: "Field", name: { kind: "Name", value: "dailyLayer" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hourlyOverrides" },
                },
                { kind: "Field", name: { kind: "Name", value: "hourlyLayer" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "totalSeasonalityAdjustedForecastDistribution",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "dailySeasonalityAdjustedForecastDistribution",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpsertWeeklyAdjustmentMutationFn = Apollo.MutationFunction<
  UpsertWeeklyAdjustmentMutation,
  UpsertWeeklyAdjustmentMutationVariables
>;

/**
 * __useUpsertWeeklyAdjustmentMutation__
 *
 * To run a mutation, you first call `useUpsertWeeklyAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertWeeklyAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertWeeklyAdjustmentMutation, { data, loading, error }] = useUpsertWeeklyAdjustmentMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      forecasterId: // value for 'forecasterId'
 *      adjustmentType: // value for 'adjustmentType'
 *      operationalWeekStartDate: // value for 'operationalWeekStartDate'
 *      dateString: // value for 'dateString'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpsertWeeklyAdjustmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertWeeklyAdjustmentMutation,
    UpsertWeeklyAdjustmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertWeeklyAdjustmentMutation,
    UpsertWeeklyAdjustmentMutationVariables
  >(UpsertWeeklyAdjustmentDocument, options);
}
export type UpsertWeeklyAdjustmentMutationHookResult = ReturnType<
  typeof useUpsertWeeklyAdjustmentMutation
>;
